/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Edison API
 * R&D Tax Incentive Evidence Platform
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import { customInstance } from '../axios-instance';
export type ErrorError = {
  code: string;
  message: string;
  requestId?: string;
};

export interface Error {
  error: ErrorError;
}

export type HealthResponseDataStatus = typeof HealthResponseDataStatus[keyof typeof HealthResponseDataStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const HealthResponseDataStatus = {
  ok: 'ok',
  degraded: 'degraded',
} as const;

export type HealthResponseData = {
  status: HealthResponseDataStatus;
  db?: string;
  timestamp: string;
};

export interface HealthResponse {
  data: HealthResponseData;
}

export interface Pagination {
  page: number;
  limit: number;
  total: number;
  totalPages: number;
}

export type WorkBucketAiColumn = typeof WorkBucketAiColumn[keyof typeof WorkBucketAiColumn];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const WorkBucketAiColumn = {
  rd: 'rd',
  non_rd: 'non_rd',
} as const;

export type WorkBucketColumn = typeof WorkBucketColumn[keyof typeof WorkBucketColumn];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const WorkBucketColumn = {
  rd: 'rd',
  non_rd: 'non_rd',
} as const;

export interface WorkBucket {
  id: string;
  timeEntryId: string;
  /** @nullable */
  activityId?: string | null;
  label: string;
  tfaMatch: boolean;
  /** @nullable */
  tfaAspect?: string | null;
  rationale: string;
  aiColumn: WorkBucketAiColumn;
  column: WorkBucketColumn;
  /** @nullable */
  overrideReason?: string | null;
  /** @nullable */
  reviewedBy?: string | null;
  /** @nullable */
  reviewedAt?: string | null;
  weight: string;
  linesChanged: number;
  filesChanged: number;
  commitCount: number;
  weightAlgorithmVersion: string;
  tfaVersionHash?: string;
  commitRefs: string[];
  createdAt: string;
}

export type GithubContributorEmploymentType = typeof GithubContributorEmploymentType[keyof typeof GithubContributorEmploymentType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GithubContributorEmploymentType = {
  employee: 'employee',
  contractor: 'contractor',
  unknown: 'unknown',
} as const;

export interface GithubContributor {
  id: string;
  tenantId: string;
  /** @nullable */
  githubUsername?: string | null;
  email: string;
  /** @nullable */
  name?: string | null;
  /** @nullable */
  userId?: string | null;
  employmentType: GithubContributorEmploymentType;
  /** @nullable */
  verifiedBy?: string | null;
  /** @nullable */
  verifiedAt?: string | null;
  createdAt: string;
}

export interface UserRate {
  id: string;
  tenantId: string;
  userId: string;
  /** numeric as string (Drizzle) */
  hourlyRate: string;
  effectiveFrom: string;
  createdBy: string;
  createdAt: string;
}

export type CostAllocationCategory = typeof CostAllocationCategory[keyof typeof CostAllocationCategory];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CostAllocationCategory = {
  cloud: 'cloud',
  llm_tokens: 'llm_tokens',
  software_license: 'software_license',
  hardware: 'hardware',
  other: 'other',
  admin_overhead: 'admin_overhead',
  software_subscription: 'software_subscription',
  insurance: 'insurance',
  consultant_fees: 'consultant_fees',
  company_setup: 'company_setup',
  rdti_claim_prep: 'rdti_claim_prep',
} as const;

export type CostAllocationSource = typeof CostAllocationSource[keyof typeof CostAllocationSource];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CostAllocationSource = {
  api_aws: 'api_aws',
  api_gcp: 'api_gcp',
  api_openai: 'api_openai',
  api_anthropic: 'api_anthropic',
  api_replit: 'api_replit',
  api_xero: 'api_xero',
  manual: 'manual',
} as const;

/**
 * @nullable
 */
export type CostAllocationMatchConfidence = typeof CostAllocationMatchConfidence[keyof typeof CostAllocationMatchConfidence] | null;


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CostAllocationMatchConfidence = {
  exact: 'exact',
  fuzzy: 'fuzzy',
  manual: 'manual',
  override: 'override',
} as const;

/**
 * Claim contribution = amount × claimablePercent/100 when claimable; excluded/needs_review contribute zero to every claim surface
 */
export type CostAllocationEligibilityStatus = typeof CostAllocationEligibilityStatus[keyof typeof CostAllocationEligibilityStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CostAllocationEligibilityStatus = {
  claimable: 'claimable',
  excluded: 'excluded',
  needs_review: 'needs_review',
} as const;

/**
 * @nullable
 */
export type CostAllocationApportionmentBasis = typeof CostAllocationApportionmentBasis[keyof typeof CostAllocationApportionmentBasis] | null;


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CostAllocationApportionmentBasis = {
  manual: 'manual',
  labour_pct: 'labour_pct',
  custom: 'custom',
  full: 'full',
} as const;

export interface CostAllocation {
  id: string;
  tenantId: string;
  /** @nullable */
  claimId?: string | null;
  /** @nullable */
  projectId?: string | null;
  category: CostAllocationCategory;
  /** numeric as string (Drizzle) */
  amount: string;
  /**
   * numeric as string (Drizzle) — provider-reported amount before FX
   * @nullable
   */
  originalAmount?: string | null;
  /** @nullable */
  currency?: string | null;
  /**
   * numeric as string (Drizzle) — USD→AUD (or X→AUD) rate applied
   * @nullable
   */
  fxRate?: string | null;
  periodStart: string;
  periodEnd: string;
  source: CostAllocationSource;
  /** @nullable */
  sourceRef?: string | null;
  /** @nullable */
  matchConfidence?: CostAllocationMatchConfidence;
  /** @nullable */
  vendor?: string | null;
  /** @nullable */
  description?: string | null;
  /** @nullable */
  notes?: string | null;
  /** Claim contribution = amount × claimablePercent/100 when claimable; excluded/needs_review contribute zero to every claim surface */
  eligibilityStatus: CostAllocationEligibilityStatus;
  /** numeric as string (Drizzle) */
  claimablePercent: string;
  /** @nullable */
  eligibilityReason?: string | null;
  /** @nullable */
  apportionmentBasis?: CostAllocationApportionmentBasis;
  createdBy: string;
  createdAt: string;
}

export type ExpenditureSummaryByProvider = {[key: string]: {
  totalAud?: number;
  /** @nullable */
  lastSyncedAt?: string | null;
}};

export type ExpenditureSummaryByCategory = {[key: string]: number};

export type ExpenditureSummaryMonthlyByProviderItem = {
  /** YYYY-MM */
  month: string;
  api_aws?: number;
  api_gcp?: number;
  api_openai?: number;
  api_anthropic?: number;
  api_replit?: number;
  manual?: number;
};

export type ExpenditureSummaryMonthlyByCategoryItem = {
  month: string;
  cloud?: number;
  llm_tokens?: number;
  software_license?: number;
  hardware?: number;
  other?: number;
};

export type ExpenditureSummaryByProjectItem = {
  /** @nullable */
  projectId: string | null;
  projectName: string;
  totalAud: number;
  cloud: number;
  llm_tokens: number;
  software_license: number;
  hardware: number;
  other: number;
};

export interface ExpenditureSummary {
  /** raw captured spend (CAPTURE surface — un-apportioned) */
  totalAud: number;
  /** Σ claimableAmount — the eligibility-apportioned CLAIM figure (THE claim formula, see services/cost-eligibility.ts) */
  totalClaimable: number;
  /** count of allocations where projectId IS NULL */
  unattributedCount: number;
  /** providers with credentials stored in integration_configs */
  configuredProviders: string[];
  byProvider: ExpenditureSummaryByProvider;
  byCategory: ExpenditureSummaryByCategory;
  monthlyByProvider: ExpenditureSummaryMonthlyByProviderItem[];
  monthlyByCategory: ExpenditureSummaryMonthlyByCategoryItem[];
  byProject: ExpenditureSummaryByProjectItem[];
}

export interface ExpenditureAccount {
  /** aws | gcp */
  provider: string;
  /** AWS account ID or GCP project ID */
  externalId: string;
  /** Human-readable account/project name */
  label: string;
  /** @nullable */
  overrideId?: string | null;
  /** @nullable */
  mappedProjectId?: string | null;
}

export type ProjectCostOverrideProvider = typeof ProjectCostOverrideProvider[keyof typeof ProjectCostOverrideProvider];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ProjectCostOverrideProvider = {
  aws: 'aws',
  gcp: 'gcp',
  openai: 'openai',
} as const;

export interface ProjectCostOverride {
  id: string;
  tenantId: string;
  projectId: string;
  provider: ProjectCostOverrideProvider;
  externalId: string;
  createdBy: string;
  createdAt: string;
}

export type XeroCostCandidateSuggestedCategory = typeof XeroCostCandidateSuggestedCategory[keyof typeof XeroCostCandidateSuggestedCategory];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const XeroCostCandidateSuggestedCategory = {
  cloud: 'cloud',
  llm_tokens: 'llm_tokens',
  software_license: 'software_license',
  hardware: 'hardware',
  other: 'other',
  admin_overhead: 'admin_overhead',
  software_subscription: 'software_subscription',
  insurance: 'insurance',
  consultant_fees: 'consultant_fees',
  company_setup: 'company_setup',
  rdti_claim_prep: 'rdti_claim_prep',
} as const;

export type XeroCostCandidateStatus = typeof XeroCostCandidateStatus[keyof typeof XeroCostCandidateStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const XeroCostCandidateStatus = {
  pending: 'pending',
  approved: 'approved',
  dismissed: 'dismissed',
} as const;

export interface XeroCostCandidate {
  id: string;
  tenantId: string;
  accountName: string;
  /** YYYY-MM */
  period: string;
  /** numeric as string (Drizzle) — AUD from the Xero snapshot */
  amount: string;
  suggestedCategory: XeroCostCandidateSuggestedCategory;
  status: XeroCostCandidateStatus;
  /**
   * set when an API-synced vendor's costs overlap this candidate's period
   * @nullable
   */
  duplicateVendor?: string | null;
  /** @nullable */
  costAllocationId?: string | null;
  /** @nullable */
  reviewedBy?: string | null;
  /** @nullable */
  reviewedAt?: string | null;
  /** @nullable */
  dismissReason?: string | null;
  createdAt: string;
}

export type ApportionmentViewMode = typeof ApportionmentViewMode[keyof typeof ApportionmentViewMode];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ApportionmentViewMode = {
  manual: 'manual',
  computed: 'computed',
  custom: 'custom',
} as const;

export type ApportionmentViewComputed = {
  /**
   * rdVsPayroll × 100, rounded; null when the reconciliation ratio cannot be computed
   * @nullable
   */
  percent: number | null;
  rdLabour: number;
  payrollTotal: number;
  incomeYear: string;
  claimMode: string;
  monthsCovered: number;
};

export interface ApportionmentView {
  mode: ApportionmentViewMode;
  /** @nullable */
  customPercent: number | null;
  /** @nullable */
  customReason: string | null;
  /**
   * what approval pre-fills; null = no pre-fill (Rule Zero — never a fabricated percent)
   * @nullable
   */
  effectiveDefaultPercent: number | null;
  computed: ApportionmentViewComputed;
}

export type SdlcCoverageResultCategoriesItemKey = typeof SdlcCoverageResultCategoriesItemKey[keyof typeof SdlcCoverageResultCategoriesItemKey];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SdlcCoverageResultCategoriesItemKey = {
  preliminary_investigation: 'preliminary_investigation',
  specifications_requirements: 'specifications_requirements',
  development_coding: 'development_coding',
  ui_gui: 'ui_gui',
  testing: 'testing',
  technical_improvement: 'technical_improvement',
  project_support: 'project_support',
} as const;

export type SdlcCoverageResultCategoriesItem = {
  key: SdlcCoverageResultCategoriesItemKey;
  label: string;
  /** Weighted share of RAW recorded duration (indicative, not a claim figure) */
  hours: number;
  /** Up to 3 distinct example work-bucket labels that landed in this category */
  exampleLabels: string[];
};

export interface SdlcCoverageResult {
  /** Always all seven SDLC categories, in canonical order, even at 0 h */
  categories: SdlcCoverageResultCategoriesItem[];
  /** Hours whose bucket did not resolve to any category */
  unmappedHours: number;
  /** Sum of category hours + unmappedHours */
  totalHours: number;
}

export type GrantStatus = typeof GrantStatus[keyof typeof GrantStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GrantStatus = {
  open: 'open',
  closed: 'closed',
  forecast: 'forecast',
  archived: 'archived',
} as const;

export interface Grant {
  id: string;
  source: string;
  /** @nullable */
  state?: string | null;
  sourceId: string;
  name: string;
  funder: string;
  status: GrantStatus;
  /** @nullable */
  openDate?: string | null;
  /** @nullable */
  closeDate?: string | null;
  /**
   * numeric as string
   * @nullable
   */
  fundingMin?: string | null;
  /**
   * numeric as string
   * @nullable
   */
  fundingMax?: string | null;
  /** @nullable */
  eligibility?: string | null;
  /** @nullable */
  evidenceRequired?: string | null;
  /** @nullable */
  description?: string | null;
  /** @nullable */
  applicationUrl?: string | null;
  /** @nullable */
  industry?: string | null;
  tags?: string[];
  aiExtracted: boolean;
  lastSyncedAt: string;
  createdAt: string;
  updatedAt: string;
}

export interface OrgProfile {
  id: string;
  tenantId: string;
  legalName: string;
  abn: string;
  /** @nullable */
  address?: string | null;
  /** @nullable */
  industry?: string | null;
  /** @nullable */
  companySize?: string | null;
  /** @nullable */
  annualTurnover?: string | null;
  /** @nullable */
  description?: string | null;
  updatedAt: string;
}

export interface GrantConfig {
  id: string;
  tenantId: string;
  extractionPrompt?: string;
  matchingPrompt?: string;
  watchedGrantUuids?: string[];
  watchedBusinessSlugs?: string[];
  syncEnabled: boolean;
  updatedAt?: string;
}

export type GrantApplicationAidAnswersItem = {
  criterion: string;
  answer: string;
  sourceData?: string[];
};

export interface GrantApplicationAid {
  id: string;
  tenantId: string;
  grantId: string;
  answers: GrantApplicationAidAnswersItem[];
  generatedAt: string;
  /** @nullable */
  orgProfileVersion?: string | null;
  createdBy?: string;
}

export type IntegrationConfigSummaryProvider = typeof IntegrationConfigSummaryProvider[keyof typeof IntegrationConfigSummaryProvider];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const IntegrationConfigSummaryProvider = {
  anthropic: 'anthropic',
  aws: 'aws',
  gcp: 'gcp',
  openai: 'openai',
  replit: 'replit',
} as const;

export interface IntegrationConfigSummary {
  id: string;
  provider: IntegrationConfigSummaryProvider;
  configKey: string;
  updatedAt: string;
}

export type SuggestedActivityStatus = typeof SuggestedActivityStatus[keyof typeof SuggestedActivityStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SuggestedActivityStatus = {
  suggested: 'suggested',
  dismissed: 'dismissed',
} as const;

export interface SuggestedActivity {
  id: string;
  projectId: string;
  tenantId?: string;
  theme: string;
  /** @nullable */
  tfaAspect?: string | null;
  sessionCount: number;
  firstSeen: string;
  lastSeen: string;
  exampleBuckets?: string[];
  status: SuggestedActivityStatus;
  createdAt?: string;
}

export interface Artefact {
  id: string;
  tenantId: string;
  type: string;
  title?: string;
  /** @nullable */
  projectId?: string | null;
  /** @nullable */
  activityId?: string | null;
  createdBy?: string;
  createdAt: string;
  updatedAt?: string;
}

export type InitiativeStatus = typeof InitiativeStatus[keyof typeof InitiativeStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InitiativeStatus = {
  active: 'active',
  completed: 'completed',
  cancelled: 'cancelled',
} as const;

export interface Initiative {
  id: string;
  tenantId: string;
  name: string;
  /** @nullable */
  description?: string | null;
  status: InitiativeStatus;
  /** @nullable */
  projectCount?: number | null;
  createdAt: string;
  updatedAt: string;
}

export type ProjectStatus = typeof ProjectStatus[keyof typeof ProjectStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ProjectStatus = {
  active: 'active',
  archived: 'archived',
  no_rd: 'no_rd',
  completed: 'completed',
  cancelled: 'cancelled',
} as const;

export type ProjectRdAttributionMode = typeof ProjectRdAttributionMode[keyof typeof ProjectRdAttributionMode];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ProjectRdAttributionMode = {
  granular: 'granular',
  project_level: 'project_level',
} as const;

export interface Project {
  id: string;
  tenantId: string;
  name: string;
  /** @nullable */
  description?: string | null;
  /** @nullable */
  incomeYear?: string | null;
  startDate: string;
  /** @nullable */
  endDate?: string | null;
  status: ProjectStatus;
  /** @nullable */
  closureReason?: string | null;
  /** @nullable */
  closedAt?: string | null;
  /** @nullable */
  initiativeId?: string | null;
  createdAt: string;
  /** @nullable */
  tfaLocked?: boolean | null;
  /** @nullable */
  tfaStage?: string | null;
  /** @nullable */
  repoCount?: number | null;
  /** @nullable */
  totalHours?: number | null;
  /** @nullable */
  rdHours?: number | null;
  /** @nullable */
  pendingCount?: number | null;
  /** @nullable */
  lastClassifiedAt?: string | null;
  /** @nullable */
  lastBackfilledAt?: string | null;
  /** @nullable */
  createdBy?: string | null;
  rdAttributionMode?: ProjectRdAttributionMode;
  /** @nullable */
  productGroup?: string | null;
  /**
   * Comma-separated alternative names / codenames (e.g. "Crystal Ball, CB")
   * @nullable
   */
  aliases?: string | null;
}

export type TranscriptSplitAttendeesItem = {
  name: string;
  /** @nullable */
  email?: string | null;
  /**
   * Matched Edison user ID
   * @nullable
   */
  userId?: string | null;
  /**
   * Matched Edison user display name
   * @nullable
   */
  userName?: string | null;
};

export interface TranscriptSplit {
  projectId: string;
  projectName: string;
  /** @nullable */
  activityId?: string | null;
  /** @nullable */
  activityName?: string | null;
  /**
   * AI-suggested name for a new activity when no existing activity matches
   * @nullable
   */
  suggestedActivityName?: string | null;
  title: string;
  /** Raw verbatim transcript slice for this project */
  excerpt: string;
  /**
   * HH:MM:SS timestamp where this segment begins
   * @nullable
   */
  timeStart?: string | null;
  /**
   * HH:MM:SS timestamp where this segment ends
   * @nullable
   */
  timeEnd?: string | null;
  /**
   * People identified as speaking or participating in this segment
   * @nullable
   */
  attendees?: TranscriptSplitAttendeesItem[] | null;
}

export interface CompetenceRecord {
  id: string;
  activityId: string;
  assessorUserId: string;
  /** @nullable */
  qualifications?: string | null;
  /** @nullable */
  relevantExpertise?: string | null;
  /** @nullable */
  priorWorkSummary?: string | null;
  roleOnActivity: string;
  uncertaintyBasis: string;
  /** @nullable */
  confirmedAt?: string | null;
  createdAt: string;
}

export interface Activity {
  id: string;
  projectId: string;
  tenantId: string;
  name: string;
  /** @nullable */
  description?: string | null;
  ipOwnership: string;
  status: string;
  createdAt: string;
}

export type ActivityDetailAllOf = {
  competenceRecords?: CompetenceRecord[];
};

export type ActivityDetail = Activity & ActivityDetailAllOf;

export interface TfaPanelist {
  id: string;
  panelId: string;
  userId: string;
  /** @nullable */
  name?: string | null;
  /** @nullable */
  email?: string | null;
  /** @nullable */
  confirmedAt: string | null;
  isFinalApprover: boolean;
  /** @nullable */
  profileComplete?: boolean | null;
}

export type TfaDeliberationQuestionQuestionKey = typeof TfaDeliberationQuestionQuestionKey[keyof typeof TfaDeliberationQuestionQuestionKey];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TfaDeliberationQuestionQuestionKey = {
  systematic_investigation: 'systematic_investigation',
  technical_uncertainty: 'technical_uncertainty',
  new_knowledge: 'new_knowledge',
  innovative: 'innovative',
  project_specific_uncertainty: 'project_specific_uncertainty',
} as const;

export interface TfaDeliberationQuestion {
  questionKey: TfaDeliberationQuestionQuestionKey;
  answer: boolean;
  /** @nullable */
  comment?: string | null;
}

export interface TfaDeliberationResponse {
  id: string;
  panelId: string;
  panelistId: string;
  /** @nullable */
  panelistName?: string | null;
  responses: TfaDeliberationQuestion[];
  /** @nullable */
  overallComment?: string | null;
  /** @nullable */
  submittedAt?: string | null;
  /** @nullable */
  updatedAt?: string | null;
  createdAt: string;
}

export type TfaDeterminationOutcome = typeof TfaDeterminationOutcome[keyof typeof TfaDeterminationOutcome];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TfaDeterminationOutcome = {
  eligible: 'eligible',
  ineligible: 'ineligible',
  certain: 'certain',
  uncertain: 'uncertain',
} as const;

export type TfaDeterminationDetermination = typeof TfaDeterminationDetermination[keyof typeof TfaDeterminationDetermination];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TfaDeterminationDetermination = {
  eligible: 'eligible',
  ineligible: 'ineligible',
  certain: 'certain',
  uncertain: 'uncertain',
  partially_uncertain: 'partially_uncertain',
} as const;

export interface TfaDetermination {
  id: string;
  panelId: string;
  outcome: TfaDeterminationOutcome;
  determination?: TfaDeterminationDetermination;
  /** @nullable */
  rationale?: string | null;
  /** @nullable */
  notes?: string | null;
  /** @nullable */
  problemStatement?: string | null;
  /** @nullable */
  cotsConclusion?: string | null;
  createdAt: string;
}

export type TfaPanelFullStage = typeof TfaPanelFullStage[keyof typeof TfaPanelFullStage];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TfaPanelFullStage = {
  setup: 'setup',
  problem_definition: 'problem_definition',
  cots_sweep: 'cots_sweep',
  panel_selection: 'panel_selection',
  panel_deliberation: 'panel_deliberation',
  determination: 'determination',
} as const;

export type TfaPanelFullAiDraftCotsSweepItemsItem = {
  name: string;
  whyConsidered: string;
  whyRejected: string;
};

/**
 * @nullable
 */
export type TfaPanelFullAiDraftStatus = typeof TfaPanelFullAiDraftStatus[keyof typeof TfaPanelFullAiDraftStatus] | null;


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TfaPanelFullAiDraftStatus = {
  pending: 'pending',
  complete: 'complete',
  failed: 'failed',
  skipped: 'skipped',
} as const;

export interface TfaPanelFull {
  id: string;
  projectId: string;
  stage: TfaPanelFullStage;
  locked: boolean;
  retrospective: boolean;
  /** @nullable */
  lockedAt?: string | null;
  /**
   * Name of user who locked the TFA
   * @nullable
   */
  lockedBy?: string | null;
  /** @nullable */
  evidencePeriodStart?: string | null;
  /** @nullable */
  evidencePeriodEnd?: string | null;
  /** @nullable */
  assessmentDate?: string | null;
  /** @nullable */
  problemStatement?: string | null;
  /** @nullable */
  cotsConclusion?: string | null;
  /** @nullable */
  cotsSweepNotes?: string | null;
  /** @nullable */
  aiDraftProblemStatement?: string | null;
  /** @nullable */
  aiDraftCotsSweepNotes?: string | null;
  /** @nullable */
  aiDraftCotsSweepItems?: TfaPanelFullAiDraftCotsSweepItemsItem[] | null;
  /** @nullable */
  aiDraftStatus?: TfaPanelFullAiDraftStatus;
  /** @nullable */
  aiDraftGeneratedAt?: string | null;
  /** @nullable */
  aiDeterminationSynthesis?: string | null;
  /** @nullable */
  allDeliberationsSubmitted?: boolean | null;
  /** @nullable */
  myDeliberation?: TfaDeliberationResponse;
  createdAt: string;
  panelists: TfaPanelist[];
  /** @nullable */
  determination?: TfaDetermination;
}

export interface Signal {
  id: string;
  /** @nullable */
  tenantId?: string | null;
  repoOwner: string;
  repoName: string;
  /** @nullable */
  lastSyncedAt?: string | null;
  /** @nullable */
  createdAt?: string | null;
  /** @nullable */
  projectName?: string | null;
  /** @nullable */
  lastCommitAt?: string | null;
  /** @nullable */
  lastCommitBy?: string | null;
  artefactCount?: number;
  hasPrd?: boolean;
}

export type ClaimStatus = typeof ClaimStatus[keyof typeof ClaimStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ClaimStatus = {
  draft: 'draft',
  validating: 'validating',
  locked: 'locked',
} as const;

export interface Claim {
  id: string;
  tenantId: string;
  name: string;
  incomeYear: string;
  status: ClaimStatus;
  /** @nullable */
  lockedAt?: string | null;
  createdAt: string;
}

export interface ValidationFailure {
  code: string;
  message: string;
  /** @nullable */
  field?: string | null;
}

export type AccessTokenRole = typeof AccessTokenRole[keyof typeof AccessTokenRole];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AccessTokenRole = {
  auditor: 'auditor',
  advisor: 'advisor',
  due_diligence: 'due_diligence',
} as const;

export interface AccessToken {
  id: string;
  tenantId: string;
  claimId: string;
  role: AccessTokenRole;
  /** @nullable */
  label?: string | null;
  expiresAt: string;
  /** @nullable */
  revokedAt?: string | null;
  createdAt: string;
  /**
   * Raw token — returned once on create only
   * @nullable
   */
  token?: string | null;
}

export type ClaimAccessGrantRole = typeof ClaimAccessGrantRole[keyof typeof ClaimAccessGrantRole];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ClaimAccessGrantRole = {
  auditor: 'auditor',
  advisor: 'advisor',
  due_diligence: 'due_diligence',
} as const;

export type ClaimAccessGrantStatus = typeof ClaimAccessGrantStatus[keyof typeof ClaimAccessGrantStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ClaimAccessGrantStatus = {
  active: 'active',
  expired: 'expired',
  revoked: 'revoked',
} as const;

export interface ClaimAccessGrant {
  id: string;
  tenantId: string;
  claimId: string;
  /** The external_reviewer user row bound to this grant */
  userId: string;
  /**
   * Reviewer's email (joined from the user row)
   * @nullable
   */
  email?: string | null;
  role: ClaimAccessGrantRole;
  grantedBy: string;
  expiresAt: string;
  /** @nullable */
  revokedAt?: string | null;
  status: ClaimAccessGrantStatus;
  createdAt: string;
  /**
   * Present only on create — whether the Clerk invitation email was sent
   * @nullable
   */
  clerkInviteSent?: boolean | null;
  /**
   * Present only on create — Clerk error message if the invite failed to send
   * @nullable
   */
  clerkInviteError?: string | null;
}

export type ReviewerClaimGrantRole = typeof ReviewerClaimGrantRole[keyof typeof ReviewerClaimGrantRole];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ReviewerClaimGrantRole = {
  auditor: 'auditor',
  advisor: 'advisor',
  due_diligence: 'due_diligence',
} as const;

export interface ReviewerClaimGrant {
  claimId: string;
  /** @nullable */
  claimName: string | null;
  /** @nullable */
  incomeYear: string | null;
  role: ReviewerClaimGrantRole;
  expiresAt: string;
}

export type EligibilitySnapshotStatus = typeof EligibilitySnapshotStatus[keyof typeof EligibilitySnapshotStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EligibilitySnapshotStatus = {
  intact: 'intact',
  weakening: 'weakening',
  at_risk: 'at_risk',
} as const;

/**
 * @nullable
 */
export type EligibilitySnapshotPreviousStatus = typeof EligibilitySnapshotPreviousStatus[keyof typeof EligibilitySnapshotPreviousStatus] | null;


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EligibilitySnapshotPreviousStatus = {
  intact: 'intact',
  weakening: 'weakening',
  at_risk: 'at_risk',
} as const;

/**
 * Flexible per-dimension eligibility signal payload (jsonb)
 */
export type EligibilitySnapshotDimensions = { [key: string]: unknown };

export type EligibilitySnapshotTriggeredBy = typeof EligibilitySnapshotTriggeredBy[keyof typeof EligibilitySnapshotTriggeredBy];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EligibilitySnapshotTriggeredBy = {
  scheduled: 'scheduled',
  prd_drift: 'prd_drift',
  new_cots: 'new_cots',
  engagement: 'engagement',
  manual: 'manual',
} as const;

export interface EligibilitySnapshot {
  id: string;
  status: EligibilitySnapshotStatus;
  /** @nullable */
  previousStatus?: EligibilitySnapshotPreviousStatus;
  rationale: string;
  /** Flexible per-dimension eligibility signal payload (jsonb) */
  dimensions: EligibilitySnapshotDimensions;
  triggeredBy: EligibilitySnapshotTriggeredBy;
  createdAt: string;
}

export type AbandonedWorkCandidateDetectedType = typeof AbandonedWorkCandidateDetectedType[keyof typeof AbandonedWorkCandidateDetectedType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AbandonedWorkCandidateDetectedType = {
  unmerged_pr: 'unmerged_pr',
  reverted_commit: 'reverted_commit',
  stale_branch: 'stale_branch',
  large_deletion: 'large_deletion',
} as const;

export type AbandonedWorkCandidateStatus = typeof AbandonedWorkCandidateStatus[keyof typeof AbandonedWorkCandidateStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AbandonedWorkCandidateStatus = {
  pending: 'pending',
  confirmed: 'confirmed',
  dismissed: 'dismissed',
} as const;

/**
 * @nullable
 */
export type AbandonedWorkCandidateMetadata = {
  /** @nullable */
  developer?: string | null;
  /** @nullable */
  branch?: string | null;
  /** @nullable */
  daysOld?: number | null;
  /** @nullable */
  prNumber?: number | null;
  /** @nullable */
  title?: string | null;
  /** @nullable */
  daysOpen?: number | null;
  /** @nullable */
  url?: string | null;
  /** @nullable */
  sha?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  filesRemoved?: number | null;
} | null;

export interface AbandonedWorkCandidate {
  id: string;
  tenantId: string;
  repoOwner: string;
  repoName: string;
  detectedType: AbandonedWorkCandidateDetectedType;
  summary: string;
  status: AbandonedWorkCandidateStatus;
  /** @nullable */
  projectId?: string | null;
  /** @nullable */
  projectName?: string | null;
  /** @nullable */
  metadata?: AbandonedWorkCandidateMetadata;
  receivedAt: string;
}

export type ExpenditureResultEntryBreakdownItem = {
  entryId: string;
  durationHours: number;
  rdPercentage: number;
  rdHours: number;
  rdExpenditure: number;
};

export interface ExpenditureResult {
  approvedEntryCount: number;
  totalRdHours: number;
  totalRdExpenditure: number;
  entryBreakdown: ExpenditureResultEntryBreakdownItem[];
}

/**
 * @nullable
 */
export type FindingSeverity = typeof FindingSeverity[keyof typeof FindingSeverity] | null;


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const FindingSeverity = {
  info: 'info',
  concern: 'concern',
  critical: 'critical',
} as const;

export interface Finding {
  id: string;
  /** @nullable */
  tokenId?: string | null;
  /** @nullable */
  grantId?: string | null;
  claimId: string;
  /** @nullable */
  artefactId?: string | null;
  /** @nullable */
  activityId?: string | null;
  content: string;
  /** @nullable */
  severity?: FindingSeverity;
  createdAt: string;
}

export interface ProjectRepo {
  id: string;
  projectId: string;
  repoOwner: string;
  repoName: string;
  createdAt: string;
  hasPrd: boolean;
}

/**
 * @nullable
 */
export type AuditLogEntryPreviousState = { [key: string]: unknown } | null;

/**
 * @nullable
 */
export type AuditLogEntryNewState = { [key: string]: unknown } | null;

export interface AuditLogEntry {
  id: string;
  timestamp: string;
  /** @nullable */
  tenantId?: string | null;
  /** @nullable */
  userId?: string | null;
  action: string;
  /** @nullable */
  entityType?: string | null;
  /** @nullable */
  entityId?: string | null;
  /** @nullable */
  previousState?: AuditLogEntryPreviousState;
  /** @nullable */
  newState?: AuditLogEntryNewState;
  /** @nullable */
  previousHash?: string | null;
  currentHash: string;
  /** @nullable */
  ipAddress?: string | null;
  /** @nullable */
  requestId?: string | null;
}

export interface ArtefactLink {
  id: string;
  tenantId: string;
  sourceId: string;
  targetId: string;
  linkType: string;
  createdBy?: string;
  /** @nullable */
  deletedAt?: string | null;
  createdAt: string;
}

export type FeedbackType = typeof FeedbackType[keyof typeof FeedbackType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const FeedbackType = {
  bug_report: 'bug_report',
  feature_request: 'feature_request',
} as const;

export interface Feedback {
  id?: string;
  tenantId?: string;
  type?: FeedbackType;
  title?: string;
  description?: string;
  /** @nullable */
  priority?: string | null;
  status?: string;
  /** @nullable */
  pageUrl?: string | null;
  userId?: string;
  /** @nullable */
  novaTicketId?: string | null;
  createdAt?: string;
  updatedAt?: string;
}

export type WorkingPapersReadinessItemStatus = typeof WorkingPapersReadinessItemStatus[keyof typeof WorkingPapersReadinessItemStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const WorkingPapersReadinessItemStatus = {
  ok: 'ok',
  warning: 'warning',
  blocking: 'blocking',
} as const;

export interface WorkingPapersReadinessItem {
  code: string;
  status: WorkingPapersReadinessItemStatus;
  message: string;
  /** @nullable */
  detail?: string | null;
}

export type WorkingPapersClassificationLabel = typeof WorkingPapersClassificationLabel[keyof typeof WorkingPapersClassificationLabel];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const WorkingPapersClassificationLabel = {
  rd: 'rd',
  non_rd: 'non_rd',
  mixed: 'mixed',
} as const;

export interface WorkingPapersClassification {
  label: WorkingPapersClassificationLabel;
  confidence: number;
  rdPercentage: number;
  /** @nullable */
  rationale?: string | null;
  promptVersion: string;
  model: string;
}

/**
 * @nullable
 */
export type WorkingPapersEntryClassification = WorkingPapersClassification | null;

export interface WorkingPapersEntry {
  id: string;
  userId: string;
  /** @nullable */
  userName?: string | null;
  date: string;
  durationHours: number;
  rdPercentage: number;
  rdExpenditure: number;
  hourlyRate: number;
  /** @nullable */
  reviewedBy?: string | null;
  /** @nullable */
  reviewedByName?: string | null;
  /** @nullable */
  reviewedAt?: string | null;
  /** @nullable */
  classification?: WorkingPapersEntryClassification;
}

export interface WorkingPapersProject {
  id: string;
  name: string;
  tfaLocked: boolean;
  lowConfidenceCount: number;
  entryCount: number;
  rdHours: number;
  rdExpenditure: number;
  entries: WorkingPapersEntry[];
}

export type WorkingPapersResponseDataReadiness = {
  items: WorkingPapersReadinessItem[];
  allClear: boolean;
};

export type WorkingPapersResponseData = {
  readiness: WorkingPapersResponseDataReadiness;
  projects: WorkingPapersProject[];
};

export interface WorkingPapersResponse {
  data: WorkingPapersResponseData;
}

export type DeveloperActivityRange = {
  from?: string;
  to?: string;
};

export type DeveloperActivityTotals = {
  hours?: number;
  commits?: number;
  projects?: number;
  sessions?: number;
};

export type DeveloperActivityCapture = {
  activeMachines?: number;
  hookOutdated?: boolean;
  /** @nullable */
  lastSeenAt?: string | null;
};

export interface DeveloperActivity {
  range?: DeveloperActivityRange;
  days?: DeveloperActivityDay[];
  totals?: DeveloperActivityTotals;
  capture?: DeveloperActivityCapture;
}

export interface DeveloperActivityDay {
  date?: string;
  projects?: DeveloperActivityProject[];
}

export type DeveloperActivityProjectCommitsItem = {
  message?: string;
  at?: string;
};

export type DeveloperActivityProjectExplorationsItemKind = typeof DeveloperActivityProjectExplorationsItemKind[keyof typeof DeveloperActivityProjectExplorationsItemKind];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DeveloperActivityProjectExplorationsItemKind = {
  abandoned_work: 'abandoned_work',
  session: 'session',
} as const;

export type DeveloperActivityProjectExplorationsItem = {
  kind?: DeveloperActivityProjectExplorationsItemKind;
  descriptor?: string;
  at?: string;
};

export interface DeveloperActivityProject {
  /** @nullable */
  projectId?: string | null;
  project?: string;
  hours?: number;
  sessionCount?: number;
  commits?: DeveloperActivityProjectCommitsItem[];
  explorations?: DeveloperActivityProjectExplorationsItem[];
}

export type DeveloperRecapNoteKind = typeof DeveloperRecapNoteKind[keyof typeof DeveloperRecapNoteKind];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DeveloperRecapNoteKind = {
  shipped: 'shipped',
  figured_out: 'figured_out',
  flag: 'flag',
} as const;

export interface DeveloperRecapNote {
  kind: DeveloperRecapNoteKind;
  text: string;
  projectIds?: string[];
}

export interface DeveloperRecapDraft {
  shipped: string;
  figured_out: string;
}

export type DeveloperWeeklyRecapStatus = typeof DeveloperWeeklyRecapStatus[keyof typeof DeveloperWeeklyRecapStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DeveloperWeeklyRecapStatus = {
  pending: 'pending',
  confirmed: 'confirmed',
  edited: 'edited',
} as const;

/**
 * @nullable
 */
export type DeveloperWeeklyRecapDraft = DeveloperRecapDraft | null;

export interface DeveloperWeeklyRecap {
  weekStart?: string;
  notes?: DeveloperRecapNote[];
  projectContext?: string[];
  status?: DeveloperWeeklyRecapStatus;
  /** @nullable */
  confirmedAt?: string | null;
  /** @nullable */
  draft?: DeveloperWeeklyRecapDraft;
}

export type DeveloperWeeklyRecapDraftResponseStatus = typeof DeveloperWeeklyRecapDraftResponseStatus[keyof typeof DeveloperWeeklyRecapDraftResponseStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DeveloperWeeklyRecapDraftResponseStatus = {
  pending: 'pending',
  confirmed: 'confirmed',
  edited: 'edited',
} as const;

export interface DeveloperWeeklyRecapDraftResponse {
  weekStart: string;
  status: DeveloperWeeklyRecapDraftResponseStatus;
  evidenceHash?: string;
  cached?: boolean;
  draft: DeveloperRecapDraft;
}

export type PatchBucketBodyColumn = typeof PatchBucketBodyColumn[keyof typeof PatchBucketBodyColumn];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PatchBucketBodyColumn = {
  rd: 'rd',
  non_rd: 'non_rd',
} as const;

export type PatchBucketBody = {
  column: PatchBucketBodyColumn;
  overrideReason?: string;
};

export type PatchBucket200Data = {
  id?: string;
  column?: string;
};

export type PatchBucket200 = {
  data?: PatchBucket200Data;
};

export type GetProjectContributors200Data = {
  items?: GithubContributor[];
};

export type GetProjectContributors200 = {
  data?: GetProjectContributors200Data;
};

export type VerifyContributorBodyEmploymentType = typeof VerifyContributorBodyEmploymentType[keyof typeof VerifyContributorBodyEmploymentType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const VerifyContributorBodyEmploymentType = {
  employee: 'employee',
  contractor: 'contractor',
} as const;

export type VerifyContributorBody = {
  employmentType: VerifyContributorBodyEmploymentType;
};

export type VerifyContributor200Data = {
  id?: string;
  employmentType?: string;
};

export type VerifyContributor200 = {
  data?: VerifyContributor200Data;
};

export type GetProjectSuggestedActivities200Data = {
  items?: SuggestedActivity[];
};

export type GetProjectSuggestedActivities200 = {
  data?: GetProjectSuggestedActivities200Data;
};

export type DismissSuggestedActivityBodyAction = typeof DismissSuggestedActivityBodyAction[keyof typeof DismissSuggestedActivityBodyAction];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DismissSuggestedActivityBodyAction = {
  dismiss: 'dismiss',
} as const;

export type DismissSuggestedActivityBody = {
  action: DismissSuggestedActivityBodyAction;
};

export type DismissSuggestedActivity200Data = {
  id?: string;
  status?: string;
};

export type DismissSuggestedActivity200 = {
  data?: DismissSuggestedActivity200Data;
};

export type GetUsers200DataItemsItem = {
  id?: string;
  email?: string;
  /** @nullable */
  name?: string | null;
  active?: boolean;
  role?: string;
  createdAt?: string;
};

export type GetUsers200Data = {
  items?: GetUsers200DataItemsItem[];
};

export type GetUsers200 = {
  data?: GetUsers200Data;
};

export type PatchUserRoleBodyRole = typeof PatchUserRoleBodyRole[keyof typeof PatchUserRoleBodyRole];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PatchUserRoleBodyRole = {
  tenant_admin: 'tenant_admin',
  r_and_d_manager: 'r_and_d_manager',
  member: 'member',
  viewer: 'viewer',
  developer: 'developer',
} as const;

export type PatchUserRoleBody = {
  role: PatchUserRoleBodyRole;
};

export type PatchUserRole200Data = {
  id?: string;
  role?: string;
};

export type PatchUserRole200 = {
  data?: PatchUserRole200Data;
};

export type GetTimeEntriesParams = {
reviewStatus?: GetTimeEntriesReviewStatus;
status?: GetTimeEntriesStatus;
projectId?: string;
};

export type GetTimeEntriesReviewStatus = typeof GetTimeEntriesReviewStatus[keyof typeof GetTimeEntriesReviewStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetTimeEntriesReviewStatus = {
  pending: 'pending',
  classifying: 'classifying',
  approved: 'approved',
  rejected: 'rejected',
} as const;

export type GetTimeEntriesStatus = typeof GetTimeEntriesStatus[keyof typeof GetTimeEntriesStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetTimeEntriesStatus = {
  pending: 'pending',
  classifying: 'classifying',
  approved: 'approved',
  rejected: 'rejected',
} as const;

/**
 * @nullable
 */
export type GetTimeEntries200DataItemsItemMetadata = { [key: string]: unknown } | null;

/**
 * @nullable
 */
export type GetTimeEntries200DataItemsItemClassification = {
  id?: string;
  label?: string;
  confidence?: string;
  rdPercentage?: string;
  /** @nullable */
  rationale?: string | null;
} | null;

export type GetTimeEntries200DataItemsItem = {
  id?: string;
  projectId?: string;
  /** @nullable */
  projectName?: string | null;
  startTime?: string;
  endTime?: string;
  /** @nullable */
  rdPercentage?: string | null;
  reviewStatus?: string;
  /** @nullable */
  metadata?: GetTimeEntries200DataItemsItemMetadata;
  /** @nullable */
  classification?: GetTimeEntries200DataItemsItemClassification;
  buckets?: WorkBucket[];
};

export type GetTimeEntries200Data = {
  items?: GetTimeEntries200DataItemsItem[];
};

export type GetTimeEntries200 = {
  data?: GetTimeEntries200Data;
};

export type ApproveTimeEntry200Data = { [key: string]: unknown };

export type ApproveTimeEntry200 = {
  data?: ApproveTimeEntry200Data;
};

export type RejectTimeEntry200Data = { [key: string]: unknown };

export type RejectTimeEntry200 = {
  data?: RejectTimeEntry200Data;
};

export type UndoTimeEntryRejection200Data = { [key: string]: unknown };

export type UndoTimeEntryRejection200 = {
  data?: UndoTimeEntryRejection200Data;
};

export type BulkApproveTimeEntriesBody = {
  ids?: string[];
};

export type BulkApproveTimeEntries200Data = {
  approved?: number;
  skipped?: number;
};

export type BulkApproveTimeEntries200 = {
  data?: BulkApproveTimeEntries200Data;
};

export type GetExpenditureTimelineParams = {
/**
 * @pattern ^FY\d{4}$
 */
incomeYear: string;
};

/**
 * Non-labour cost broken down by source key (aws, gcp, openai, anthropic, replit, manual)
 */
export type GetExpenditureTimeline200DataItemsItemNonLabourBySource = {[key: string]: number};

export type GetExpenditureTimeline200DataItemsItem = {
  month?: string;
  labourExpenditure?: number;
  grossLabourExpenditure?: number;
  nonLabourExpenditure?: number;
  /** Non-labour cost broken down by source key (aws, gcp, openai, anthropic, replit, manual) */
  nonLabourBySource?: GetExpenditureTimeline200DataItemsItemNonLabourBySource;
  totalExpenditure?: number;
  grossTotalExpenditure?: number;
};

export type GetExpenditureTimeline200DataSummary = {
  totalLabour?: number;
  totalNonLabour?: number;
  totalExpenditure?: number;
  incomeYear?: string;
  unratedEligibleHours?: number;
  unclassifiedApprovedCount?: number;
  unclassifiedApprovedHours?: number;
};

export type GetExpenditureTimeline200Data = {
  items?: GetExpenditureTimeline200DataItemsItem[];
  summary?: GetExpenditureTimeline200DataSummary;
};

export type GetExpenditureTimeline200 = {
  data?: GetExpenditureTimeline200Data;
};

export type GetLabourReportParams = {
/**
 * @pattern ^FY\d{4}$
 */
incomeYear: string;
};

export type GetLabourReport200DataProjectsItem = {
  projectId: string;
  projectName: string;
  /** Total approved hours including weekends, no cap */
  rawHours: number;
  /** Approved hours after 7.6h/day/person cap, weekdays only */
  cappedWeekdayHours: number;
  /** Capped weekday hours x hourly rate (AUD) */
  cappedWeekdayLabour: number;
  /** Capped hours x rdPercentage */
  rdHours: number;
  /** R&D hours x hourly rate (AUD) */
  rdLabour: number;
  /** rdHours / cappedWeekdayHours x 100 */
  rdPct: number;
};

export type GetLabourReport200DataTotals = {
  rawHours: number;
  cappedWeekdayHours: number;
  cappedWeekdayLabour: number;
  rdHours: number;
  rdLabour: number;
  rdPct: number;
  incomeYear: string;
};

export type GetLabourReport200Data = {
  projects?: GetLabourReport200DataProjectsItem[];
  totals?: GetLabourReport200DataTotals;
};

export type GetLabourReport200 = {
  data?: GetLabourReport200Data;
};

export type GetDashboardSdlcParams = {
/**
 * @pattern ^FY\d{4}$
 */
incomeYear: string;
/**
 * Optional — scope coverage to a single project (omit for tenant-wide FY view)
 */
projectId?: string;
};

export type GetDashboardSdlc200 = {
  data?: SdlcCoverageResult;
};

export type ListGrantsParams = {
status?: ListGrantsStatus;
source?: string;
state?: string;
};

export type ListGrantsStatus = typeof ListGrantsStatus[keyof typeof ListGrantsStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ListGrantsStatus = {
  open: 'open',
  closed: 'closed',
  forecast: 'forecast',
  archived: 'archived',
} as const;

export type ListGrants200Data = {
  items?: Grant[];
};

export type ListGrants200 = {
  data?: ListGrants200Data;
};

export type GetOrgProfile200 = {
  data?: OrgProfile;
};

export type UpsertOrgProfileBodyCompanySize = typeof UpsertOrgProfileBodyCompanySize[keyof typeof UpsertOrgProfileBodyCompanySize];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpsertOrgProfileBodyCompanySize = {
  sole_trader: 'sole_trader',
  NUMBER_210: 210,
  NUMBER_1150: 1150,
  NUMBER_51200: 51200,
  '200_plus': '200_plus',
} as const;

export type UpsertOrgProfileBodyAnnualTurnover = typeof UpsertOrgProfileBodyAnnualTurnover[keyof typeof UpsertOrgProfileBodyAnnualTurnover];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpsertOrgProfileBodyAnnualTurnover = {
  under_1m: 'under_1m',
  '1m_5m': '1m_5m',
  '5m_20m': '5m_20m',
  over_20m: 'over_20m',
} as const;

export type UpsertOrgProfileBody = {
  legalName: string;
  /** @pattern ^\d{11}$ */
  abn: string;
  address?: string;
  industry?: string;
  companySize?: UpsertOrgProfileBodyCompanySize;
  annualTurnover?: UpsertOrgProfileBodyAnnualTurnover;
  description?: string;
};

export type UpsertOrgProfile200 = {
  data?: OrgProfile;
};

export type GetGrantConfig200 = {
  data?: GrantConfig;
};

export type UpdateGrantConfigBody = {
  extractionPrompt?: string;
  matchingPrompt?: string;
  watchedGrantUuids?: string[];
  watchedBusinessSlugs?: string[];
  syncEnabled?: boolean;
};

export type UpdateGrantConfig200 = {
  data?: GrantConfig;
};

export type GetGrant200 = {
  data?: Grant;
};

export type GetApplicationAid200 = {
  data?: GrantApplicationAid;
};

export type GenerateApplicationAid200 = {
  data?: GrantApplicationAid;
};

export type PostHelpChatBodyMessagesItemRole = typeof PostHelpChatBodyMessagesItemRole[keyof typeof PostHelpChatBodyMessagesItemRole];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PostHelpChatBodyMessagesItemRole = {
  user: 'user',
  assistant: 'assistant',
} as const;

export type PostHelpChatBodyMessagesItem = {
  role: PostHelpChatBodyMessagesItemRole;
  /** @maxLength 4000 */
  content: string;
};

export type PostHelpChatBodyDiagnostics = {
  /** @nullable */
  previousRoute: string | null;
  consoleErrors: string[];
};

export type PostHelpChatBodyDraftType = typeof PostHelpChatBodyDraftType[keyof typeof PostHelpChatBodyDraftType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PostHelpChatBodyDraftType = {
  bug: 'bug',
  feature: 'feature',
} as const;

/**
 * Required when confirmSubmit is true
 */
export type PostHelpChatBodyDraft = {
  /**
   * @minLength 1
   * @maxLength 200
   */
  title: string;
  /**
   * @minLength 1
   * @maxLength 4000
   */
  description: string;
  type: PostHelpChatBodyDraftType;
};

export type PostHelpChatBody = {
  /**
   * @minItems 1
   * @maxItems 20
   */
  messages: PostHelpChatBodyMessagesItem[];
  /**
   * Optional app context string shown to the AI
   * @maxLength 500
   */
  pageContext?: string;
  diagnostics?: PostHelpChatBodyDiagnostics;
  /** When true, submits the draft to Nova and saves to feedback table */
  confirmSubmit?: boolean;
  /** Required when confirmSubmit is true */
  draft?: PostHelpChatBodyDraft;
};

export type PostHelpChat200DataOneOfType = typeof PostHelpChat200DataOneOfType[keyof typeof PostHelpChat200DataOneOfType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PostHelpChat200DataOneOfType = {
  answer: 'answer',
} as const;

export type PostHelpChat200DataOneOf = {
  type: PostHelpChat200DataOneOfType;
  message: string;
  /** @nullable */
  citedGuideId?: string | null;
};

export type PostHelpChat200DataOneOfThreeType = typeof PostHelpChat200DataOneOfThreeType[keyof typeof PostHelpChat200DataOneOfThreeType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PostHelpChat200DataOneOfThreeType = {
  intake: 'intake',
} as const;

export type PostHelpChat200DataOneOfThreeIntakeType = typeof PostHelpChat200DataOneOfThreeIntakeType[keyof typeof PostHelpChat200DataOneOfThreeIntakeType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PostHelpChat200DataOneOfThreeIntakeType = {
  bug: 'bug',
  feature: 'feature',
} as const;

export type PostHelpChat200DataOneOfThree = {
  type: PostHelpChat200DataOneOfThreeType;
  message: string;
  intakeType: PostHelpChat200DataOneOfThreeIntakeType;
};

export type PostHelpChat200DataOneOfSixType = typeof PostHelpChat200DataOneOfSixType[keyof typeof PostHelpChat200DataOneOfSixType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PostHelpChat200DataOneOfSixType = {
  confirm_submit: 'confirm_submit',
} as const;

export type PostHelpChat200DataOneOfSixDraftType = typeof PostHelpChat200DataOneOfSixDraftType[keyof typeof PostHelpChat200DataOneOfSixDraftType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PostHelpChat200DataOneOfSixDraftType = {
  bug: 'bug',
  feature: 'feature',
} as const;

export type PostHelpChat200DataOneOfSixDraft = {
  title: string;
  description: string;
  type: PostHelpChat200DataOneOfSixDraftType;
};

export type PostHelpChat200DataOneOfSix = {
  type: PostHelpChat200DataOneOfSixType;
  message: string;
  draft: PostHelpChat200DataOneOfSixDraft;
};

export type PostHelpChat200DataOneOfOnezeroType = typeof PostHelpChat200DataOneOfOnezeroType[keyof typeof PostHelpChat200DataOneOfOnezeroType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PostHelpChat200DataOneOfOnezeroType = {
  submitted: 'submitted',
} as const;

export type PostHelpChat200DataOneOfOnezero = {
  type: PostHelpChat200DataOneOfOnezeroType;
  message: string;
  ticketId: string;
};

export type PostHelpChat200Data = PostHelpChat200DataOneOf | PostHelpChat200DataOneOfThree | PostHelpChat200DataOneOfSix | PostHelpChat200DataOneOfOnezero;

export type PostHelpChat200 = {
  data: PostHelpChat200Data;
};

export type ListFeedbackParams = {
type?: ListFeedbackType;
status?: ListFeedbackStatus;
};

export type ListFeedbackType = typeof ListFeedbackType[keyof typeof ListFeedbackType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ListFeedbackType = {
  bug_report: 'bug_report',
  feature_request: 'feature_request',
} as const;

export type ListFeedbackStatus = typeof ListFeedbackStatus[keyof typeof ListFeedbackStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ListFeedbackStatus = {
  open: 'open',
  in_review: 'in_review',
  planned: 'planned',
  resolved: 'resolved',
  closed: 'closed',
} as const;

export type ListFeedback200Data = {
  items?: Feedback[];
  /** @nullable */
  lastPolledAt?: string | null;
};

export type ListFeedback200 = {
  data?: ListFeedback200Data;
};

export type CreateFeedbackBodyType = typeof CreateFeedbackBodyType[keyof typeof CreateFeedbackBodyType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateFeedbackBodyType = {
  bug_report: 'bug_report',
  feature_request: 'feature_request',
} as const;

export type CreateFeedbackBodyPriority = typeof CreateFeedbackBodyPriority[keyof typeof CreateFeedbackBodyPriority];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateFeedbackBodyPriority = {
  low: 'low',
  medium: 'medium',
  high: 'high',
  critical: 'critical',
} as const;

export type CreateFeedbackBody = {
  type: CreateFeedbackBodyType;
  /**
   * @minLength 3
   * @maxLength 200
   */
  title: string;
  /**
   * @minLength 10
   * @maxLength 5000
   */
  description: string;
  priority?: CreateFeedbackBodyPriority;
  /** @maxLength 500 */
  pageUrl?: string;
};

export type CreateFeedback201 = {
  data?: Feedback;
};

export type GetFeedback200 = {
  data?: Feedback;
};

export type UpdateFeedbackStatusBodyStatus = typeof UpdateFeedbackStatusBodyStatus[keyof typeof UpdateFeedbackStatusBodyStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateFeedbackStatusBodyStatus = {
  open: 'open',
  in_review: 'in_review',
  planned: 'planned',
  resolved: 'resolved',
  closed: 'closed',
} as const;

export type UpdateFeedbackStatusBody = {
  status: UpdateFeedbackStatusBodyStatus;
};

export type UpdateFeedbackStatus200 = {
  data?: Feedback;
};

export type AddFeedbackCommentBody = {
  /**
   * @minLength 1
   * @maxLength 2000
   */
  message: string;
};

export type AddFeedbackComment201Data = { [key: string]: unknown };

export type AddFeedbackComment201 = {
  data?: AddFeedbackComment201Data;
};

export type GetRates200Data = {
  items?: UserRate[];
};

export type GetRates200 = {
  data?: GetRates200Data;
};

export type CreateRateBody = {
  userId: string;
  /**
   * @minimum 0
   * @maximum 10000
   */
  hourlyRate: number;
  effectiveFrom: string;
};

export type CreateRate201 = {
  data?: UserRate;
};

export type GetRateHistory200Data = {
  items?: UserRate[];
};

export type GetRateHistory200 = {
  data?: GetRateHistory200Data;
};

export type GetCostAllocationsParams = {
claimId: string;
};

export type GetCostAllocations200Data = {
  items?: CostAllocation[];
};

export type GetCostAllocations200 = {
  data?: GetCostAllocations200Data;
};

export type CreateCostAllocationBodyCategory = typeof CreateCostAllocationBodyCategory[keyof typeof CreateCostAllocationBodyCategory];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateCostAllocationBodyCategory = {
  cloud: 'cloud',
  llm_tokens: 'llm_tokens',
  software_license: 'software_license',
  hardware: 'hardware',
  other: 'other',
  admin_overhead: 'admin_overhead',
  software_subscription: 'software_subscription',
  insurance: 'insurance',
  consultant_fees: 'consultant_fees',
  company_setup: 'company_setup',
  rdti_claim_prep: 'rdti_claim_prep',
} as const;

/**
 * If omitted entirely (with claimablePercent/eligibilityReason/apportionmentBasis also omitted), CATEGORY_DEFAULTS applies all-or-nothing for the category
 */
export type CreateCostAllocationBodyEligibilityStatus = typeof CreateCostAllocationBodyEligibilityStatus[keyof typeof CreateCostAllocationBodyEligibilityStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateCostAllocationBodyEligibilityStatus = {
  claimable: 'claimable',
  excluded: 'excluded',
  needs_review: 'needs_review',
} as const;

export type CreateCostAllocationBodyApportionmentBasis = typeof CreateCostAllocationBodyApportionmentBasis[keyof typeof CreateCostAllocationBodyApportionmentBasis];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateCostAllocationBodyApportionmentBasis = {
  manual: 'manual',
  labour_pct: 'labour_pct',
  custom: 'custom',
  full: 'full',
} as const;

export type CreateCostAllocationBody = {
  claimId?: string;
  projectId?: string;
  category: CreateCostAllocationBodyCategory;
  /** @minimum 0 */
  amount: number;
  periodStart: string;
  periodEnd: string;
  /** @maxLength 500 */
  description?: string;
  /** @maxLength 2000 */
  notes?: string;
  /** @maxLength 50 */
  vendor?: string;
  /** If omitted entirely (with claimablePercent/eligibilityReason/apportionmentBasis also omitted), CATEGORY_DEFAULTS applies all-or-nothing for the category */
  eligibilityStatus?: CreateCostAllocationBodyEligibilityStatus;
  /**
   * @minimum 0
   * @maximum 100
   */
  claimablePercent?: number;
  /**
   * Required when eligibilityStatus is excluded
   * @maxLength 2000
   */
  eligibilityReason?: string;
  apportionmentBasis?: CreateCostAllocationBodyApportionmentBasis;
};

export type CreateCostAllocation201 = {
  data?: CostAllocation;
};

export type BulkUpdateCostEligibilityBodyFilterSource = typeof BulkUpdateCostEligibilityBodyFilterSource[keyof typeof BulkUpdateCostEligibilityBodyFilterSource];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BulkUpdateCostEligibilityBodyFilterSource = {
  api_aws: 'api_aws',
  api_gcp: 'api_gcp',
  api_openai: 'api_openai',
  api_anthropic: 'api_anthropic',
  api_replit: 'api_replit',
  api_xero: 'api_xero',
  manual: 'manual',
} as const;

/**
 * Filters on the row's CURRENT status (which rows to act on)
 */
export type BulkUpdateCostEligibilityBodyFilterEligibilityStatus = typeof BulkUpdateCostEligibilityBodyFilterEligibilityStatus[keyof typeof BulkUpdateCostEligibilityBodyFilterEligibilityStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BulkUpdateCostEligibilityBodyFilterEligibilityStatus = {
  claimable: 'claimable',
  excluded: 'excluded',
  needs_review: 'needs_review',
} as const;

/**
 * At least one of source or vendor is required — no tenant-wide blanket updates
 */
export type BulkUpdateCostEligibilityBodyFilter = {
  source?: BulkUpdateCostEligibilityBodyFilterSource;
  /** @maxLength 50 */
  vendor?: string;
  periodStart: string;
  periodEnd: string;
  /** Filters on the row's CURRENT status (which rows to act on) */
  eligibilityStatus?: BulkUpdateCostEligibilityBodyFilterEligibilityStatus;
};

export type BulkUpdateCostEligibilityBodySetEligibilityStatus = typeof BulkUpdateCostEligibilityBodySetEligibilityStatus[keyof typeof BulkUpdateCostEligibilityBodySetEligibilityStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BulkUpdateCostEligibilityBodySetEligibilityStatus = {
  claimable: 'claimable',
  excluded: 'excluded',
  needs_review: 'needs_review',
} as const;

export type BulkUpdateCostEligibilityBodySet = {
  eligibilityStatus: BulkUpdateCostEligibilityBodySetEligibilityStatus;
  /**
   * When present, apportionmentBasis is stamped 'manual' on the affected rows (reviewer override provenance)
   * @minimum 0
   * @maximum 100
   */
  claimablePercent?: number;
  /**
   * ALWAYS required — every bulk change is an explicit reviewer override
   * @minLength 1
   * @maxLength 2000
   */
  eligibilityReason: string;
};

export type BulkUpdateCostEligibilityBody = {
  /** At least one of source or vendor is required — no tenant-wide blanket updates */
  filter: BulkUpdateCostEligibilityBodyFilter;
  set: BulkUpdateCostEligibilityBodySet;
  /** true → return the would-be impact without writing */
  dryRun?: boolean;
};

export type BulkUpdateCostEligibility200DataTotals = {
  /** SUM(amount) over affected rows */
  amount?: number;
  claimableBefore?: number;
  claimableAfter?: number;
  claimableDelta?: number;
};

export type BulkUpdateCostEligibility200Data = {
  dryRun?: boolean;
  /** rows matching the filter */
  matched?: number;
  /** rows actually affected (matched minus hard-excluded skips) */
  updated?: number;
  skippedHardExcluded?: number;
  totals?: BulkUpdateCostEligibility200DataTotals;
};

export type BulkUpdateCostEligibility200 = {
  data?: BulkUpdateCostEligibility200Data;
};

export type UpdateCostAllocationEligibilityBodyCategory = typeof UpdateCostAllocationEligibilityBodyCategory[keyof typeof UpdateCostAllocationEligibilityBodyCategory];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateCostAllocationEligibilityBodyCategory = {
  cloud: 'cloud',
  llm_tokens: 'llm_tokens',
  software_license: 'software_license',
  hardware: 'hardware',
  other: 'other',
  admin_overhead: 'admin_overhead',
  software_subscription: 'software_subscription',
  insurance: 'insurance',
  consultant_fees: 'consultant_fees',
  company_setup: 'company_setup',
  rdti_claim_prep: 'rdti_claim_prep',
} as const;

export type UpdateCostAllocationEligibilityBodyEligibilityStatus = typeof UpdateCostAllocationEligibilityBodyEligibilityStatus[keyof typeof UpdateCostAllocationEligibilityBodyEligibilityStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateCostAllocationEligibilityBodyEligibilityStatus = {
  claimable: 'claimable',
  excluded: 'excluded',
  needs_review: 'needs_review',
} as const;

export type UpdateCostAllocationEligibilityBodyApportionmentBasis = typeof UpdateCostAllocationEligibilityBodyApportionmentBasis[keyof typeof UpdateCostAllocationEligibilityBodyApportionmentBasis];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateCostAllocationEligibilityBodyApportionmentBasis = {
  manual: 'manual',
  labour_pct: 'labour_pct',
  custom: 'custom',
  full: 'full',
} as const;

export type UpdateCostAllocationEligibilityBody = {
  category?: UpdateCostAllocationEligibilityBodyCategory;
  /** @maxLength 500 */
  description?: string;
  /** @maxLength 2000 */
  notes?: string;
  /** @maxLength 50 */
  vendor?: string;
  eligibilityStatus?: UpdateCostAllocationEligibilityBodyEligibilityStatus;
  /**
   * Changing this away from the row's stored value requires eligibilityReason in the same request (COST_PERCENT_REASON_REQUIRED otherwise)
   * @minimum 0
   * @maximum 100
   */
  claimablePercent?: number;
  /**
   * Required when eligibilityStatus is excluded
   * @maxLength 2000
   */
  eligibilityReason?: string;
  apportionmentBasis?: UpdateCostAllocationEligibilityBodyApportionmentBasis;
};

export type UpdateCostAllocationEligibility200 = {
  data?: CostAllocation;
};

export type SyncAnthropicUsageBody = {
  claimId: string;
  periodStart: string;
  periodEnd: string;
};

export type SyncAnthropicUsage201 = {
  data?: CostAllocation;
};

export type SyncAwsCostsBody = {
  claimId: string;
  periodStart: string;
  periodEnd: string;
};

export type SyncAwsCosts201 = {
  data?: CostAllocation;
};

export type AssignCostAllocationBody = {
  /** @nullable */
  projectId: string | null;
};

export type AssignCostAllocation200 = {
  data?: CostAllocation;
};

export type GetProjectCostOverridesParams = {
projectId?: string;
};

export type GetProjectCostOverrides200Data = {
  items?: ProjectCostOverride[];
};

export type GetProjectCostOverrides200 = {
  data?: GetProjectCostOverrides200Data;
};

export type CreateProjectCostOverrideBodyProvider = typeof CreateProjectCostOverrideBodyProvider[keyof typeof CreateProjectCostOverrideBodyProvider];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateProjectCostOverrideBodyProvider = {
  aws: 'aws',
  gcp: 'gcp',
  openai: 'openai',
} as const;

export type CreateProjectCostOverrideBody = {
  projectId: string;
  provider: CreateProjectCostOverrideBodyProvider;
  externalId: string;
};

export type CreateProjectCostOverride201 = {
  data?: ProjectCostOverride;
};

export type GetIntegrations200Data = {
  items?: IntegrationConfigSummary[];
};

export type GetIntegrations200 = {
  data?: GetIntegrations200Data;
};

export type UpsertIntegrationBodyProvider = typeof UpsertIntegrationBodyProvider[keyof typeof UpsertIntegrationBodyProvider];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpsertIntegrationBodyProvider = {
  anthropic: 'anthropic',
  aws: 'aws',
  gcp: 'gcp',
  openai: 'openai',
  replit: 'replit',
} as const;

export type UpsertIntegrationBody = {
  provider: UpsertIntegrationBodyProvider;
  configKey: string;
  configValue: string;
};

export type GetClaimExpenditure200DataLabourByProjectItem = {
  projectId?: string;
  /** @nullable */
  name?: string | null;
  rdHours?: number;
  rdExpenditure?: number;
  entryCount?: number;
};

export type GetClaimExpenditure200DataLabourByUserItem = {
  userId?: string;
  /** @nullable */
  name?: string | null;
  /** @nullable */
  email?: string | null;
  rdHours?: number;
  rdExpenditure?: number;
  entryCount?: number;
  hourlyRate?: number;
};

export type GetClaimExpenditure200DataLabourEntryBreakdownItem = {
  entryId?: string;
  userId?: string;
  projectId?: string;
  durationHours?: number;
  rdPercentage?: number;
  rdHours?: number;
  rdExpenditure?: number;
  hourlyRate?: number;
};

export type GetClaimExpenditure200DataLabour = {
  totalRdHours?: number;
  totalRdExpenditure?: number;
  approvedEntryCount?: number;
  byProject?: GetClaimExpenditure200DataLabourByProjectItem[];
  byUser?: GetClaimExpenditure200DataLabourByUserItem[];
  entryBreakdown?: GetClaimExpenditure200DataLabourEntryBreakdownItem[];
};

export type GetClaimExpenditure200DataNonLabour = {
  items?: CostAllocation[];
  totalNonLabourExpenditure?: number;
};

export type GetClaimExpenditure200Data = {
  labour?: GetClaimExpenditure200DataLabour;
  nonLabour?: GetClaimExpenditure200DataNonLabour;
  totalExpenditure?: number;
  /** User IDs with no rate card covering their time entries */
  missingRates?: string[];
};

export type GetClaimExpenditure200 = {
  data?: GetClaimExpenditure200Data;
};

export type RegisterUserBody = {
  /**
   * @minLength 1
   * @maxLength 255
   */
  tenantName: string;
};

export type RegisterUser201Data = {
  userId?: string;
  tenantId?: string;
};

export type RegisterUser201 = {
  data?: RegisterUser201Data;
};

export type EnterActAsBodyTargetRole = typeof EnterActAsBodyTargetRole[keyof typeof EnterActAsBodyTargetRole];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EnterActAsBodyTargetRole = {
  r_and_d_manager: 'r_and_d_manager',
  member: 'member',
  viewer: 'viewer',
  developer: 'developer',
} as const;

export type EnterActAsBody = {
  targetRole: EnterActAsBodyTargetRole;
};

export type EnterActAs200Data = {
  token?: string;
  actAsRole?: string;
  expiresAt?: string;
};

export type EnterActAs200 = {
  data?: EnterActAs200Data;
};

export type ExitActAsBody = {
  targetRole?: string;
};

export type ExitActAs200Data = {
  ok?: boolean;
};

export type ExitActAs200 = {
  data?: ExitActAs200Data;
};

export type GetArtefactsParams = {
type?: string;
projectId?: string;
};

export type GetArtefacts200Data = {
  items?: Artefact[];
};

export type GetArtefacts200 = {
  data?: GetArtefacts200Data;
};

export type CreateArtefactBody = {
  type: string;
  title: string;
  content: string;
  projectId?: string;
  activityId?: string;
};

export type CreateArtefact201 = {
  data?: Artefact;
};

export type DetectTranscriptSplitsBody = {
  /** Raw transcript text */
  content: string;
  filename: string;
};

export type DetectTranscriptSplits200Data = {
  splits?: TranscriptSplit[];
};

export type DetectTranscriptSplits200 = {
  data?: DetectTranscriptSplits200Data;
};

export type GetArtefact200 = {
  data?: Artefact;
};

export type GetProjectsParams = {
status?: GetProjectsStatus;
/**
 * Filter by income year (e.g. FY2025)
 */
incomeYear?: string;
};

export type GetProjectsStatus = typeof GetProjectsStatus[keyof typeof GetProjectsStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetProjectsStatus = {
  active: 'active',
  archived: 'archived',
} as const;

export type GetProjects200Data = {
  items?: Project[];
};

export type GetProjects200 = {
  data?: GetProjects200Data;
};

export type CreateProjectBody = {
  name: string;
  description?: string;
  incomeYear?: string;
  startDate: string;
  endDate?: string;
  initiativeId?: string;
};

export type CreateProject201 = {
  data?: Project;
};

export type GetProject200 = {
  data?: Project;
};

export type UpdateProjectBodyStatus = typeof UpdateProjectBodyStatus[keyof typeof UpdateProjectBodyStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateProjectBodyStatus = {
  active: 'active',
  archived: 'archived',
  no_rd: 'no_rd',
  completed: 'completed',
  cancelled: 'cancelled',
} as const;

export type UpdateProjectBodyRdAttributionMode = typeof UpdateProjectBodyRdAttributionMode[keyof typeof UpdateProjectBodyRdAttributionMode];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateProjectBodyRdAttributionMode = {
  granular: 'granular',
  project_level: 'project_level',
} as const;

export type UpdateProjectBody = {
  /**
   * @minLength 1
   * @maxLength 255
   */
  name?: string;
  description?: string;
  status?: UpdateProjectBodyStatus;
  endDate?: string;
  /** @nullable */
  incomeYear?: string | null;
  /** @nullable */
  initiativeId?: string | null;
  rdAttributionMode?: UpdateProjectBodyRdAttributionMode;
  /** @nullable */
  productGroup?: string | null;
  /** @nullable */
  aliases?: string | null;
};

export type UpdateProject200 = {
  data?: Project;
};

export type BulkUpdateProjectStatusBodyStatus = typeof BulkUpdateProjectStatusBodyStatus[keyof typeof BulkUpdateProjectStatusBodyStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BulkUpdateProjectStatusBodyStatus = {
  active: 'active',
  archived: 'archived',
  no_rd: 'no_rd',
} as const;

export type BulkUpdateProjectStatusBody = {
  /**
   * @minItems 1
   * @maxItems 100
   */
  ids: string[];
  status: BulkUpdateProjectStatusBodyStatus;
};

export type BulkUpdateProjectStatus200Data = {
  updated: number;
};

export type BulkUpdateProjectStatus200 = {
  data: BulkUpdateProjectStatus200Data;
};

export type CloseProjectBodyStatus = typeof CloseProjectBodyStatus[keyof typeof CloseProjectBodyStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CloseProjectBodyStatus = {
  completed: 'completed',
  cancelled: 'cancelled',
} as const;

export type CloseProjectBody = {
  status: CloseProjectBodyStatus;
  /**
   * @minLength 1
   * @maxLength 500
   */
  closureReason: string;
};

export type CloseProject200 = {
  data?: Project;
};

export type GetInitiatives200Data = {
  items?: Initiative[];
};

export type GetInitiatives200 = {
  data?: GetInitiatives200Data;
};

export type CreateInitiativeBody = {
  name: string;
  description?: string;
};

export type CreateInitiative201 = {
  data?: Initiative;
};

export type UpdateInitiativeBodyStatus = typeof UpdateInitiativeBodyStatus[keyof typeof UpdateInitiativeBodyStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateInitiativeBodyStatus = {
  active: 'active',
  completed: 'completed',
  cancelled: 'cancelled',
} as const;

export type UpdateInitiativeBody = {
  name?: string;
  description?: string;
  status?: UpdateInitiativeBodyStatus;
};

export type UpdateInitiative200 = {
  data?: Initiative;
};

export type DeleteInitiative200 = {
  data?: Initiative;
};

export type GetProjectRepos200Data = {
  items?: ProjectRepo[];
};

export type GetProjectRepos200 = {
  data?: GetProjectRepos200Data;
};

export type AddProjectRepoBody = {
  repoOwner: string;
  repoName: string;
};

export type AddProjectRepo201 = {
  data?: ProjectRepo;
};

export type GetProjectEngagement200DataBranchesItem = {
  branchName: string;
  commitCount: number;
  /** @nullable */
  filesTouched?: number | null;
  outcome: string;
  /** @nullable */
  lifetimeDays?: number | null;
  /** @nullable */
  mergedAt?: string | null;
  /** @nullable */
  prNumber?: number | null;
};

export type GetProjectEngagement200DataPrReviewsItem = {
  prNumber: number;
  reviewCount: number;
  commentCount: number;
  reviewerCount: number;
  roundtrips: number;
  /** @nullable */
  decision?: string | null;
};

export type GetProjectEngagement200DataCiSequencesItem = {
  commitSha: string;
  /** @nullable */
  branch?: string | null;
  context: string;
  /** @nullable */
  failuresBeforeGreen?: number | null;
  fixCommitSha: string;
};

export type GetProjectEngagement200DataSummary = {
  /** @nullable */
  avgBranchLifetimeDays: number | null;
  abandonedBranches: number;
  mergedBranches: number;
  totalPrRoundtrips: number;
  ciFailureSequences: number;
};

export type GetProjectEngagement200Data = {
  branches: GetProjectEngagement200DataBranchesItem[];
  prReviews: GetProjectEngagement200DataPrReviewsItem[];
  ciSequences: GetProjectEngagement200DataCiSequencesItem[];
  summary: GetProjectEngagement200DataSummary;
};

export type GetProjectEngagement200 = {
  data?: GetProjectEngagement200Data;
};

/**
 * @nullable
 */
export type GetProjectEligibilityLedger200DataCurrent = EligibilitySnapshot | null;

export type GetProjectEligibilityLedger200Data = {
  /** @nullable */
  current: GetProjectEligibilityLedger200DataCurrent;
  history: EligibilitySnapshot[];
};

export type GetProjectEligibilityLedger200 = {
  data?: GetProjectEligibilityLedger200Data;
};

export type CreateProjectTfaBody = {
  retrospective?: boolean;
  evidencePeriodStart?: string;
  evidencePeriodEnd?: string;
  assessmentDate?: string;
};

export type CreateProjectTfa201 = {
  data?: TfaPanelFull;
};

export type GetTfa200 = {
  data?: TfaPanelFull;
};

export type PatchTfaStageBodyStage = typeof PatchTfaStageBodyStage[keyof typeof PatchTfaStageBodyStage];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PatchTfaStageBodyStage = {
  setup: 'setup',
  problem_definition: 'problem_definition',
  cots_sweep: 'cots_sweep',
  panel_selection: 'panel_selection',
  panel_deliberation: 'panel_deliberation',
  determination: 'determination',
} as const;

export type PatchTfaStageBody = {
  stage: PatchTfaStageBodyStage;
};

export type PatchTfaStage200 = {
  data?: TfaPanelFull;
};

export type PatchTfaContentBody = {
  problemStatement?: string;
  cotsConclusion?: string;
  cotsSweepNotes?: string;
};

export type PatchTfaContent200 = {
  data?: TfaPanelFull;
};

export type PostTfaLock200 = {
  data?: TfaPanelFull;
};

export type PostTfaUnlock200 = {
  data?: TfaPanelFull;
};

export type PostTfaPanelistBody = {
  userId: string;
};

export type PostTfaPanelist201 = {
  data?: TfaPanelist;
};

export type PostTfaPanelistConfirm200 = {
  data?: TfaPanelist;
};

export type PatchTfaPanelistFinalApproverBody = {
  isFinalApprover: boolean;
};

export type PatchTfaPanelistFinalApprover200 = {
  data?: TfaPanelist;
};

export type PostTfaPanelistDeliberateBody = {
  responses: TfaDeliberationQuestion[];
  /** @nullable */
  overallComment?: string | null;
};

export type PostTfaPanelistDeliberate200 = {
  data?: TfaDeliberationResponse;
};

export type GetTfaDeliberations200Data = {
  items: TfaDeliberationResponse[];
};

export type GetTfaDeliberations200 = {
  data: GetTfaDeliberations200Data;
};

export type PostTfaSynthesize200Data = {
  /** @nullable */
  synthesis?: string | null;
};

export type PostTfaSynthesize200 = {
  data?: PostTfaSynthesize200Data;
};

export type GetMyPendingDeliberations200DataItemsItem = {
  projectId: string;
  projectName: string;
  panelId: string;
};

export type GetMyPendingDeliberations200Data = {
  items: GetMyPendingDeliberations200DataItemsItem[];
};

export type GetMyPendingDeliberations200 = {
  data: GetMyPendingDeliberations200Data;
};

export type PostTfaDeterminationBodyOutcome = typeof PostTfaDeterminationBodyOutcome[keyof typeof PostTfaDeterminationBodyOutcome];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PostTfaDeterminationBodyOutcome = {
  eligible: 'eligible',
  ineligible: 'ineligible',
  certain: 'certain',
  uncertain: 'uncertain',
} as const;

export type PostTfaDeterminationBodyDetermination = typeof PostTfaDeterminationBodyDetermination[keyof typeof PostTfaDeterminationBodyDetermination];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PostTfaDeterminationBodyDetermination = {
  eligible: 'eligible',
  ineligible: 'ineligible',
  certain: 'certain',
  uncertain: 'uncertain',
  partially_uncertain: 'partially_uncertain',
} as const;

export type PostTfaDeterminationBody = {
  outcome: PostTfaDeterminationBodyOutcome;
  determination?: PostTfaDeterminationBodyDetermination;
  /** @nullable */
  rationale?: string | null;
  /** @nullable */
  notes?: string | null;
};

export type PostTfaDetermination201 = {
  data?: TfaDetermination;
};

export type RegenerateTfaDraft200DataStatus = typeof RegenerateTfaDraft200DataStatus[keyof typeof RegenerateTfaDraft200DataStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RegenerateTfaDraft200DataStatus = {
  complete: 'complete',
  skipped: 'skipped',
  failed: 'failed',
} as const;

export type RegenerateTfaDraft200Data = {
  status?: RegenerateTfaDraft200DataStatus;
};

export type RegenerateTfaDraft200 = {
  data?: RegenerateTfaDraft200Data;
};

export type GetProjectActivities200Data = {
  items?: Activity[];
};

export type GetProjectActivities200 = {
  data?: GetProjectActivities200Data;
};

export type CreateActivityBodyIpOwnership = typeof CreateActivityBodyIpOwnership[keyof typeof CreateActivityBodyIpOwnership];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateActivityBodyIpOwnership = {
  company: 'company',
  client: 'client',
  joint: 'joint',
  licensed_back: 'licensed_back',
  undetermined: 'undetermined',
} as const;

export type CreateActivityBody = {
  name: string;
  description?: string;
  ipOwnership: CreateActivityBodyIpOwnership;
};

export type CreateActivity201 = {
  data?: Activity;
};

export type GetActivity200 = {
  data?: ActivityDetail;
};

export type CreateCompetenceRecordBody = {
  qualifications?: string;
  relevantExpertise?: string;
  priorWorkSummary?: string;
  roleOnActivity: string;
  uncertaintyBasis: string;
  /** tenant_admin / r_and_d_manager only — create this record on behalf of another user in the same tenant */
  targetUserId?: string;
};

export type CreateCompetenceRecord201Data = {
  id?: string;
};

export type CreateCompetenceRecord201 = {
  data?: CreateCompetenceRecord201Data;
};

export type GetSignals200Data = {
  items?: Signal[];
};

export type GetSignals200 = {
  data?: GetSignals200Data;
};

export type CreateSignalBody = {
  repoOwner: string;
  repoName: string;
};

export type CreateSignal201 = {
  data?: Signal;
};

export type SyncSignalPrd200Data = {
  ingested?: boolean;
};

export type SyncSignalPrd200 = {
  data?: SyncSignalPrd200Data;
};

export type GetAbandonedWorkCandidates200Data = {
  items?: AbandonedWorkCandidate[];
};

export type GetAbandonedWorkCandidates200 = {
  data?: GetAbandonedWorkCandidates200Data;
};

export type PatchAbandonedWorkCandidateBodyAction = typeof PatchAbandonedWorkCandidateBodyAction[keyof typeof PatchAbandonedWorkCandidateBodyAction];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PatchAbandonedWorkCandidateBodyAction = {
  dismiss: 'dismiss',
  confirm: 'confirm',
} as const;

export type PatchAbandonedWorkCandidateBody = {
  action: PatchAbandonedWorkCandidateBodyAction;
  projectId?: string;
  activityId?: string;
};

export type PatchAbandonedWorkCandidate200 = {
  data?: AbandonedWorkCandidate;
};

export type ExtractAbandonedWork200Data = {
  whatWasTried: string;
  whyAbandoned: string;
  evidenceSignals: string[];
  promptVersion: string;
  model: string;
};

export type ExtractAbandonedWork200 = {
  data: ExtractAbandonedWork200Data;
};

export type GetSignalAvailableRepos200DataItemsItem = {
  name: string;
  full_name: string;
  private: boolean;
  /** @nullable */
  description?: string | null;
  pushed_at: string;
  /** @nullable */
  alreadyLinkedTo?: string | null;
};

export type GetSignalAvailableRepos200Data = {
  items: GetSignalAvailableRepos200DataItemsItem[];
};

export type GetSignalAvailableRepos200 = {
  data: GetSignalAvailableRepos200Data;
};

export type GetSignalRepoPreviewParams = {
owner: string;
repo: string;
};

export type GetSignalRepoPreview200DataRecentCommitsItem = {
  id: string;
  sha: string;
  message: string;
  createdAt: string;
};

export type GetSignalRepoPreview200Data = {
  commitCount: number;
  contributorCount: number;
  /** @nullable */
  lastCommitAt: string | null;
  recentCommits: GetSignalRepoPreview200DataRecentCommitsItem[];
};

export type GetSignalRepoPreview200 = {
  data: GetSignalRepoPreview200Data;
};

export type GetSignalActivityChartParams = {
range: GetSignalActivityChartRange;
fy?: string;
};

export type GetSignalActivityChartRange = typeof GetSignalActivityChartRange[keyof typeof GetSignalActivityChartRange];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetSignalActivityChartRange = {
  '30d': '30d',
  '60d': '60d',
  '90d': '90d',
  fy: 'fy',
} as const;

export type GetSignalActivityChart200DataSeriesItemPointsItem = {
  date: string;
  rdCount: number;
  nonRdCount: number;
};

export type GetSignalActivityChart200DataSeriesItem = {
  repoOwner: string;
  repoName: string;
  points: GetSignalActivityChart200DataSeriesItemPointsItem[];
};

export type GetSignalActivityChart200Data = {
  series: GetSignalActivityChart200DataSeriesItem[];
};

export type GetSignalActivityChart200 = {
  data: GetSignalActivityChart200Data;
};

export type GetClaimsParams = {
status?: GetClaimsStatus;
};

export type GetClaimsStatus = typeof GetClaimsStatus[keyof typeof GetClaimsStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetClaimsStatus = {
  draft: 'draft',
  validating: 'validating',
  locked: 'locked',
} as const;

export type GetClaims200Data = {
  items?: Claim[];
};

export type GetClaims200 = {
  data?: GetClaims200Data;
};

export type CreateClaimBody = {
  name: string;
  incomeYear: string;
};

export type CreateClaim201 = {
  data?: Claim;
};

export type GetClaim200 = {
  data?: Claim;
};

export type ValidateClaim200 = {
  data?: Claim;
};

export type ValidateClaim422Error = {
  code?: string;
  message?: string;
  details?: ValidationFailure[];
};

export type ValidateClaim422 = {
  error?: ValidateClaim422Error;
};

export type LockClaim200 = {
  data?: Claim;
};

export type LockClaim422Error = {
  code?: string;
  message?: string;
  details?: ValidationFailure[];
};

export type LockClaim422 = {
  error?: LockClaim422Error;
};

export type PrepareClaimForLock200 = {
  data: Claim;
};

export type GetAccessTokensParams = {
claimId: string;
};

export type GetAccessTokens200Data = {
  items?: AccessToken[];
};

export type GetAccessTokens200 = {
  data?: GetAccessTokens200Data;
};

export type CreateAccessTokenBodyRole = typeof CreateAccessTokenBodyRole[keyof typeof CreateAccessTokenBodyRole];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateAccessTokenBodyRole = {
  auditor: 'auditor',
  advisor: 'advisor',
  due_diligence: 'due_diligence',
} as const;

export type CreateAccessTokenBody = {
  claimId: string;
  role: CreateAccessTokenBodyRole;
  label?: string;
  expiresAt: string;
};

export type CreateAccessToken201 = {
  data?: AccessToken;
};

export type RevokeAccessTokenBody = {
  claimId?: string;
};

export type RevokeAccessToken200 = {
  data?: AccessToken;
};

export type GetClaimAccessGrantsParams = {
claimId: string;
};

export type GetClaimAccessGrants200Data = {
  items?: ClaimAccessGrant[];
};

export type GetClaimAccessGrants200 = {
  data?: GetClaimAccessGrants200Data;
};

export type CreateClaimAccessGrantBodyRole = typeof CreateClaimAccessGrantBodyRole[keyof typeof CreateClaimAccessGrantBodyRole];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateClaimAccessGrantBodyRole = {
  auditor: 'auditor',
  advisor: 'advisor',
  due_diligence: 'due_diligence',
} as const;

export type CreateClaimAccessGrantBody = {
  claimId: string;
  email: string;
  role: CreateClaimAccessGrantBodyRole;
  expiresAt: string;
};

export type CreateClaimAccessGrant201 = {
  data?: ClaimAccessGrant;
};

export type RevokeClaimAccessGrant200 = {
  data?: ClaimAccessGrant;
};

export type GetReviewerClaims200Data = {
  items?: ReviewerClaimGrant[];
};

export type GetReviewerClaims200 = {
  data?: GetReviewerClaims200Data;
};

export type GetAuditLogParams = {
entityType?: string;
actionPrefix?: string;
page?: number;
limit?: number;
};

export type GetAuditLog200Data = {
  items?: AuditLogEntry[];
  pagination?: Pagination;
};

export type GetAuditLog200 = {
  data?: GetAuditLog200Data;
};

export type GetLinksParams = {
sourceId?: string;
targetId?: string;
};

export type GetLinks200Data = {
  items?: ArtefactLink[];
};

export type GetLinks200 = {
  data?: GetLinks200Data;
};

export type CreateLinkBody = {
  sourceId: string;
  targetId: string;
  linkType: string;
};

export type CreateLink201 = {
  data?: ArtefactLink;
};

export type GetExpenditureSummaryParams = {
incomeYear: string;
};

export type GetExpenditureSummary200 = {
  data?: ExpenditureSummary;
};

export type GetExpenditureLineItemsParams = {
incomeYear: string;
provider?: string;
category?: string;
projectId?: string;
search?: string;
page?: number;
limit?: number;
};

export type GetExpenditureLineItems200Data = {
  items?: CostAllocation[];
  pagination?: Pagination;
};

export type GetExpenditureLineItems200 = {
  data?: GetExpenditureLineItems200Data;
};

export type SyncExpenditureProvider200Data = {
  created: number;
  updated: number;
  unchanged: number;
  rows: number;
  /** Non-fatal partial-sync warnings (e.g. AWS Cost Explorer declined months older than its ~14-month retention window) — the sync succeeded for the remaining data */
  warnings?: string[];
};

export type SyncExpenditureProvider200 = {
  data?: SyncExpenditureProvider200Data;
};

export type GetExpenditureAccounts200 = {
  data?: ExpenditureAccount[];
};

export type GetExpenditureOverrides200 = {
  data?: ProjectCostOverride[];
};

export type UpsertExpenditureOverrideBody = {
  provider: string;
  externalId: string;
  projectId: string;
  label?: string;
};

export type UpsertExpenditureOverride200 = {
  data?: ProjectCostOverride;
};

export type GetOverheadApportionmentParams = {
incomeYear: string;
/**
 * Claim mode used to compute the reconciliation ratio. When omitted, resolves to the active claim mode for the income year (the latest claim's stored claim_mode), falling back to business_hours when no claim exists.
 */
mode?: string;
};

export type GetOverheadApportionment200 = {
  data?: ApportionmentView;
};

export type SetOverheadApportionmentParams = {
incomeYear: string;
/**
 * Claim mode used to compute the reconciliation ratio. When omitted, resolves to the active claim mode for the income year (the latest claim's stored claim_mode), falling back to business_hours when no claim exists.
 */
mode?: string;
};

export type SetOverheadApportionmentBodyMode = typeof SetOverheadApportionmentBodyMode[keyof typeof SetOverheadApportionmentBodyMode];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SetOverheadApportionmentBodyMode = {
  manual: 'manual',
  computed: 'computed',
  custom: 'custom',
} as const;

export type SetOverheadApportionmentBody = {
  mode: SetOverheadApportionmentBodyMode;
  /**
   * Required (with customReason) when mode is custom
   * @minimum 0
   * @maximum 100
   */
  customPercent?: number;
  /**
   * Required (with customPercent) when mode is custom
   * @minLength 1
   */
  customReason?: string;
};

export type SetOverheadApportionment200 = {
  data?: ApportionmentView;
};

export type GetCostCandidatesParams = {
incomeYear: string;
status?: GetCostCandidatesStatus;
};

export type GetCostCandidatesStatus = typeof GetCostCandidatesStatus[keyof typeof GetCostCandidatesStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetCostCandidatesStatus = {
  pending: 'pending',
  approved: 'approved',
  dismissed: 'dismissed',
} as const;

export type GetCostCandidates200Data = {
  items?: XeroCostCandidate[];
};

export type GetCostCandidates200 = {
  data?: GetCostCandidates200Data;
};

export type RefreshCostCandidatesBody = {
  incomeYear: string;
};

export type RefreshCostCandidates200Data = {
  created: number;
  /** payroll/on-cost accounts firewalled — never candidates */
  skippedPayroll: number;
  /** tuples that already had a candidate of any status (incl. dismissed) */
  skippedExisting: number;
  /** income/subtotal P&L lines firewalled — income is never a cost */
  skippedIncome: number;
};

export type RefreshCostCandidates200 = {
  data?: RefreshCostCandidates200Data;
};

export type ApproveCostCandidateBodyCategory = typeof ApproveCostCandidateBodyCategory[keyof typeof ApproveCostCandidateBodyCategory];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ApproveCostCandidateBodyCategory = {
  cloud: 'cloud',
  llm_tokens: 'llm_tokens',
  software_license: 'software_license',
  hardware: 'hardware',
  other: 'other',
  admin_overhead: 'admin_overhead',
  software_subscription: 'software_subscription',
  insurance: 'insurance',
  consultant_fees: 'consultant_fees',
  company_setup: 'company_setup',
  rdti_claim_prep: 'rdti_claim_prep',
} as const;

export type ApproveCostCandidateBodyEligibilityStatus = typeof ApproveCostCandidateBodyEligibilityStatus[keyof typeof ApproveCostCandidateBodyEligibilityStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ApproveCostCandidateBodyEligibilityStatus = {
  claimable: 'claimable',
  excluded: 'excluded',
  needs_review: 'needs_review',
} as const;

export type ApproveCostCandidateBody = {
  category?: ApproveCostCandidateBodyCategory;
  /**
   * @minimum 0
   * @maximum 100
   */
  claimablePercent?: number;
  eligibilityStatus?: ApproveCostCandidateBodyEligibilityStatus;
  /** @maxLength 2000 */
  eligibilityReason?: string;
  projectId?: string;
};

export type ApproveCostCandidate201Data = {
  candidate: XeroCostCandidate;
  allocation: CostAllocation;
};

export type ApproveCostCandidate201 = {
  data: ApproveCostCandidate201Data;
  /** Top-level sibling of data — present only when the candidate's vendor overlaps an API-synced allocation for the same period (possible double-count) */
  warnings?: string[];
};

export type DismissCostCandidateBody = {
  /**
   * @minLength 1
   * @maxLength 2000
   */
  reason: string;
};

export type DismissCostCandidate200 = {
  data?: XeroCostCandidate;
};

export type GetMyActivityParams = {
range?: GetMyActivityRange;
};

export type GetMyActivityRange = typeof GetMyActivityRange[keyof typeof GetMyActivityRange];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetMyActivityRange = {
  week: 'week',
  fortnight: 'fortnight',
} as const;

export type GetMyActivity200 = {
  data?: DeveloperActivity;
};

export type GetWeeklyRecapDraftParams = {
/**
 * @pattern ^\d{4}-\d{2}-\d{2}$
 */
weekStart: string;
refresh?: boolean;
};

export type GetWeeklyRecapDraft200 = {
  data?: DeveloperWeeklyRecapDraftResponse;
};

export type GetWeeklyRecapParams = {
/**
 * @pattern ^\d{4}-\d{2}-\d{2}$
 */
weekStart: string;
};

export type GetWeeklyRecap200 = {
  data?: DeveloperWeeklyRecap;
};

export type PutWeeklyRecapBodyStatus = typeof PutWeeklyRecapBodyStatus[keyof typeof PutWeeklyRecapBodyStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PutWeeklyRecapBodyStatus = {
  pending: 'pending',
  confirmed: 'confirmed',
  edited: 'edited',
} as const;

export type PutWeeklyRecapBody = {
  /** @pattern ^\d{4}-\d{2}-\d{2}$ */
  weekStart: string;
  notes: DeveloperRecapNote[];
  projectContext?: string[];
  status?: PutWeeklyRecapBodyStatus;
};

export type PutWeeklyRecap200 = {
  data?: DeveloperWeeklyRecap;
};

type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;




/**
 * @summary Move a work bucket between R&D and non-R&D columns
 */
export const patchBucket = (
    id: string,
    patchBucketBody: PatchBucketBody,
 ) => {
      
      
      return customInstance<PatchBucket200>(
      {url: `/api/buckets/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchBucketBody
    },
      );
    }
  


export const getPatchBucketMutationOptions = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchBucket>>, TError,{id: string;data: PatchBucketBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patchBucket>>, TError,{id: string;data: PatchBucketBody}, TContext> => {

const mutationKey = ['patchBucket'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchBucket>>, {id: string;data: PatchBucketBody}> = (props) => {
          const {id,data} = props ?? {};

          return  patchBucket(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatchBucketMutationResult = NonNullable<Awaited<ReturnType<typeof patchBucket>>>
    export type PatchBucketMutationBody = PatchBucketBody
    export type PatchBucketMutationError = Error

    /**
 * @summary Move a work bucket between R&D and non-R&D columns
 */
export const usePatchBucket = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchBucket>>, TError,{id: string;data: PatchBucketBody}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof patchBucket>>,
        TError,
        {id: string;data: PatchBucketBody},
        TContext
      > => {

      const mutationOptions = getPatchBucketMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary List GitHub contributors for a project's tenant
 */
export const getProjectContributors = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetProjectContributors200>(
      {url: `/api/projects/${id}/contributors`, method: 'GET', signal
    },
      );
    }
  



export const getGetProjectContributorsQueryKey = (id?: string,) => {
    return [
    `/api/projects/${id}/contributors`
    ] as const;
    }

    
export const getGetProjectContributorsQueryOptions = <TData = Awaited<ReturnType<typeof getProjectContributors>>, TError = unknown>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getProjectContributors>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProjectContributorsQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProjectContributors>>> = ({ signal }) => getProjectContributors(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getProjectContributors>>, TError, TData> & { queryKey: QueryKey }
}

export type GetProjectContributorsQueryResult = NonNullable<Awaited<ReturnType<typeof getProjectContributors>>>
export type GetProjectContributorsQueryError = unknown


/**
 * @summary List GitHub contributors for a project's tenant
 */

export function useGetProjectContributors<TData = Awaited<ReturnType<typeof getProjectContributors>>, TError = unknown>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getProjectContributors>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetProjectContributorsQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * @summary Verify a contributor's employment type
 */
export const verifyContributor = (
    id: string,
    contributorId: string,
    verifyContributorBody: VerifyContributorBody,
 ) => {
      
      
      return customInstance<VerifyContributor200>(
      {url: `/api/projects/${id}/contributors/${contributorId}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: verifyContributorBody
    },
      );
    }
  


export const getVerifyContributorMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof verifyContributor>>, TError,{id: string;contributorId: string;data: VerifyContributorBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof verifyContributor>>, TError,{id: string;contributorId: string;data: VerifyContributorBody}, TContext> => {

const mutationKey = ['verifyContributor'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof verifyContributor>>, {id: string;contributorId: string;data: VerifyContributorBody}> = (props) => {
          const {id,contributorId,data} = props ?? {};

          return  verifyContributor(id,contributorId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type VerifyContributorMutationResult = NonNullable<Awaited<ReturnType<typeof verifyContributor>>>
    export type VerifyContributorMutationBody = VerifyContributorBody
    export type VerifyContributorMutationError = unknown

    /**
 * @summary Verify a contributor's employment type
 */
export const useVerifyContributor = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof verifyContributor>>, TError,{id: string;contributorId: string;data: VerifyContributorBody}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof verifyContributor>>,
        TError,
        {id: string;contributorId: string;data: VerifyContributorBody},
        TContext
      > => {

      const mutationOptions = getVerifyContributorMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary List AI-suggested activity themes for a project
 */
export const getProjectSuggestedActivities = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetProjectSuggestedActivities200>(
      {url: `/api/projects/${id}/suggested-activities`, method: 'GET', signal
    },
      );
    }
  



export const getGetProjectSuggestedActivitiesQueryKey = (id?: string,) => {
    return [
    `/api/projects/${id}/suggested-activities`
    ] as const;
    }

    
export const getGetProjectSuggestedActivitiesQueryOptions = <TData = Awaited<ReturnType<typeof getProjectSuggestedActivities>>, TError = unknown>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getProjectSuggestedActivities>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProjectSuggestedActivitiesQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProjectSuggestedActivities>>> = ({ signal }) => getProjectSuggestedActivities(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getProjectSuggestedActivities>>, TError, TData> & { queryKey: QueryKey }
}

export type GetProjectSuggestedActivitiesQueryResult = NonNullable<Awaited<ReturnType<typeof getProjectSuggestedActivities>>>
export type GetProjectSuggestedActivitiesQueryError = unknown


/**
 * @summary List AI-suggested activity themes for a project
 */

export function useGetProjectSuggestedActivities<TData = Awaited<ReturnType<typeof getProjectSuggestedActivities>>, TError = unknown>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getProjectSuggestedActivities>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetProjectSuggestedActivitiesQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * @summary Dismiss a suggested activity
 */
export const dismissSuggestedActivity = (
    id: string,
    suggestionId: string,
    dismissSuggestedActivityBody: DismissSuggestedActivityBody,
 signal?: AbortSignal
) => {
      
      
      return customInstance<DismissSuggestedActivity200>(
      {url: `/api/projects/${id}/suggested-activities/${suggestionId}`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: dismissSuggestedActivityBody, signal
    },
      );
    }
  


export const getDismissSuggestedActivityMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof dismissSuggestedActivity>>, TError,{id: string;suggestionId: string;data: DismissSuggestedActivityBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof dismissSuggestedActivity>>, TError,{id: string;suggestionId: string;data: DismissSuggestedActivityBody}, TContext> => {

const mutationKey = ['dismissSuggestedActivity'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof dismissSuggestedActivity>>, {id: string;suggestionId: string;data: DismissSuggestedActivityBody}> = (props) => {
          const {id,suggestionId,data} = props ?? {};

          return  dismissSuggestedActivity(id,suggestionId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DismissSuggestedActivityMutationResult = NonNullable<Awaited<ReturnType<typeof dismissSuggestedActivity>>>
    export type DismissSuggestedActivityMutationBody = DismissSuggestedActivityBody
    export type DismissSuggestedActivityMutationError = unknown

    /**
 * @summary Dismiss a suggested activity
 */
export const useDismissSuggestedActivity = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof dismissSuggestedActivity>>, TError,{id: string;suggestionId: string;data: DismissSuggestedActivityBody}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof dismissSuggestedActivity>>,
        TError,
        {id: string;suggestionId: string;data: DismissSuggestedActivityBody},
        TContext
      > => {

      const mutationOptions = getDismissSuggestedActivityMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary List all users in tenant
 */
export const getUsers = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetUsers200>(
      {url: `/api/users`, method: 'GET', signal
    },
      );
    }
  



export const getGetUsersQueryKey = () => {
    return [
    `/api/users`
    ] as const;
    }

    
export const getGetUsersQueryOptions = <TData = Awaited<ReturnType<typeof getUsers>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUsers>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUsersQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUsers>>> = ({ signal }) => getUsers(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUsers>>, TError, TData> & { queryKey: QueryKey }
}

export type GetUsersQueryResult = NonNullable<Awaited<ReturnType<typeof getUsers>>>
export type GetUsersQueryError = unknown


/**
 * @summary List all users in tenant
 */

export function useGetUsers<TData = Awaited<ReturnType<typeof getUsers>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUsers>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetUsersQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * @summary Update a user's role
 */
export const patchUserRole = (
    id: string,
    patchUserRoleBody: PatchUserRoleBody,
 ) => {
      
      
      return customInstance<PatchUserRole200>(
      {url: `/api/users/${id}/role`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchUserRoleBody
    },
      );
    }
  


export const getPatchUserRoleMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchUserRole>>, TError,{id: string;data: PatchUserRoleBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patchUserRole>>, TError,{id: string;data: PatchUserRoleBody}, TContext> => {

const mutationKey = ['patchUserRole'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchUserRole>>, {id: string;data: PatchUserRoleBody}> = (props) => {
          const {id,data} = props ?? {};

          return  patchUserRole(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatchUserRoleMutationResult = NonNullable<Awaited<ReturnType<typeof patchUserRole>>>
    export type PatchUserRoleMutationBody = PatchUserRoleBody
    export type PatchUserRoleMutationError = unknown

    /**
 * @summary Update a user's role
 */
export const usePatchUserRole = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchUserRole>>, TError,{id: string;data: PatchUserRoleBody}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof patchUserRole>>,
        TError,
        {id: string;data: PatchUserRoleBody},
        TContext
      > => {

      const mutationOptions = getPatchUserRoleMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary List time entries (filterable by reviewStatus/status, project)
 */
export const getTimeEntries = (
    params?: GetTimeEntriesParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetTimeEntries200>(
      {url: `/api/time-entries`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getGetTimeEntriesQueryKey = (params?: GetTimeEntriesParams,) => {
    return [
    `/api/time-entries`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetTimeEntriesQueryOptions = <TData = Awaited<ReturnType<typeof getTimeEntries>>, TError = unknown>(params?: GetTimeEntriesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTimeEntries>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTimeEntriesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTimeEntries>>> = ({ signal }) => getTimeEntries(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTimeEntries>>, TError, TData> & { queryKey: QueryKey }
}

export type GetTimeEntriesQueryResult = NonNullable<Awaited<ReturnType<typeof getTimeEntries>>>
export type GetTimeEntriesQueryError = unknown


/**
 * @summary List time entries (filterable by reviewStatus/status, project)
 */

export function useGetTimeEntries<TData = Awaited<ReturnType<typeof getTimeEntries>>, TError = unknown>(
 params?: GetTimeEntriesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTimeEntries>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetTimeEntriesQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * @summary Approve a time entry
 */
export const approveTimeEntry = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<ApproveTimeEntry200>(
      {url: `/api/time-entries/${id}/approve`, method: 'POST', signal
    },
      );
    }
  


export const getApproveTimeEntryMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof approveTimeEntry>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof approveTimeEntry>>, TError,{id: string}, TContext> => {

const mutationKey = ['approveTimeEntry'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof approveTimeEntry>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  approveTimeEntry(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ApproveTimeEntryMutationResult = NonNullable<Awaited<ReturnType<typeof approveTimeEntry>>>
    
    export type ApproveTimeEntryMutationError = unknown

    /**
 * @summary Approve a time entry
 */
export const useApproveTimeEntry = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof approveTimeEntry>>, TError,{id: string}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof approveTimeEntry>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getApproveTimeEntryMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Reject a time entry
 */
export const rejectTimeEntry = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<RejectTimeEntry200>(
      {url: `/api/time-entries/${id}/reject`, method: 'POST', signal
    },
      );
    }
  


export const getRejectTimeEntryMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof rejectTimeEntry>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof rejectTimeEntry>>, TError,{id: string}, TContext> => {

const mutationKey = ['rejectTimeEntry'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof rejectTimeEntry>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  rejectTimeEntry(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type RejectTimeEntryMutationResult = NonNullable<Awaited<ReturnType<typeof rejectTimeEntry>>>
    
    export type RejectTimeEntryMutationError = unknown

    /**
 * @summary Reject a time entry
 */
export const useRejectTimeEntry = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof rejectTimeEntry>>, TError,{id: string}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof rejectTimeEntry>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getRejectTimeEntryMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Undo a rejection — moves rejected entry back to pending
 */
export const undoTimeEntryRejection = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<UndoTimeEntryRejection200>(
      {url: `/api/time-entries/${id}/undo-rejection`, method: 'POST', signal
    },
      );
    }
  


export const getUndoTimeEntryRejectionMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof undoTimeEntryRejection>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof undoTimeEntryRejection>>, TError,{id: string}, TContext> => {

const mutationKey = ['undoTimeEntryRejection'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof undoTimeEntryRejection>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  undoTimeEntryRejection(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UndoTimeEntryRejectionMutationResult = NonNullable<Awaited<ReturnType<typeof undoTimeEntryRejection>>>
    
    export type UndoTimeEntryRejectionMutationError = void

    /**
 * @summary Undo a rejection — moves rejected entry back to pending
 */
export const useUndoTimeEntryRejection = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof undoTimeEntryRejection>>, TError,{id: string}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof undoTimeEntryRejection>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getUndoTimeEntryRejectionMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Bulk approve eligible time entries
 */
export const bulkApproveTimeEntries = (
    bulkApproveTimeEntriesBody: BulkApproveTimeEntriesBody,
 signal?: AbortSignal
) => {
      
      
      return customInstance<BulkApproveTimeEntries200>(
      {url: `/api/time-entries/bulk-approve`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: bulkApproveTimeEntriesBody, signal
    },
      );
    }
  


export const getBulkApproveTimeEntriesMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof bulkApproveTimeEntries>>, TError,{data: BulkApproveTimeEntriesBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof bulkApproveTimeEntries>>, TError,{data: BulkApproveTimeEntriesBody}, TContext> => {

const mutationKey = ['bulkApproveTimeEntries'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof bulkApproveTimeEntries>>, {data: BulkApproveTimeEntriesBody}> = (props) => {
          const {data} = props ?? {};

          return  bulkApproveTimeEntries(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type BulkApproveTimeEntriesMutationResult = NonNullable<Awaited<ReturnType<typeof bulkApproveTimeEntries>>>
    export type BulkApproveTimeEntriesMutationBody = BulkApproveTimeEntriesBody
    export type BulkApproveTimeEntriesMutationError = unknown

    /**
 * @summary Bulk approve eligible time entries
 */
export const useBulkApproveTimeEntries = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof bulkApproveTimeEntries>>, TError,{data: BulkApproveTimeEntriesBody}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof bulkApproveTimeEntries>>,
        TError,
        {data: BulkApproveTimeEntriesBody},
        TContext
      > => {

      const mutationOptions = getBulkApproveTimeEntriesMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Monthly R&D expenditure breakdown (labour + non-labour) for an income year
 */
export const getExpenditureTimeline = (
    params: GetExpenditureTimelineParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetExpenditureTimeline200>(
      {url: `/api/dashboard/expenditure-timeline`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getGetExpenditureTimelineQueryKey = (params?: GetExpenditureTimelineParams,) => {
    return [
    `/api/dashboard/expenditure-timeline`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetExpenditureTimelineQueryOptions = <TData = Awaited<ReturnType<typeof getExpenditureTimeline>>, TError = unknown>(params: GetExpenditureTimelineParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getExpenditureTimeline>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetExpenditureTimelineQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getExpenditureTimeline>>> = ({ signal }) => getExpenditureTimeline(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getExpenditureTimeline>>, TError, TData> & { queryKey: QueryKey }
}

export type GetExpenditureTimelineQueryResult = NonNullable<Awaited<ReturnType<typeof getExpenditureTimeline>>>
export type GetExpenditureTimelineQueryError = unknown


/**
 * @summary Monthly R&D expenditure breakdown (labour + non-labour) for an income year
 */

export function useGetExpenditureTimeline<TData = Awaited<ReturnType<typeof getExpenditureTimeline>>, TError = unknown>(
 params: GetExpenditureTimelineParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getExpenditureTimeline>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetExpenditureTimelineQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * @summary Per-project R&D labour with 7.6h/day cap and weekend exclusion
 */
export const getLabourReport = (
    params: GetLabourReportParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetLabourReport200>(
      {url: `/api/dashboard/labour-report`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getGetLabourReportQueryKey = (params?: GetLabourReportParams,) => {
    return [
    `/api/dashboard/labour-report`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetLabourReportQueryOptions = <TData = Awaited<ReturnType<typeof getLabourReport>>, TError = unknown>(params: GetLabourReportParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getLabourReport>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLabourReportQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLabourReport>>> = ({ signal }) => getLabourReport(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLabourReport>>, TError, TData> & { queryKey: QueryKey }
}

export type GetLabourReportQueryResult = NonNullable<Awaited<ReturnType<typeof getLabourReport>>>
export type GetLabourReportQueryError = unknown


/**
 * @summary Per-project R&D labour with 7.6h/day cap and weekend exclusion
 */

export function useGetLabourReport<TData = Awaited<ReturnType<typeof getLabourReport>>, TError = unknown>(
 params: GetLabourReportParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getLabourReport>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetLabourReportQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Returns how recorded R&D work time is spread across the seven standard software-development stages, derived from stored work-bucket SDLC tags. Optional projectId scopes to a single project; omit for the tenant-wide FY view. Hours are the buckets' weighted share of RAW recorded duration (indicative) — NOT the capped/mode-weighted claim figures.

 * @summary SDLC-stage coverage of recorded R&D work time (from stored work-bucket tags)
 */
export const getDashboardSdlc = (
    params: GetDashboardSdlcParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetDashboardSdlc200>(
      {url: `/api/dashboard/sdlc`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getGetDashboardSdlcQueryKey = (params?: GetDashboardSdlcParams,) => {
    return [
    `/api/dashboard/sdlc`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetDashboardSdlcQueryOptions = <TData = Awaited<ReturnType<typeof getDashboardSdlc>>, TError = unknown>(params: GetDashboardSdlcParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getDashboardSdlc>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDashboardSdlcQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDashboardSdlc>>> = ({ signal }) => getDashboardSdlc(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDashboardSdlc>>, TError, TData> & { queryKey: QueryKey }
}

export type GetDashboardSdlcQueryResult = NonNullable<Awaited<ReturnType<typeof getDashboardSdlc>>>
export type GetDashboardSdlcQueryError = unknown


/**
 * @summary SDLC-stage coverage of recorded R&D work time (from stored work-bucket tags)
 */

export function useGetDashboardSdlc<TData = Awaited<ReturnType<typeof getDashboardSdlc>>, TError = unknown>(
 params: GetDashboardSdlcParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getDashboardSdlc>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetDashboardSdlcQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * @summary List grants with optional status/source/state filter
 */
export const listGrants = (
    params?: ListGrantsParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<ListGrants200>(
      {url: `/api/grants`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getListGrantsQueryKey = (params?: ListGrantsParams,) => {
    return [
    `/api/grants`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getListGrantsQueryOptions = <TData = Awaited<ReturnType<typeof listGrants>>, TError = unknown>(params?: ListGrantsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listGrants>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListGrantsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listGrants>>> = ({ signal }) => listGrants(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listGrants>>, TError, TData> & { queryKey: QueryKey }
}

export type ListGrantsQueryResult = NonNullable<Awaited<ReturnType<typeof listGrants>>>
export type ListGrantsQueryError = unknown


/**
 * @summary List grants with optional status/source/state filter
 */

export function useListGrants<TData = Awaited<ReturnType<typeof listGrants>>, TError = unknown>(
 params?: ListGrantsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listGrants>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListGrantsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * @summary Get tenant organisation profile (used for grant application aid)
 */
export const getOrgProfile = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetOrgProfile200>(
      {url: `/api/grants/org-profile`, method: 'GET', signal
    },
      );
    }
  



export const getGetOrgProfileQueryKey = () => {
    return [
    `/api/grants/org-profile`
    ] as const;
    }

    
export const getGetOrgProfileQueryOptions = <TData = Awaited<ReturnType<typeof getOrgProfile>>, TError = void>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getOrgProfile>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOrgProfileQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrgProfile>>> = ({ signal }) => getOrgProfile(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOrgProfile>>, TError, TData> & { queryKey: QueryKey }
}

export type GetOrgProfileQueryResult = NonNullable<Awaited<ReturnType<typeof getOrgProfile>>>
export type GetOrgProfileQueryError = void


/**
 * @summary Get tenant organisation profile (used for grant application aid)
 */

export function useGetOrgProfile<TData = Awaited<ReturnType<typeof getOrgProfile>>, TError = void>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getOrgProfile>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetOrgProfileQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * @summary Create or update tenant org profile
 */
export const upsertOrgProfile = (
    upsertOrgProfileBody: UpsertOrgProfileBody,
 ) => {
      
      
      return customInstance<UpsertOrgProfile200>(
      {url: `/api/grants/org-profile`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: upsertOrgProfileBody
    },
      );
    }
  


export const getUpsertOrgProfileMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof upsertOrgProfile>>, TError,{data: UpsertOrgProfileBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof upsertOrgProfile>>, TError,{data: UpsertOrgProfileBody}, TContext> => {

const mutationKey = ['upsertOrgProfile'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof upsertOrgProfile>>, {data: UpsertOrgProfileBody}> = (props) => {
          const {data} = props ?? {};

          return  upsertOrgProfile(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpsertOrgProfileMutationResult = NonNullable<Awaited<ReturnType<typeof upsertOrgProfile>>>
    export type UpsertOrgProfileMutationBody = UpsertOrgProfileBody
    export type UpsertOrgProfileMutationError = unknown

    /**
 * @summary Create or update tenant org profile
 */
export const useUpsertOrgProfile = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof upsertOrgProfile>>, TError,{data: UpsertOrgProfileBody}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof upsertOrgProfile>>,
        TError,
        {data: UpsertOrgProfileBody},
        TContext
      > => {

      const mutationOptions = getUpsertOrgProfileMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Get tenant grant config
 */
export const getGrantConfig = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetGrantConfig200>(
      {url: `/api/grants/config`, method: 'GET', signal
    },
      );
    }
  



export const getGetGrantConfigQueryKey = () => {
    return [
    `/api/grants/config`
    ] as const;
    }

    
export const getGetGrantConfigQueryOptions = <TData = Awaited<ReturnType<typeof getGrantConfig>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getGrantConfig>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetGrantConfigQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getGrantConfig>>> = ({ signal }) => getGrantConfig(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getGrantConfig>>, TError, TData> & { queryKey: QueryKey }
}

export type GetGrantConfigQueryResult = NonNullable<Awaited<ReturnType<typeof getGrantConfig>>>
export type GetGrantConfigQueryError = unknown


/**
 * @summary Get tenant grant config
 */

export function useGetGrantConfig<TData = Awaited<ReturnType<typeof getGrantConfig>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getGrantConfig>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetGrantConfigQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * @summary Update grant config (prompts, watched lists)
 */
export const updateGrantConfig = (
    updateGrantConfigBody: UpdateGrantConfigBody,
 ) => {
      
      
      return customInstance<UpdateGrantConfig200>(
      {url: `/api/grants/config`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateGrantConfigBody
    },
      );
    }
  


export const getUpdateGrantConfigMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateGrantConfig>>, TError,{data: UpdateGrantConfigBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateGrantConfig>>, TError,{data: UpdateGrantConfigBody}, TContext> => {

const mutationKey = ['updateGrantConfig'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateGrantConfig>>, {data: UpdateGrantConfigBody}> = (props) => {
          const {data} = props ?? {};

          return  updateGrantConfig(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateGrantConfigMutationResult = NonNullable<Awaited<ReturnType<typeof updateGrantConfig>>>
    export type UpdateGrantConfigMutationBody = UpdateGrantConfigBody
    export type UpdateGrantConfigMutationError = unknown

    /**
 * @summary Update grant config (prompts, watched lists)
 */
export const useUpdateGrantConfig = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateGrantConfig>>, TError,{data: UpdateGrantConfigBody}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateGrantConfig>>,
        TError,
        {data: UpdateGrantConfigBody},
        TContext
      > => {

      const mutationOptions = getUpdateGrantConfigMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Trigger manual sync of all grant sources
 */
export const triggerGrantSync = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/grants/sync`, method: 'POST', signal
    },
      );
    }
  


export const getTriggerGrantSyncMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof triggerGrantSync>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof triggerGrantSync>>, TError,void, TContext> => {

const mutationKey = ['triggerGrantSync'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof triggerGrantSync>>, void> = () => {
          

          return  triggerGrantSync()
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type TriggerGrantSyncMutationResult = NonNullable<Awaited<ReturnType<typeof triggerGrantSync>>>
    
    export type TriggerGrantSyncMutationError = unknown

    /**
 * @summary Trigger manual sync of all grant sources
 */
export const useTriggerGrantSync = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof triggerGrantSync>>, TError,void, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof triggerGrantSync>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getTriggerGrantSyncMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Get grant detail
 */
export const getGrant = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetGrant200>(
      {url: `/api/grants/${id}`, method: 'GET', signal
    },
      );
    }
  



export const getGetGrantQueryKey = (id?: string,) => {
    return [
    `/api/grants/${id}`
    ] as const;
    }

    
export const getGetGrantQueryOptions = <TData = Awaited<ReturnType<typeof getGrant>>, TError = void>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getGrant>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetGrantQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getGrant>>> = ({ signal }) => getGrant(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getGrant>>, TError, TData> & { queryKey: QueryKey }
}

export type GetGrantQueryResult = NonNullable<Awaited<ReturnType<typeof getGrant>>>
export type GetGrantQueryError = void


/**
 * @summary Get grant detail
 */

export function useGetGrant<TData = Awaited<ReturnType<typeof getGrant>>, TError = void>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getGrant>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetGrantQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * @summary Get existing application aid for a grant
 */
export const getApplicationAid = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetApplicationAid200>(
      {url: `/api/grants/${id}/application-aid`, method: 'GET', signal
    },
      );
    }
  



export const getGetApplicationAidQueryKey = (id?: string,) => {
    return [
    `/api/grants/${id}/application-aid`
    ] as const;
    }

    
export const getGetApplicationAidQueryOptions = <TData = Awaited<ReturnType<typeof getApplicationAid>>, TError = void>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApplicationAid>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApplicationAidQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApplicationAid>>> = ({ signal }) => getApplicationAid(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApplicationAid>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApplicationAidQueryResult = NonNullable<Awaited<ReturnType<typeof getApplicationAid>>>
export type GetApplicationAidQueryError = void


/**
 * @summary Get existing application aid for a grant
 */

export function useGetApplicationAid<TData = Awaited<ReturnType<typeof getApplicationAid>>, TError = void>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApplicationAid>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApplicationAidQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * @summary Generate (or regenerate) application aid using Claude
 */
export const generateApplicationAid = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GenerateApplicationAid200>(
      {url: `/api/grants/${id}/application-aid`, method: 'POST', signal
    },
      );
    }
  


export const getGenerateApplicationAidMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof generateApplicationAid>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof generateApplicationAid>>, TError,{id: string}, TContext> => {

const mutationKey = ['generateApplicationAid'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof generateApplicationAid>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  generateApplicationAid(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type GenerateApplicationAidMutationResult = NonNullable<Awaited<ReturnType<typeof generateApplicationAid>>>
    
    export type GenerateApplicationAidMutationError = void

    /**
 * @summary Generate (or regenerate) application aid using Claude
 */
export const useGenerateApplicationAid = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof generateApplicationAid>>, TError,{id: string}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof generateApplicationAid>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getGenerateApplicationAidMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary AI triage — answer from guides, gather bug/feature info, or submit report
 */
export const postHelpChat = (
    postHelpChatBody: PostHelpChatBody,
 signal?: AbortSignal
) => {
      
      
      return customInstance<PostHelpChat200>(
      {url: `/api/help/chat`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postHelpChatBody, signal
    },
      );
    }
  


export const getPostHelpChatMutationOptions = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postHelpChat>>, TError,{data: PostHelpChatBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postHelpChat>>, TError,{data: PostHelpChatBody}, TContext> => {

const mutationKey = ['postHelpChat'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postHelpChat>>, {data: PostHelpChatBody}> = (props) => {
          const {data} = props ?? {};

          return  postHelpChat(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostHelpChatMutationResult = NonNullable<Awaited<ReturnType<typeof postHelpChat>>>
    export type PostHelpChatMutationBody = PostHelpChatBody
    export type PostHelpChatMutationError = Error

    /**
 * @summary AI triage — answer from guides, gather bug/feature info, or submit report
 */
export const usePostHelpChat = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postHelpChat>>, TError,{data: PostHelpChatBody}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof postHelpChat>>,
        TError,
        {data: PostHelpChatBody},
        TContext
      > => {

      const mutationOptions = getPostHelpChatMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary List feedback submissions (tenant-scoped)
 */
export const listFeedback = (
    params?: ListFeedbackParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<ListFeedback200>(
      {url: `/api/help/feedback`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getListFeedbackQueryKey = (params?: ListFeedbackParams,) => {
    return [
    `/api/help/feedback`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getListFeedbackQueryOptions = <TData = Awaited<ReturnType<typeof listFeedback>>, TError = unknown>(params?: ListFeedbackParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listFeedback>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListFeedbackQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listFeedback>>> = ({ signal }) => listFeedback(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listFeedback>>, TError, TData> & { queryKey: QueryKey }
}

export type ListFeedbackQueryResult = NonNullable<Awaited<ReturnType<typeof listFeedback>>>
export type ListFeedbackQueryError = unknown


/**
 * @summary List feedback submissions (tenant-scoped)
 */

export function useListFeedback<TData = Awaited<ReturnType<typeof listFeedback>>, TError = unknown>(
 params?: ListFeedbackParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listFeedback>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListFeedbackQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * @summary Submit a bug report or feature request
 */
export const createFeedback = (
    createFeedbackBody: CreateFeedbackBody,
 signal?: AbortSignal
) => {
      
      
      return customInstance<CreateFeedback201>(
      {url: `/api/help/feedback`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createFeedbackBody, signal
    },
      );
    }
  


export const getCreateFeedbackMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createFeedback>>, TError,{data: CreateFeedbackBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createFeedback>>, TError,{data: CreateFeedbackBody}, TContext> => {

const mutationKey = ['createFeedback'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createFeedback>>, {data: CreateFeedbackBody}> = (props) => {
          const {data} = props ?? {};

          return  createFeedback(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateFeedbackMutationResult = NonNullable<Awaited<ReturnType<typeof createFeedback>>>
    export type CreateFeedbackMutationBody = CreateFeedbackBody
    export type CreateFeedbackMutationError = unknown

    /**
 * @summary Submit a bug report or feature request
 */
export const useCreateFeedback = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createFeedback>>, TError,{data: CreateFeedbackBody}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof createFeedback>>,
        TError,
        {data: CreateFeedbackBody},
        TContext
      > => {

      const mutationOptions = getCreateFeedbackMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Get feedback item with comments
 */
export const getFeedback = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetFeedback200>(
      {url: `/api/help/feedback/${id}`, method: 'GET', signal
    },
      );
    }
  



export const getGetFeedbackQueryKey = (id?: string,) => {
    return [
    `/api/help/feedback/${id}`
    ] as const;
    }

    
export const getGetFeedbackQueryOptions = <TData = Awaited<ReturnType<typeof getFeedback>>, TError = unknown>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getFeedback>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetFeedbackQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getFeedback>>> = ({ signal }) => getFeedback(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getFeedback>>, TError, TData> & { queryKey: QueryKey }
}

export type GetFeedbackQueryResult = NonNullable<Awaited<ReturnType<typeof getFeedback>>>
export type GetFeedbackQueryError = unknown


/**
 * @summary Get feedback item with comments
 */

export function useGetFeedback<TData = Awaited<ReturnType<typeof getFeedback>>, TError = unknown>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getFeedback>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetFeedbackQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * @summary Update feedback status (managers only)
 */
export const updateFeedbackStatus = (
    id: string,
    updateFeedbackStatusBody: UpdateFeedbackStatusBody,
 ) => {
      
      
      return customInstance<UpdateFeedbackStatus200>(
      {url: `/api/help/feedback/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateFeedbackStatusBody
    },
      );
    }
  


export const getUpdateFeedbackStatusMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateFeedbackStatus>>, TError,{id: string;data: UpdateFeedbackStatusBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateFeedbackStatus>>, TError,{id: string;data: UpdateFeedbackStatusBody}, TContext> => {

const mutationKey = ['updateFeedbackStatus'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateFeedbackStatus>>, {id: string;data: UpdateFeedbackStatusBody}> = (props) => {
          const {id,data} = props ?? {};

          return  updateFeedbackStatus(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateFeedbackStatusMutationResult = NonNullable<Awaited<ReturnType<typeof updateFeedbackStatus>>>
    export type UpdateFeedbackStatusMutationBody = UpdateFeedbackStatusBody
    export type UpdateFeedbackStatusMutationError = unknown

    /**
 * @summary Update feedback status (managers only)
 */
export const useUpdateFeedbackStatus = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateFeedbackStatus>>, TError,{id: string;data: UpdateFeedbackStatusBody}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateFeedbackStatus>>,
        TError,
        {id: string;data: UpdateFeedbackStatusBody},
        TContext
      > => {

      const mutationOptions = getUpdateFeedbackStatusMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Add a comment to a feedback item
 */
export const addFeedbackComment = (
    id: string,
    addFeedbackCommentBody: AddFeedbackCommentBody,
 signal?: AbortSignal
) => {
      
      
      return customInstance<AddFeedbackComment201>(
      {url: `/api/help/feedback/${id}`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: addFeedbackCommentBody, signal
    },
      );
    }
  


export const getAddFeedbackCommentMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addFeedbackComment>>, TError,{id: string;data: AddFeedbackCommentBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof addFeedbackComment>>, TError,{id: string;data: AddFeedbackCommentBody}, TContext> => {

const mutationKey = ['addFeedbackComment'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof addFeedbackComment>>, {id: string;data: AddFeedbackCommentBody}> = (props) => {
          const {id,data} = props ?? {};

          return  addFeedbackComment(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AddFeedbackCommentMutationResult = NonNullable<Awaited<ReturnType<typeof addFeedbackComment>>>
    export type AddFeedbackCommentMutationBody = AddFeedbackCommentBody
    export type AddFeedbackCommentMutationError = unknown

    /**
 * @summary Add a comment to a feedback item
 */
export const useAddFeedbackComment = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addFeedbackComment>>, TError,{id: string;data: AddFeedbackCommentBody}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof addFeedbackComment>>,
        TError,
        {id: string;data: AddFeedbackCommentBody},
        TContext
      > => {

      const mutationOptions = getAddFeedbackCommentMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary List all users with their current rate (most recent effectiveFrom)
 */
export const getRates = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetRates200>(
      {url: `/api/rates`, method: 'GET', signal
    },
      );
    }
  



export const getGetRatesQueryKey = () => {
    return [
    `/api/rates`
    ] as const;
    }

    
export const getGetRatesQueryOptions = <TData = Awaited<ReturnType<typeof getRates>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getRates>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetRatesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRates>>> = ({ signal }) => getRates(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getRates>>, TError, TData> & { queryKey: QueryKey }
}

export type GetRatesQueryResult = NonNullable<Awaited<ReturnType<typeof getRates>>>
export type GetRatesQueryError = unknown


/**
 * @summary List all users with their current rate (most recent effectiveFrom)
 */

export function useGetRates<TData = Awaited<ReturnType<typeof getRates>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getRates>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetRatesQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * @summary Set a new hourly rate for a user (preserves history)
 */
export const createRate = (
    createRateBody: CreateRateBody,
 signal?: AbortSignal
) => {
      
      
      return customInstance<CreateRate201>(
      {url: `/api/rates`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createRateBody, signal
    },
      );
    }
  


export const getCreateRateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createRate>>, TError,{data: CreateRateBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createRate>>, TError,{data: CreateRateBody}, TContext> => {

const mutationKey = ['createRate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createRate>>, {data: CreateRateBody}> = (props) => {
          const {data} = props ?? {};

          return  createRate(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateRateMutationResult = NonNullable<Awaited<ReturnType<typeof createRate>>>
    export type CreateRateMutationBody = CreateRateBody
    export type CreateRateMutationError = unknown

    /**
 * @summary Set a new hourly rate for a user (preserves history)
 */
export const useCreateRate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createRate>>, TError,{data: CreateRateBody}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof createRate>>,
        TError,
        {data: CreateRateBody},
        TContext
      > => {

      const mutationOptions = getCreateRateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Rate history for a specific user
 */
export const getRateHistory = (
    userId: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetRateHistory200>(
      {url: `/api/rates/${userId}`, method: 'GET', signal
    },
      );
    }
  



export const getGetRateHistoryQueryKey = (userId?: string,) => {
    return [
    `/api/rates/${userId}`
    ] as const;
    }

    
export const getGetRateHistoryQueryOptions = <TData = Awaited<ReturnType<typeof getRateHistory>>, TError = unknown>(userId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getRateHistory>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetRateHistoryQueryKey(userId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRateHistory>>> = ({ signal }) => getRateHistory(userId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(userId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getRateHistory>>, TError, TData> & { queryKey: QueryKey }
}

export type GetRateHistoryQueryResult = NonNullable<Awaited<ReturnType<typeof getRateHistory>>>
export type GetRateHistoryQueryError = unknown


/**
 * @summary Rate history for a specific user
 */

export function useGetRateHistory<TData = Awaited<ReturnType<typeof getRateHistory>>, TError = unknown>(
 userId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getRateHistory>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetRateHistoryQueryOptions(userId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * @summary List cost allocations for a claim
 */
export const getCostAllocations = (
    params: GetCostAllocationsParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetCostAllocations200>(
      {url: `/api/cost-allocations`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getGetCostAllocationsQueryKey = (params?: GetCostAllocationsParams,) => {
    return [
    `/api/cost-allocations`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetCostAllocationsQueryOptions = <TData = Awaited<ReturnType<typeof getCostAllocations>>, TError = unknown>(params: GetCostAllocationsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCostAllocations>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCostAllocationsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCostAllocations>>> = ({ signal }) => getCostAllocations(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCostAllocations>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCostAllocationsQueryResult = NonNullable<Awaited<ReturnType<typeof getCostAllocations>>>
export type GetCostAllocationsQueryError = unknown


/**
 * @summary List cost allocations for a claim
 */

export function useGetCostAllocations<TData = Awaited<ReturnType<typeof getCostAllocations>>, TError = unknown>(
 params: GetCostAllocationsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCostAllocations>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetCostAllocationsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * @summary Create a manual cost allocation line item
 */
export const createCostAllocation = (
    createCostAllocationBody: CreateCostAllocationBody,
 signal?: AbortSignal
) => {
      
      
      return customInstance<CreateCostAllocation201>(
      {url: `/api/cost-allocations`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createCostAllocationBody, signal
    },
      );
    }
  


export const getCreateCostAllocationMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCostAllocation>>, TError,{data: CreateCostAllocationBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createCostAllocation>>, TError,{data: CreateCostAllocationBody}, TContext> => {

const mutationKey = ['createCostAllocation'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createCostAllocation>>, {data: CreateCostAllocationBody}> = (props) => {
          const {data} = props ?? {};

          return  createCostAllocation(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateCostAllocationMutationResult = NonNullable<Awaited<ReturnType<typeof createCostAllocation>>>
    export type CreateCostAllocationMutationBody = CreateCostAllocationBody
    export type CreateCostAllocationMutationError = void

    /**
 * @summary Create a manual cost allocation line item
 */
export const useCreateCostAllocation = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCostAllocation>>, TError,{data: CreateCostAllocationBody}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof createCostAllocation>>,
        TError,
        {data: CreateCostAllocationBody},
        TContext
      > => {

      const mutationOptions = getCreateCostAllocationMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Filtered dry-run + audited batch eligibility override. Edits eligibility (a reviewer-decision overlay) across ALL sources including API-synced rows — unlike the single-row PATCH — because it never touches the immutable captured cost data. Hard-excluded categories (rdti_claim_prep) are skipped, counted, and reported when the target status is claimable (the batch never fails). dryRun=true returns the real would-be-affected count and amount/claimable aggregates without writing. Cost rows are never claim-locked (locked claims read frozen snapshot figures), so no locked-claim guard applies.
 * @summary Apply one eligibility decision to a filtered set of cost allocations in a single audited batch
 */
export const bulkUpdateCostEligibility = (
    bulkUpdateCostEligibilityBody: BulkUpdateCostEligibilityBody,
 signal?: AbortSignal
) => {
      
      
      return customInstance<BulkUpdateCostEligibility200>(
      {url: `/api/cost-allocations/bulk-eligibility`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: bulkUpdateCostEligibilityBody, signal
    },
      );
    }
  


export const getBulkUpdateCostEligibilityMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof bulkUpdateCostEligibility>>, TError,{data: BulkUpdateCostEligibilityBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof bulkUpdateCostEligibility>>, TError,{data: BulkUpdateCostEligibilityBody}, TContext> => {

const mutationKey = ['bulkUpdateCostEligibility'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof bulkUpdateCostEligibility>>, {data: BulkUpdateCostEligibilityBody}> = (props) => {
          const {data} = props ?? {};

          return  bulkUpdateCostEligibility(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type BulkUpdateCostEligibilityMutationResult = NonNullable<Awaited<ReturnType<typeof bulkUpdateCostEligibility>>>
    export type BulkUpdateCostEligibilityMutationBody = BulkUpdateCostEligibilityBody
    export type BulkUpdateCostEligibilityMutationError = void

    /**
 * @summary Apply one eligibility decision to a filtered set of cost allocations in a single audited batch
 */
export const useBulkUpdateCostEligibility = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof bulkUpdateCostEligibility>>, TError,{data: BulkUpdateCostEligibilityBody}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof bulkUpdateCostEligibility>>,
        TError,
        {data: BulkUpdateCostEligibilityBody},
        TContext
      > => {

      const mutationOptions = getBulkUpdateCostEligibilityMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Update a manually-created cost allocation's category/eligibility/metadata (manual + api_xero rows only)
 */
export const updateCostAllocationEligibility = (
    id: string,
    updateCostAllocationEligibilityBody: UpdateCostAllocationEligibilityBody,
 ) => {
      
      
      return customInstance<UpdateCostAllocationEligibility200>(
      {url: `/api/cost-allocations/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateCostAllocationEligibilityBody
    },
      );
    }
  


export const getUpdateCostAllocationEligibilityMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCostAllocationEligibility>>, TError,{id: string;data: UpdateCostAllocationEligibilityBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateCostAllocationEligibility>>, TError,{id: string;data: UpdateCostAllocationEligibilityBody}, TContext> => {

const mutationKey = ['updateCostAllocationEligibility'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateCostAllocationEligibility>>, {id: string;data: UpdateCostAllocationEligibilityBody}> = (props) => {
          const {id,data} = props ?? {};

          return  updateCostAllocationEligibility(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateCostAllocationEligibilityMutationResult = NonNullable<Awaited<ReturnType<typeof updateCostAllocationEligibility>>>
    export type UpdateCostAllocationEligibilityMutationBody = UpdateCostAllocationEligibilityBody
    export type UpdateCostAllocationEligibilityMutationError = void

    /**
 * @summary Update a manually-created cost allocation's category/eligibility/metadata (manual + api_xero rows only)
 */
export const useUpdateCostAllocationEligibility = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCostAllocationEligibility>>, TError,{id: string;data: UpdateCostAllocationEligibilityBody}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateCostAllocationEligibility>>,
        TError,
        {id: string;data: UpdateCostAllocationEligibilityBody},
        TContext
      > => {

      const mutationOptions = getUpdateCostAllocationEligibilityMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Delete a manual cost allocation (API-sourced rows cannot be deleted)
 */
export const deleteCostAllocation = (
    id: string,
 ) => {
      
      
      return customInstance<void>(
      {url: `/api/cost-allocations/${id}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteCostAllocationMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCostAllocation>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteCostAllocation>>, TError,{id: string}, TContext> => {

const mutationKey = ['deleteCostAllocation'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteCostAllocation>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteCostAllocation(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteCostAllocationMutationResult = NonNullable<Awaited<ReturnType<typeof deleteCostAllocation>>>
    
    export type DeleteCostAllocationMutationError = void

    /**
 * @summary Delete a manual cost allocation (API-sourced rows cannot be deleted)
 */
export const useDeleteCostAllocation = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCostAllocation>>, TError,{id: string}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteCostAllocation>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteCostAllocationMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Pull Anthropic token usage for a period and create a cost allocation
 */
export const syncAnthropicUsage = (
    syncAnthropicUsageBody: SyncAnthropicUsageBody,
 signal?: AbortSignal
) => {
      
      
      return customInstance<void | SyncAnthropicUsage201>(
      {url: `/api/cost-allocations/sync/anthropic`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: syncAnthropicUsageBody, signal
    },
      );
    }
  


export const getSyncAnthropicUsageMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof syncAnthropicUsage>>, TError,{data: SyncAnthropicUsageBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof syncAnthropicUsage>>, TError,{data: SyncAnthropicUsageBody}, TContext> => {

const mutationKey = ['syncAnthropicUsage'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof syncAnthropicUsage>>, {data: SyncAnthropicUsageBody}> = (props) => {
          const {data} = props ?? {};

          return  syncAnthropicUsage(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SyncAnthropicUsageMutationResult = NonNullable<Awaited<ReturnType<typeof syncAnthropicUsage>>>
    export type SyncAnthropicUsageMutationBody = SyncAnthropicUsageBody
    export type SyncAnthropicUsageMutationError = void

    /**
 * @summary Pull Anthropic token usage for a period and create a cost allocation
 */
export const useSyncAnthropicUsage = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof syncAnthropicUsage>>, TError,{data: SyncAnthropicUsageBody}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof syncAnthropicUsage>>,
        TError,
        {data: SyncAnthropicUsageBody},
        TContext
      > => {

      const mutationOptions = getSyncAnthropicUsageMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Pull AWS Cost Explorer data for a period and create a cost allocation
 */
export const syncAwsCosts = (
    syncAwsCostsBody: SyncAwsCostsBody,
 signal?: AbortSignal
) => {
      
      
      return customInstance<void | SyncAwsCosts201>(
      {url: `/api/cost-allocations/sync/aws`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: syncAwsCostsBody, signal
    },
      );
    }
  


export const getSyncAwsCostsMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof syncAwsCosts>>, TError,{data: SyncAwsCostsBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof syncAwsCosts>>, TError,{data: SyncAwsCostsBody}, TContext> => {

const mutationKey = ['syncAwsCosts'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof syncAwsCosts>>, {data: SyncAwsCostsBody}> = (props) => {
          const {data} = props ?? {};

          return  syncAwsCosts(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SyncAwsCostsMutationResult = NonNullable<Awaited<ReturnType<typeof syncAwsCosts>>>
    export type SyncAwsCostsMutationBody = SyncAwsCostsBody
    export type SyncAwsCostsMutationError = void

    /**
 * @summary Pull AWS Cost Explorer data for a period and create a cost allocation
 */
export const useSyncAwsCosts = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof syncAwsCosts>>, TError,{data: SyncAwsCostsBody}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof syncAwsCosts>>,
        TError,
        {data: SyncAwsCostsBody},
        TContext
      > => {

      const mutationOptions = getSyncAwsCostsMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Assign a pending cost allocation to a project
 */
export const assignCostAllocation = (
    id: string,
    assignCostAllocationBody: AssignCostAllocationBody,
 ) => {
      
      
      return customInstance<AssignCostAllocation200>(
      {url: `/api/cost-allocations/${id}/assign`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: assignCostAllocationBody
    },
      );
    }
  


export const getAssignCostAllocationMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof assignCostAllocation>>, TError,{id: string;data: AssignCostAllocationBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof assignCostAllocation>>, TError,{id: string;data: AssignCostAllocationBody}, TContext> => {

const mutationKey = ['assignCostAllocation'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof assignCostAllocation>>, {id: string;data: AssignCostAllocationBody}> = (props) => {
          const {id,data} = props ?? {};

          return  assignCostAllocation(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AssignCostAllocationMutationResult = NonNullable<Awaited<ReturnType<typeof assignCostAllocation>>>
    export type AssignCostAllocationMutationBody = AssignCostAllocationBody
    export type AssignCostAllocationMutationError = unknown

    /**
 * @summary Assign a pending cost allocation to a project
 */
export const useAssignCostAllocation = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof assignCostAllocation>>, TError,{id: string;data: AssignCostAllocationBody}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof assignCostAllocation>>,
        TError,
        {id: string;data: AssignCostAllocationBody},
        TContext
      > => {

      const mutationOptions = getAssignCostAllocationMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary List project cost overrides
 */
export const getProjectCostOverrides = (
    params?: GetProjectCostOverridesParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetProjectCostOverrides200>(
      {url: `/api/cost-allocations/overrides`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getGetProjectCostOverridesQueryKey = (params?: GetProjectCostOverridesParams,) => {
    return [
    `/api/cost-allocations/overrides`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetProjectCostOverridesQueryOptions = <TData = Awaited<ReturnType<typeof getProjectCostOverrides>>, TError = unknown>(params?: GetProjectCostOverridesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getProjectCostOverrides>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProjectCostOverridesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProjectCostOverrides>>> = ({ signal }) => getProjectCostOverrides(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getProjectCostOverrides>>, TError, TData> & { queryKey: QueryKey }
}

export type GetProjectCostOverridesQueryResult = NonNullable<Awaited<ReturnType<typeof getProjectCostOverrides>>>
export type GetProjectCostOverridesQueryError = unknown


/**
 * @summary List project cost overrides
 */

export function useGetProjectCostOverrides<TData = Awaited<ReturnType<typeof getProjectCostOverrides>>, TError = unknown>(
 params?: GetProjectCostOverridesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getProjectCostOverrides>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetProjectCostOverridesQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * @summary Create a project cost override
 */
export const createProjectCostOverride = (
    createProjectCostOverrideBody: CreateProjectCostOverrideBody,
 signal?: AbortSignal
) => {
      
      
      return customInstance<CreateProjectCostOverride201>(
      {url: `/api/cost-allocations/overrides`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createProjectCostOverrideBody, signal
    },
      );
    }
  


export const getCreateProjectCostOverrideMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createProjectCostOverride>>, TError,{data: CreateProjectCostOverrideBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createProjectCostOverride>>, TError,{data: CreateProjectCostOverrideBody}, TContext> => {

const mutationKey = ['createProjectCostOverride'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createProjectCostOverride>>, {data: CreateProjectCostOverrideBody}> = (props) => {
          const {data} = props ?? {};

          return  createProjectCostOverride(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateProjectCostOverrideMutationResult = NonNullable<Awaited<ReturnType<typeof createProjectCostOverride>>>
    export type CreateProjectCostOverrideMutationBody = CreateProjectCostOverrideBody
    export type CreateProjectCostOverrideMutationError = unknown

    /**
 * @summary Create a project cost override
 */
export const useCreateProjectCostOverride = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createProjectCostOverride>>, TError,{data: CreateProjectCostOverrideBody}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof createProjectCostOverride>>,
        TError,
        {data: CreateProjectCostOverrideBody},
        TContext
      > => {

      const mutationOptions = getCreateProjectCostOverrideMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Delete a project cost override
 */
export const deleteProjectCostOverride = (
    id: string,
 ) => {
      
      
      return customInstance<void>(
      {url: `/api/cost-allocations/overrides/${id}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteProjectCostOverrideMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteProjectCostOverride>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteProjectCostOverride>>, TError,{id: string}, TContext> => {

const mutationKey = ['deleteProjectCostOverride'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteProjectCostOverride>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteProjectCostOverride(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteProjectCostOverrideMutationResult = NonNullable<Awaited<ReturnType<typeof deleteProjectCostOverride>>>
    
    export type DeleteProjectCostOverrideMutationError = unknown

    /**
 * @summary Delete a project cost override
 */
export const useDeleteProjectCostOverride = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteProjectCostOverride>>, TError,{id: string}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteProjectCostOverride>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteProjectCostOverrideMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary List configured integration providers (keys only, values never returned)
 */
export const getIntegrations = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetIntegrations200>(
      {url: `/api/integrations`, method: 'GET', signal
    },
      );
    }
  



export const getGetIntegrationsQueryKey = () => {
    return [
    `/api/integrations`
    ] as const;
    }

    
export const getGetIntegrationsQueryOptions = <TData = Awaited<ReturnType<typeof getIntegrations>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getIntegrations>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetIntegrationsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getIntegrations>>> = ({ signal }) => getIntegrations(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getIntegrations>>, TError, TData> & { queryKey: QueryKey }
}

export type GetIntegrationsQueryResult = NonNullable<Awaited<ReturnType<typeof getIntegrations>>>
export type GetIntegrationsQueryError = unknown


/**
 * @summary List configured integration providers (keys only, values never returned)
 */

export function useGetIntegrations<TData = Awaited<ReturnType<typeof getIntegrations>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getIntegrations>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetIntegrationsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * @summary Set an integration config value (insert or replace)
 */
export const upsertIntegration = (
    upsertIntegrationBody: UpsertIntegrationBody,
 ) => {
      
      
      return customInstance<void | void>(
      {url: `/api/integrations`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: upsertIntegrationBody
    },
      );
    }
  


export const getUpsertIntegrationMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof upsertIntegration>>, TError,{data: UpsertIntegrationBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof upsertIntegration>>, TError,{data: UpsertIntegrationBody}, TContext> => {

const mutationKey = ['upsertIntegration'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof upsertIntegration>>, {data: UpsertIntegrationBody}> = (props) => {
          const {data} = props ?? {};

          return  upsertIntegration(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpsertIntegrationMutationResult = NonNullable<Awaited<ReturnType<typeof upsertIntegration>>>
    export type UpsertIntegrationMutationBody = UpsertIntegrationBody
    export type UpsertIntegrationMutationError = unknown

    /**
 * @summary Set an integration config value (insert or replace)
 */
export const useUpsertIntegration = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof upsertIntegration>>, TError,{data: UpsertIntegrationBody}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof upsertIntegration>>,
        TError,
        {data: UpsertIntegrationBody},
        TContext
      > => {

      const mutationOptions = getUpsertIntegrationMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Remove an integration config key
 */
export const deleteIntegration = (
    provider: string,
    configKey: string,
 ) => {
      
      
      return customInstance<void>(
      {url: `/api/integrations/${provider}/${configKey}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteIntegrationMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteIntegration>>, TError,{provider: string;configKey: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteIntegration>>, TError,{provider: string;configKey: string}, TContext> => {

const mutationKey = ['deleteIntegration'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteIntegration>>, {provider: string;configKey: string}> = (props) => {
          const {provider,configKey} = props ?? {};

          return  deleteIntegration(provider,configKey,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteIntegrationMutationResult = NonNullable<Awaited<ReturnType<typeof deleteIntegration>>>
    
    export type DeleteIntegrationMutationError = unknown

    /**
 * @summary Remove an integration config key
 */
export const useDeleteIntegration = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteIntegration>>, TError,{provider: string;configKey: string}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteIntegration>>,
        TError,
        {provider: string;configKey: string},
        TContext
      > => {

      const mutationOptions = getDeleteIntegrationMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Expenditure summary using per-user rate card + cost allocations
 */
export const getClaimExpenditure = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetClaimExpenditure200>(
      {url: `/api/claims/${id}/expenditure`, method: 'GET', signal
    },
      );
    }
  



export const getGetClaimExpenditureQueryKey = (id?: string,) => {
    return [
    `/api/claims/${id}/expenditure`
    ] as const;
    }

    
export const getGetClaimExpenditureQueryOptions = <TData = Awaited<ReturnType<typeof getClaimExpenditure>>, TError = unknown>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getClaimExpenditure>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetClaimExpenditureQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getClaimExpenditure>>> = ({ signal }) => getClaimExpenditure(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getClaimExpenditure>>, TError, TData> & { queryKey: QueryKey }
}

export type GetClaimExpenditureQueryResult = NonNullable<Awaited<ReturnType<typeof getClaimExpenditure>>>
export type GetClaimExpenditureQueryError = unknown


/**
 * @summary Expenditure summary using per-user rate card + cost allocations
 */

export function useGetClaimExpenditure<TData = Awaited<ReturnType<typeof getClaimExpenditure>>, TError = unknown>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getClaimExpenditure>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetClaimExpenditureQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * @summary Health check
 */
export const getHealth = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<HealthResponse>(
      {url: `/api/health`, method: 'GET', signal
    },
      );
    }
  



export const getGetHealthQueryKey = () => {
    return [
    `/api/health`
    ] as const;
    }

    
export const getGetHealthQueryOptions = <TData = Awaited<ReturnType<typeof getHealth>>, TError = HealthResponse>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getHealth>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetHealthQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getHealth>>> = ({ signal }) => getHealth(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getHealth>>, TError, TData> & { queryKey: QueryKey }
}

export type GetHealthQueryResult = NonNullable<Awaited<ReturnType<typeof getHealth>>>
export type GetHealthQueryError = HealthResponse


/**
 * @summary Health check
 */

export function useGetHealth<TData = Awaited<ReturnType<typeof getHealth>>, TError = HealthResponse>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getHealth>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetHealthQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * @summary Register a new tenant and admin user from a Clerk identity
 */
export const registerUser = (
    registerUserBody: RegisterUserBody,
 signal?: AbortSignal
) => {
      
      
      return customInstance<RegisterUser201>(
      {url: `/api/auth/register`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: registerUserBody, signal
    },
      );
    }
  


export const getRegisterUserMutationOptions = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof registerUser>>, TError,{data: RegisterUserBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof registerUser>>, TError,{data: RegisterUserBody}, TContext> => {

const mutationKey = ['registerUser'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof registerUser>>, {data: RegisterUserBody}> = (props) => {
          const {data} = props ?? {};

          return  registerUser(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type RegisterUserMutationResult = NonNullable<Awaited<ReturnType<typeof registerUser>>>
    export type RegisterUserMutationBody = RegisterUserBody
    export type RegisterUserMutationError = Error

    /**
 * @summary Register a new tenant and admin user from a Clerk identity
 */
export const useRegisterUser = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof registerUser>>, TError,{data: RegisterUserBody}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof registerUser>>,
        TError,
        {data: RegisterUserBody},
        TContext
      > => {

      const mutationOptions = getRegisterUserMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Admin mints a downgrade-only act-as token
 */
export const enterActAs = (
    enterActAsBody: EnterActAsBody,
 signal?: AbortSignal
) => {
      
      
      return customInstance<EnterActAs200>(
      {url: `/api/auth/act-as`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: enterActAsBody, signal
    },
      );
    }
  


export const getEnterActAsMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof enterActAs>>, TError,{data: EnterActAsBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof enterActAs>>, TError,{data: EnterActAsBody}, TContext> => {

const mutationKey = ['enterActAs'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof enterActAs>>, {data: EnterActAsBody}> = (props) => {
          const {data} = props ?? {};

          return  enterActAs(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type EnterActAsMutationResult = NonNullable<Awaited<ReturnType<typeof enterActAs>>>
    export type EnterActAsMutationBody = EnterActAsBody
    export type EnterActAsMutationError = unknown

    /**
 * @summary Admin mints a downgrade-only act-as token
 */
export const useEnterActAs = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof enterActAs>>, TError,{data: EnterActAsBody}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof enterActAs>>,
        TError,
        {data: EnterActAsBody},
        TContext
      > => {

      const mutationOptions = getEnterActAsMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Record exit from act-as mode
 */
export const exitActAs = (
    exitActAsBody?: ExitActAsBody,
 signal?: AbortSignal
) => {
      
      
      return customInstance<ExitActAs200>(
      {url: `/api/auth/act-as/exit`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: exitActAsBody, signal
    },
      );
    }
  


export const getExitActAsMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof exitActAs>>, TError,{data: ExitActAsBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof exitActAs>>, TError,{data: ExitActAsBody}, TContext> => {

const mutationKey = ['exitActAs'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof exitActAs>>, {data: ExitActAsBody}> = (props) => {
          const {data} = props ?? {};

          return  exitActAs(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ExitActAsMutationResult = NonNullable<Awaited<ReturnType<typeof exitActAs>>>
    export type ExitActAsMutationBody = ExitActAsBody
    export type ExitActAsMutationError = unknown

    /**
 * @summary Record exit from act-as mode
 */
export const useExitActAs = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof exitActAs>>, TError,{data: ExitActAsBody}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof exitActAs>>,
        TError,
        {data: ExitActAsBody},
        TContext
      > => {

      const mutationOptions = getExitActAsMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary List artefacts for the tenant
 */
export const getArtefacts = (
    params?: GetArtefactsParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetArtefacts200>(
      {url: `/api/artefacts`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getGetArtefactsQueryKey = (params?: GetArtefactsParams,) => {
    return [
    `/api/artefacts`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetArtefactsQueryOptions = <TData = Awaited<ReturnType<typeof getArtefacts>>, TError = unknown>(params?: GetArtefactsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getArtefacts>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetArtefactsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getArtefacts>>> = ({ signal }) => getArtefacts(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getArtefacts>>, TError, TData> & { queryKey: QueryKey }
}

export type GetArtefactsQueryResult = NonNullable<Awaited<ReturnType<typeof getArtefacts>>>
export type GetArtefactsQueryError = unknown


/**
 * @summary List artefacts for the tenant
 */

export function useGetArtefacts<TData = Awaited<ReturnType<typeof getArtefacts>>, TError = unknown>(
 params?: GetArtefactsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getArtefacts>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetArtefactsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * @summary Create a new artefact
 */
export const createArtefact = (
    createArtefactBody: CreateArtefactBody,
 signal?: AbortSignal
) => {
      
      
      return customInstance<CreateArtefact201>(
      {url: `/api/artefacts`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createArtefactBody, signal
    },
      );
    }
  


export const getCreateArtefactMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createArtefact>>, TError,{data: CreateArtefactBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createArtefact>>, TError,{data: CreateArtefactBody}, TContext> => {

const mutationKey = ['createArtefact'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createArtefact>>, {data: CreateArtefactBody}> = (props) => {
          const {data} = props ?? {};

          return  createArtefact(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateArtefactMutationResult = NonNullable<Awaited<ReturnType<typeof createArtefact>>>
    export type CreateArtefactMutationBody = CreateArtefactBody
    export type CreateArtefactMutationError = unknown

    /**
 * @summary Create a new artefact
 */
export const useCreateArtefact = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createArtefact>>, TError,{data: CreateArtefactBody}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof createArtefact>>,
        TError,
        {data: CreateArtefactBody},
        TContext
      > => {

      const mutationOptions = getCreateArtefactMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Analyse a transcript and split it into per-project excerpts
 */
export const detectTranscriptSplits = (
    detectTranscriptSplitsBody: DetectTranscriptSplitsBody,
 signal?: AbortSignal
) => {
      
      
      return customInstance<DetectTranscriptSplits200>(
      {url: `/api/artefacts/detect-splits`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: detectTranscriptSplitsBody, signal
    },
      );
    }
  


export const getDetectTranscriptSplitsMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof detectTranscriptSplits>>, TError,{data: DetectTranscriptSplitsBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof detectTranscriptSplits>>, TError,{data: DetectTranscriptSplitsBody}, TContext> => {

const mutationKey = ['detectTranscriptSplits'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof detectTranscriptSplits>>, {data: DetectTranscriptSplitsBody}> = (props) => {
          const {data} = props ?? {};

          return  detectTranscriptSplits(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DetectTranscriptSplitsMutationResult = NonNullable<Awaited<ReturnType<typeof detectTranscriptSplits>>>
    export type DetectTranscriptSplitsMutationBody = DetectTranscriptSplitsBody
    export type DetectTranscriptSplitsMutationError = unknown

    /**
 * @summary Analyse a transcript and split it into per-project excerpts
 */
export const useDetectTranscriptSplits = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof detectTranscriptSplits>>, TError,{data: DetectTranscriptSplitsBody}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof detectTranscriptSplits>>,
        TError,
        {data: DetectTranscriptSplitsBody},
        TContext
      > => {

      const mutationOptions = getDetectTranscriptSplitsMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Get a single artefact
 */
export const getArtefact = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetArtefact200>(
      {url: `/api/artefacts/${id}`, method: 'GET', signal
    },
      );
    }
  



export const getGetArtefactQueryKey = (id?: string,) => {
    return [
    `/api/artefacts/${id}`
    ] as const;
    }

    
export const getGetArtefactQueryOptions = <TData = Awaited<ReturnType<typeof getArtefact>>, TError = void>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getArtefact>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetArtefactQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getArtefact>>> = ({ signal }) => getArtefact(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getArtefact>>, TError, TData> & { queryKey: QueryKey }
}

export type GetArtefactQueryResult = NonNullable<Awaited<ReturnType<typeof getArtefact>>>
export type GetArtefactQueryError = void


/**
 * @summary Get a single artefact
 */

export function useGetArtefact<TData = Awaited<ReturnType<typeof getArtefact>>, TError = void>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getArtefact>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetArtefactQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * @summary Soft-delete an artefact (sets supersededBy = self)
 */
export const deleteArtefact = (
    id: string,
 ) => {
      
      
      return customInstance<void>(
      {url: `/api/artefacts/${id}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteArtefactMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteArtefact>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteArtefact>>, TError,{id: string}, TContext> => {

const mutationKey = ['deleteArtefact'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteArtefact>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteArtefact(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteArtefactMutationResult = NonNullable<Awaited<ReturnType<typeof deleteArtefact>>>
    
    export type DeleteArtefactMutationError = unknown

    /**
 * @summary Soft-delete an artefact (sets supersededBy = self)
 */
export const useDeleteArtefact = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteArtefact>>, TError,{id: string}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteArtefact>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteArtefactMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary List projects for the tenant
 */
export const getProjects = (
    params?: GetProjectsParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetProjects200>(
      {url: `/api/projects`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getGetProjectsQueryKey = (params?: GetProjectsParams,) => {
    return [
    `/api/projects`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetProjectsQueryOptions = <TData = Awaited<ReturnType<typeof getProjects>>, TError = unknown>(params?: GetProjectsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getProjects>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProjectsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProjects>>> = ({ signal }) => getProjects(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getProjects>>, TError, TData> & { queryKey: QueryKey }
}

export type GetProjectsQueryResult = NonNullable<Awaited<ReturnType<typeof getProjects>>>
export type GetProjectsQueryError = unknown


/**
 * @summary List projects for the tenant
 */

export function useGetProjects<TData = Awaited<ReturnType<typeof getProjects>>, TError = unknown>(
 params?: GetProjectsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getProjects>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetProjectsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * @summary Create a new project
 */
export const createProject = (
    createProjectBody: CreateProjectBody,
 signal?: AbortSignal
) => {
      
      
      return customInstance<CreateProject201>(
      {url: `/api/projects`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createProjectBody, signal
    },
      );
    }
  


export const getCreateProjectMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createProject>>, TError,{data: CreateProjectBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createProject>>, TError,{data: CreateProjectBody}, TContext> => {

const mutationKey = ['createProject'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createProject>>, {data: CreateProjectBody}> = (props) => {
          const {data} = props ?? {};

          return  createProject(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateProjectMutationResult = NonNullable<Awaited<ReturnType<typeof createProject>>>
    export type CreateProjectMutationBody = CreateProjectBody
    export type CreateProjectMutationError = unknown

    /**
 * @summary Create a new project
 */
export const useCreateProject = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createProject>>, TError,{data: CreateProjectBody}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof createProject>>,
        TError,
        {data: CreateProjectBody},
        TContext
      > => {

      const mutationOptions = getCreateProjectMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Get a project
 */
export const getProject = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetProject200>(
      {url: `/api/projects/${id}`, method: 'GET', signal
    },
      );
    }
  



export const getGetProjectQueryKey = (id?: string,) => {
    return [
    `/api/projects/${id}`
    ] as const;
    }

    
export const getGetProjectQueryOptions = <TData = Awaited<ReturnType<typeof getProject>>, TError = void>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getProject>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProjectQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProject>>> = ({ signal }) => getProject(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getProject>>, TError, TData> & { queryKey: QueryKey }
}

export type GetProjectQueryResult = NonNullable<Awaited<ReturnType<typeof getProject>>>
export type GetProjectQueryError = void


/**
 * @summary Get a project
 */

export function useGetProject<TData = Awaited<ReturnType<typeof getProject>>, TError = void>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getProject>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetProjectQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * @summary Rename or update a project
 */
export const updateProject = (
    id: string,
    updateProjectBody: UpdateProjectBody,
 ) => {
      
      
      return customInstance<UpdateProject200>(
      {url: `/api/projects/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateProjectBody
    },
      );
    }
  


export const getUpdateProjectMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateProject>>, TError,{id: string;data: UpdateProjectBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateProject>>, TError,{id: string;data: UpdateProjectBody}, TContext> => {

const mutationKey = ['updateProject'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateProject>>, {id: string;data: UpdateProjectBody}> = (props) => {
          const {id,data} = props ?? {};

          return  updateProject(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateProjectMutationResult = NonNullable<Awaited<ReturnType<typeof updateProject>>>
    export type UpdateProjectMutationBody = UpdateProjectBody
    export type UpdateProjectMutationError = void

    /**
 * @summary Rename or update a project
 */
export const useUpdateProject = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateProject>>, TError,{id: string;data: UpdateProjectBody}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateProject>>,
        TError,
        {id: string;data: UpdateProjectBody},
        TContext
      > => {

      const mutationOptions = getUpdateProjectMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Delete a project (blocked if it has time entries)
 */
export const deleteProject = (
    id: string,
 ) => {
      
      
      return customInstance<void>(
      {url: `/api/projects/${id}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteProjectMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteProject>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteProject>>, TError,{id: string}, TContext> => {

const mutationKey = ['deleteProject'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteProject>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteProject(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteProjectMutationResult = NonNullable<Awaited<ReturnType<typeof deleteProject>>>
    
    export type DeleteProjectMutationError = void

    /**
 * @summary Delete a project (blocked if it has time entries)
 */
export const useDeleteProject = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteProject>>, TError,{id: string}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteProject>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteProjectMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Set status for multiple projects
 */
export const bulkUpdateProjectStatus = (
    bulkUpdateProjectStatusBody: BulkUpdateProjectStatusBody,
 ) => {
      
      
      return customInstance<BulkUpdateProjectStatus200>(
      {url: `/api/projects/bulk-status`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: bulkUpdateProjectStatusBody
    },
      );
    }
  


export const getBulkUpdateProjectStatusMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof bulkUpdateProjectStatus>>, TError,{data: BulkUpdateProjectStatusBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof bulkUpdateProjectStatus>>, TError,{data: BulkUpdateProjectStatusBody}, TContext> => {

const mutationKey = ['bulkUpdateProjectStatus'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof bulkUpdateProjectStatus>>, {data: BulkUpdateProjectStatusBody}> = (props) => {
          const {data} = props ?? {};

          return  bulkUpdateProjectStatus(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type BulkUpdateProjectStatusMutationResult = NonNullable<Awaited<ReturnType<typeof bulkUpdateProjectStatus>>>
    export type BulkUpdateProjectStatusMutationBody = BulkUpdateProjectStatusBody
    export type BulkUpdateProjectStatusMutationError = void

    /**
 * @summary Set status for multiple projects
 */
export const useBulkUpdateProjectStatus = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof bulkUpdateProjectStatus>>, TError,{data: BulkUpdateProjectStatusBody}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof bulkUpdateProjectStatus>>,
        TError,
        {data: BulkUpdateProjectStatusBody},
        TContext
      > => {

      const mutationOptions = getBulkUpdateProjectStatusMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Mark a project as completed or cancelled
 */
export const closeProject = (
    id: string,
    closeProjectBody: CloseProjectBody,
 signal?: AbortSignal
) => {
      
      
      return customInstance<CloseProject200>(
      {url: `/api/projects/${id}/close`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: closeProjectBody, signal
    },
      );
    }
  


export const getCloseProjectMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof closeProject>>, TError,{id: string;data: CloseProjectBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof closeProject>>, TError,{id: string;data: CloseProjectBody}, TContext> => {

const mutationKey = ['closeProject'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof closeProject>>, {id: string;data: CloseProjectBody}> = (props) => {
          const {id,data} = props ?? {};

          return  closeProject(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CloseProjectMutationResult = NonNullable<Awaited<ReturnType<typeof closeProject>>>
    export type CloseProjectMutationBody = CloseProjectBody
    export type CloseProjectMutationError = void

    /**
 * @summary Mark a project as completed or cancelled
 */
export const useCloseProject = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof closeProject>>, TError,{id: string;data: CloseProjectBody}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof closeProject>>,
        TError,
        {id: string;data: CloseProjectBody},
        TContext
      > => {

      const mutationOptions = getCloseProjectMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary List initiatives for the tenant
 */
export const getInitiatives = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetInitiatives200>(
      {url: `/api/initiatives`, method: 'GET', signal
    },
      );
    }
  



export const getGetInitiativesQueryKey = () => {
    return [
    `/api/initiatives`
    ] as const;
    }

    
export const getGetInitiativesQueryOptions = <TData = Awaited<ReturnType<typeof getInitiatives>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getInitiatives>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetInitiativesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getInitiatives>>> = ({ signal }) => getInitiatives(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getInitiatives>>, TError, TData> & { queryKey: QueryKey }
}

export type GetInitiativesQueryResult = NonNullable<Awaited<ReturnType<typeof getInitiatives>>>
export type GetInitiativesQueryError = unknown


/**
 * @summary List initiatives for the tenant
 */

export function useGetInitiatives<TData = Awaited<ReturnType<typeof getInitiatives>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getInitiatives>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetInitiativesQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * @summary Create a new initiative
 */
export const createInitiative = (
    createInitiativeBody: CreateInitiativeBody,
 signal?: AbortSignal
) => {
      
      
      return customInstance<CreateInitiative201>(
      {url: `/api/initiatives`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createInitiativeBody, signal
    },
      );
    }
  


export const getCreateInitiativeMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createInitiative>>, TError,{data: CreateInitiativeBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createInitiative>>, TError,{data: CreateInitiativeBody}, TContext> => {

const mutationKey = ['createInitiative'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createInitiative>>, {data: CreateInitiativeBody}> = (props) => {
          const {data} = props ?? {};

          return  createInitiative(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateInitiativeMutationResult = NonNullable<Awaited<ReturnType<typeof createInitiative>>>
    export type CreateInitiativeMutationBody = CreateInitiativeBody
    export type CreateInitiativeMutationError = unknown

    /**
 * @summary Create a new initiative
 */
export const useCreateInitiative = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createInitiative>>, TError,{data: CreateInitiativeBody}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof createInitiative>>,
        TError,
        {data: CreateInitiativeBody},
        TContext
      > => {

      const mutationOptions = getCreateInitiativeMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Update an initiative
 */
export const updateInitiative = (
    id: string,
    updateInitiativeBody: UpdateInitiativeBody,
 ) => {
      
      
      return customInstance<UpdateInitiative200>(
      {url: `/api/initiatives/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateInitiativeBody
    },
      );
    }
  


export const getUpdateInitiativeMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateInitiative>>, TError,{id: string;data: UpdateInitiativeBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateInitiative>>, TError,{id: string;data: UpdateInitiativeBody}, TContext> => {

const mutationKey = ['updateInitiative'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateInitiative>>, {id: string;data: UpdateInitiativeBody}> = (props) => {
          const {id,data} = props ?? {};

          return  updateInitiative(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateInitiativeMutationResult = NonNullable<Awaited<ReturnType<typeof updateInitiative>>>
    export type UpdateInitiativeMutationBody = UpdateInitiativeBody
    export type UpdateInitiativeMutationError = void

    /**
 * @summary Update an initiative
 */
export const useUpdateInitiative = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateInitiative>>, TError,{id: string;data: UpdateInitiativeBody}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateInitiative>>,
        TError,
        {id: string;data: UpdateInitiativeBody},
        TContext
      > => {

      const mutationOptions = getUpdateInitiativeMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Cancel an initiative (sets status to cancelled)
 */
export const deleteInitiative = (
    id: string,
 ) => {
      
      
      return customInstance<DeleteInitiative200>(
      {url: `/api/initiatives/${id}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteInitiativeMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteInitiative>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteInitiative>>, TError,{id: string}, TContext> => {

const mutationKey = ['deleteInitiative'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteInitiative>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteInitiative(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteInitiativeMutationResult = NonNullable<Awaited<ReturnType<typeof deleteInitiative>>>
    
    export type DeleteInitiativeMutationError = void

    /**
 * @summary Cancel an initiative (sets status to cancelled)
 */
export const useDeleteInitiative = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteInitiative>>, TError,{id: string}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteInitiative>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteInitiativeMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary List repos linked to a project
 */
export const getProjectRepos = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetProjectRepos200>(
      {url: `/api/projects/${id}/repos`, method: 'GET', signal
    },
      );
    }
  



export const getGetProjectReposQueryKey = (id?: string,) => {
    return [
    `/api/projects/${id}/repos`
    ] as const;
    }

    
export const getGetProjectReposQueryOptions = <TData = Awaited<ReturnType<typeof getProjectRepos>>, TError = unknown>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getProjectRepos>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProjectReposQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProjectRepos>>> = ({ signal }) => getProjectRepos(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getProjectRepos>>, TError, TData> & { queryKey: QueryKey }
}

export type GetProjectReposQueryResult = NonNullable<Awaited<ReturnType<typeof getProjectRepos>>>
export type GetProjectReposQueryError = unknown


/**
 * @summary List repos linked to a project
 */

export function useGetProjectRepos<TData = Awaited<ReturnType<typeof getProjectRepos>>, TError = unknown>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getProjectRepos>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetProjectReposQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * @summary Add a repo to a project
 */
export const addProjectRepo = (
    id: string,
    addProjectRepoBody: AddProjectRepoBody,
 signal?: AbortSignal
) => {
      
      
      return customInstance<AddProjectRepo201>(
      {url: `/api/projects/${id}/repos`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: addProjectRepoBody, signal
    },
      );
    }
  


export const getAddProjectRepoMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addProjectRepo>>, TError,{id: string;data: AddProjectRepoBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof addProjectRepo>>, TError,{id: string;data: AddProjectRepoBody}, TContext> => {

const mutationKey = ['addProjectRepo'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof addProjectRepo>>, {id: string;data: AddProjectRepoBody}> = (props) => {
          const {id,data} = props ?? {};

          return  addProjectRepo(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AddProjectRepoMutationResult = NonNullable<Awaited<ReturnType<typeof addProjectRepo>>>
    export type AddProjectRepoMutationBody = AddProjectRepoBody
    export type AddProjectRepoMutationError = unknown

    /**
 * @summary Add a repo to a project
 */
export const useAddProjectRepo = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addProjectRepo>>, TError,{id: string;data: AddProjectRepoBody}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof addProjectRepo>>,
        TError,
        {id: string;data: AddProjectRepoBody},
        TContext
      > => {

      const mutationOptions = getAddProjectRepoMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Remove a repo from a project
 */
export const removeProjectRepo = (
    id: string,
    repoId: string,
 ) => {
      
      
      return customInstance<void>(
      {url: `/api/projects/${id}/repos/${repoId}`, method: 'DELETE'
    },
      );
    }
  


export const getRemoveProjectRepoMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeProjectRepo>>, TError,{id: string;repoId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof removeProjectRepo>>, TError,{id: string;repoId: string}, TContext> => {

const mutationKey = ['removeProjectRepo'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof removeProjectRepo>>, {id: string;repoId: string}> = (props) => {
          const {id,repoId} = props ?? {};

          return  removeProjectRepo(id,repoId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type RemoveProjectRepoMutationResult = NonNullable<Awaited<ReturnType<typeof removeProjectRepo>>>
    
    export type RemoveProjectRepoMutationError = unknown

    /**
 * @summary Remove a repo from a project
 */
export const useRemoveProjectRepo = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeProjectRepo>>, TError,{id: string;repoId: string}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof removeProjectRepo>>,
        TError,
        {id: string;repoId: string},
        TContext
      > => {

      const mutationOptions = getRemoveProjectRepoMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Git engagement signals for a project (branch lifecycles, PR reviews, CI failure→fix episodes)
 */
export const getProjectEngagement = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetProjectEngagement200>(
      {url: `/api/projects/${id}/engagement`, method: 'GET', signal
    },
      );
    }
  



export const getGetProjectEngagementQueryKey = (id?: string,) => {
    return [
    `/api/projects/${id}/engagement`
    ] as const;
    }

    
export const getGetProjectEngagementQueryOptions = <TData = Awaited<ReturnType<typeof getProjectEngagement>>, TError = Error>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getProjectEngagement>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProjectEngagementQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProjectEngagement>>> = ({ signal }) => getProjectEngagement(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getProjectEngagement>>, TError, TData> & { queryKey: QueryKey }
}

export type GetProjectEngagementQueryResult = NonNullable<Awaited<ReturnType<typeof getProjectEngagement>>>
export type GetProjectEngagementQueryError = Error


/**
 * @summary Git engagement signals for a project (branch lifecycles, PR reviews, CI failure→fix episodes)
 */

export function useGetProjectEngagement<TData = Awaited<ReturnType<typeof getProjectEngagement>>, TError = Error>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getProjectEngagement>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetProjectEngagementQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * @summary Continuous eligibility ledger for a project (append-only status trajectory)
 */
export const getProjectEligibilityLedger = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetProjectEligibilityLedger200>(
      {url: `/api/projects/${id}/eligibility-ledger`, method: 'GET', signal
    },
      );
    }
  



export const getGetProjectEligibilityLedgerQueryKey = (id?: string,) => {
    return [
    `/api/projects/${id}/eligibility-ledger`
    ] as const;
    }

    
export const getGetProjectEligibilityLedgerQueryOptions = <TData = Awaited<ReturnType<typeof getProjectEligibilityLedger>>, TError = Error>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getProjectEligibilityLedger>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProjectEligibilityLedgerQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProjectEligibilityLedger>>> = ({ signal }) => getProjectEligibilityLedger(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getProjectEligibilityLedger>>, TError, TData> & { queryKey: QueryKey }
}

export type GetProjectEligibilityLedgerQueryResult = NonNullable<Awaited<ReturnType<typeof getProjectEligibilityLedger>>>
export type GetProjectEligibilityLedgerQueryError = Error


/**
 * @summary Continuous eligibility ledger for a project (append-only status trajectory)
 */

export function useGetProjectEligibilityLedger<TData = Awaited<ReturnType<typeof getProjectEligibilityLedger>>, TError = Error>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getProjectEligibilityLedger>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetProjectEligibilityLedgerQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * @summary Create a TFA panel for a project
 */
export const createProjectTfa = (
    projectId: string,
    createProjectTfaBody: CreateProjectTfaBody,
 signal?: AbortSignal
) => {
      
      
      return customInstance<CreateProjectTfa201>(
      {url: `/api/projects/${projectId}/tfa`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createProjectTfaBody, signal
    },
      );
    }
  


export const getCreateProjectTfaMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createProjectTfa>>, TError,{projectId: string;data: CreateProjectTfaBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createProjectTfa>>, TError,{projectId: string;data: CreateProjectTfaBody}, TContext> => {

const mutationKey = ['createProjectTfa'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createProjectTfa>>, {projectId: string;data: CreateProjectTfaBody}> = (props) => {
          const {projectId,data} = props ?? {};

          return  createProjectTfa(projectId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateProjectTfaMutationResult = NonNullable<Awaited<ReturnType<typeof createProjectTfa>>>
    export type CreateProjectTfaMutationBody = CreateProjectTfaBody
    export type CreateProjectTfaMutationError = void

    /**
 * @summary Create a TFA panel for a project
 */
export const useCreateProjectTfa = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createProjectTfa>>, TError,{projectId: string;data: CreateProjectTfaBody}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof createProjectTfa>>,
        TError,
        {projectId: string;data: CreateProjectTfaBody},
        TContext
      > => {

      const mutationOptions = getCreateProjectTfaMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Get full TFA panel (including panelists and determination)
 */
export const getTfa = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetTfa200>(
      {url: `/api/tfa/${id}`, method: 'GET', signal
    },
      );
    }
  



export const getGetTfaQueryKey = (id?: string,) => {
    return [
    `/api/tfa/${id}`
    ] as const;
    }

    
export const getGetTfaQueryOptions = <TData = Awaited<ReturnType<typeof getTfa>>, TError = void>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTfa>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTfaQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTfa>>> = ({ signal }) => getTfa(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTfa>>, TError, TData> & { queryKey: QueryKey }
}

export type GetTfaQueryResult = NonNullable<Awaited<ReturnType<typeof getTfa>>>
export type GetTfaQueryError = void


/**
 * @summary Get full TFA panel (including panelists and determination)
 */

export function useGetTfa<TData = Awaited<ReturnType<typeof getTfa>>, TError = void>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTfa>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetTfaQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * @summary Advance or retreat TFA panel to a stage
 */
export const patchTfaStage = (
    id: string,
    patchTfaStageBody: PatchTfaStageBody,
 ) => {
      
      
      return customInstance<PatchTfaStage200>(
      {url: `/api/tfa/${id}/stage`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchTfaStageBody
    },
      );
    }
  


export const getPatchTfaStageMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchTfaStage>>, TError,{id: string;data: PatchTfaStageBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patchTfaStage>>, TError,{id: string;data: PatchTfaStageBody}, TContext> => {

const mutationKey = ['patchTfaStage'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchTfaStage>>, {id: string;data: PatchTfaStageBody}> = (props) => {
          const {id,data} = props ?? {};

          return  patchTfaStage(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatchTfaStageMutationResult = NonNullable<Awaited<ReturnType<typeof patchTfaStage>>>
    export type PatchTfaStageMutationBody = PatchTfaStageBody
    export type PatchTfaStageMutationError = unknown

    /**
 * @summary Advance or retreat TFA panel to a stage
 */
export const usePatchTfaStage = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchTfaStage>>, TError,{id: string;data: PatchTfaStageBody}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof patchTfaStage>>,
        TError,
        {id: string;data: PatchTfaStageBody},
        TContext
      > => {

      const mutationOptions = getPatchTfaStageMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Update TFA panel content fields (problem statement, COTS conclusion, notes)
 */
export const patchTfaContent = (
    id: string,
    patchTfaContentBody: PatchTfaContentBody,
 ) => {
      
      
      return customInstance<PatchTfaContent200>(
      {url: `/api/tfa/${id}/content`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchTfaContentBody
    },
      );
    }
  


export const getPatchTfaContentMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchTfaContent>>, TError,{id: string;data: PatchTfaContentBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patchTfaContent>>, TError,{id: string;data: PatchTfaContentBody}, TContext> => {

const mutationKey = ['patchTfaContent'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchTfaContent>>, {id: string;data: PatchTfaContentBody}> = (props) => {
          const {id,data} = props ?? {};

          return  patchTfaContent(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatchTfaContentMutationResult = NonNullable<Awaited<ReturnType<typeof patchTfaContent>>>
    export type PatchTfaContentMutationBody = PatchTfaContentBody
    export type PatchTfaContentMutationError = unknown

    /**
 * @summary Update TFA panel content fields (problem statement, COTS conclusion, notes)
 */
export const usePatchTfaContent = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchTfaContent>>, TError,{id: string;data: PatchTfaContentBody}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof patchTfaContent>>,
        TError,
        {id: string;data: PatchTfaContentBody},
        TContext
      > => {

      const mutationOptions = getPatchTfaContentMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Lock a TFA panel (no further edits after lock)
 */
export const postTfaLock = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<PostTfaLock200>(
      {url: `/api/tfa/${id}/lock`, method: 'POST', signal
    },
      );
    }
  


export const getPostTfaLockMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postTfaLock>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postTfaLock>>, TError,{id: string}, TContext> => {

const mutationKey = ['postTfaLock'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postTfaLock>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  postTfaLock(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostTfaLockMutationResult = NonNullable<Awaited<ReturnType<typeof postTfaLock>>>
    
    export type PostTfaLockMutationError = unknown

    /**
 * @summary Lock a TFA panel (no further edits after lock)
 */
export const usePostTfaLock = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postTfaLock>>, TError,{id: string}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof postTfaLock>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getPostTfaLockMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Unlock TFA panel (admin only)
 */
export const postTfaUnlock = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<PostTfaUnlock200>(
      {url: `/api/tfa/${id}/unlock`, method: 'POST', signal
    },
      );
    }
  


export const getPostTfaUnlockMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postTfaUnlock>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postTfaUnlock>>, TError,{id: string}, TContext> => {

const mutationKey = ['postTfaUnlock'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postTfaUnlock>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  postTfaUnlock(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostTfaUnlockMutationResult = NonNullable<Awaited<ReturnType<typeof postTfaUnlock>>>
    
    export type PostTfaUnlockMutationError = void

    /**
 * @summary Unlock TFA panel (admin only)
 */
export const usePostTfaUnlock = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postTfaUnlock>>, TError,{id: string}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof postTfaUnlock>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getPostTfaUnlockMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Add a panelist to the TFA panel
 */
export const postTfaPanelist = (
    id: string,
    postTfaPanelistBody: PostTfaPanelistBody,
 signal?: AbortSignal
) => {
      
      
      return customInstance<PostTfaPanelist201>(
      {url: `/api/tfa/${id}/panelists`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postTfaPanelistBody, signal
    },
      );
    }
  


export const getPostTfaPanelistMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postTfaPanelist>>, TError,{id: string;data: PostTfaPanelistBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postTfaPanelist>>, TError,{id: string;data: PostTfaPanelistBody}, TContext> => {

const mutationKey = ['postTfaPanelist'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postTfaPanelist>>, {id: string;data: PostTfaPanelistBody}> = (props) => {
          const {id,data} = props ?? {};

          return  postTfaPanelist(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostTfaPanelistMutationResult = NonNullable<Awaited<ReturnType<typeof postTfaPanelist>>>
    export type PostTfaPanelistMutationBody = PostTfaPanelistBody
    export type PostTfaPanelistMutationError = unknown

    /**
 * @summary Add a panelist to the TFA panel
 */
export const usePostTfaPanelist = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postTfaPanelist>>, TError,{id: string;data: PostTfaPanelistBody}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof postTfaPanelist>>,
        TError,
        {id: string;data: PostTfaPanelistBody},
        TContext
      > => {

      const mutationOptions = getPostTfaPanelistMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Confirm panelist participation
 */
export const postTfaPanelistConfirm = (
    panelId: string,
    panelistId: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<PostTfaPanelistConfirm200>(
      {url: `/api/tfa/${panelId}/panelists/${panelistId}/confirm`, method: 'POST', signal
    },
      );
    }
  


export const getPostTfaPanelistConfirmMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postTfaPanelistConfirm>>, TError,{panelId: string;panelistId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postTfaPanelistConfirm>>, TError,{panelId: string;panelistId: string}, TContext> => {

const mutationKey = ['postTfaPanelistConfirm'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postTfaPanelistConfirm>>, {panelId: string;panelistId: string}> = (props) => {
          const {panelId,panelistId} = props ?? {};

          return  postTfaPanelistConfirm(panelId,panelistId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostTfaPanelistConfirmMutationResult = NonNullable<Awaited<ReturnType<typeof postTfaPanelistConfirm>>>
    
    export type PostTfaPanelistConfirmMutationError = unknown

    /**
 * @summary Confirm panelist participation
 */
export const usePostTfaPanelistConfirm = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postTfaPanelistConfirm>>, TError,{panelId: string;panelistId: string}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof postTfaPanelistConfirm>>,
        TError,
        {panelId: string;panelistId: string},
        TContext
      > => {

      const mutationOptions = getPostTfaPanelistConfirmMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Remove a panelist from the TFA panel
 */
export const deleteTfaPanelist = (
    panelId: string,
    panelistId: string,
 ) => {
      
      
      return customInstance<void>(
      {url: `/api/tfa/${panelId}/panelists/${panelistId}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteTfaPanelistMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteTfaPanelist>>, TError,{panelId: string;panelistId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteTfaPanelist>>, TError,{panelId: string;panelistId: string}, TContext> => {

const mutationKey = ['deleteTfaPanelist'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteTfaPanelist>>, {panelId: string;panelistId: string}> = (props) => {
          const {panelId,panelistId} = props ?? {};

          return  deleteTfaPanelist(panelId,panelistId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteTfaPanelistMutationResult = NonNullable<Awaited<ReturnType<typeof deleteTfaPanelist>>>
    
    export type DeleteTfaPanelistMutationError = unknown

    /**
 * @summary Remove a panelist from the TFA panel
 */
export const useDeleteTfaPanelist = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteTfaPanelist>>, TError,{panelId: string;panelistId: string}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteTfaPanelist>>,
        TError,
        {panelId: string;panelistId: string},
        TContext
      > => {

      const mutationOptions = getDeleteTfaPanelistMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Set or unset a panelist as final approver
 */
export const patchTfaPanelistFinalApprover = (
    panelId: string,
    panelistId: string,
    patchTfaPanelistFinalApproverBody: PatchTfaPanelistFinalApproverBody,
 ) => {
      
      
      return customInstance<PatchTfaPanelistFinalApprover200>(
      {url: `/api/tfa/${panelId}/panelists/${panelistId}/set-final-approver`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchTfaPanelistFinalApproverBody
    },
      );
    }
  


export const getPatchTfaPanelistFinalApproverMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchTfaPanelistFinalApprover>>, TError,{panelId: string;panelistId: string;data: PatchTfaPanelistFinalApproverBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patchTfaPanelistFinalApprover>>, TError,{panelId: string;panelistId: string;data: PatchTfaPanelistFinalApproverBody}, TContext> => {

const mutationKey = ['patchTfaPanelistFinalApprover'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchTfaPanelistFinalApprover>>, {panelId: string;panelistId: string;data: PatchTfaPanelistFinalApproverBody}> = (props) => {
          const {panelId,panelistId,data} = props ?? {};

          return  patchTfaPanelistFinalApprover(panelId,panelistId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatchTfaPanelistFinalApproverMutationResult = NonNullable<Awaited<ReturnType<typeof patchTfaPanelistFinalApprover>>>
    export type PatchTfaPanelistFinalApproverMutationBody = PatchTfaPanelistFinalApproverBody
    export type PatchTfaPanelistFinalApproverMutationError = unknown

    /**
 * @summary Set or unset a panelist as final approver
 */
export const usePatchTfaPanelistFinalApprover = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchTfaPanelistFinalApprover>>, TError,{panelId: string;panelistId: string;data: PatchTfaPanelistFinalApproverBody}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof patchTfaPanelistFinalApprover>>,
        TError,
        {panelId: string;panelistId: string;data: PatchTfaPanelistFinalApproverBody},
        TContext
      > => {

      const mutationOptions = getPatchTfaPanelistFinalApproverMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Submit deliberation responses for a panelist
 */
export const postTfaPanelistDeliberate = (
    panelId: string,
    panelistId: string,
    postTfaPanelistDeliberateBody: PostTfaPanelistDeliberateBody,
 signal?: AbortSignal
) => {
      
      
      return customInstance<PostTfaPanelistDeliberate200>(
      {url: `/api/tfa/${panelId}/panelists/${panelistId}/deliberate`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postTfaPanelistDeliberateBody, signal
    },
      );
    }
  


export const getPostTfaPanelistDeliberateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postTfaPanelistDeliberate>>, TError,{panelId: string;panelistId: string;data: PostTfaPanelistDeliberateBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postTfaPanelistDeliberate>>, TError,{panelId: string;panelistId: string;data: PostTfaPanelistDeliberateBody}, TContext> => {

const mutationKey = ['postTfaPanelistDeliberate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postTfaPanelistDeliberate>>, {panelId: string;panelistId: string;data: PostTfaPanelistDeliberateBody}> = (props) => {
          const {panelId,panelistId,data} = props ?? {};

          return  postTfaPanelistDeliberate(panelId,panelistId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostTfaPanelistDeliberateMutationResult = NonNullable<Awaited<ReturnType<typeof postTfaPanelistDeliberate>>>
    export type PostTfaPanelistDeliberateMutationBody = PostTfaPanelistDeliberateBody
    export type PostTfaPanelistDeliberateMutationError = unknown

    /**
 * @summary Submit deliberation responses for a panelist
 */
export const usePostTfaPanelistDeliberate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postTfaPanelistDeliberate>>, TError,{panelId: string;panelistId: string;data: PostTfaPanelistDeliberateBody}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof postTfaPanelistDeliberate>>,
        TError,
        {panelId: string;panelistId: string;data: PostTfaPanelistDeliberateBody},
        TContext
      > => {

      const mutationOptions = getPostTfaPanelistDeliberateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Get all deliberation responses for a panel
 */
export const getTfaDeliberations = (
    panelId: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetTfaDeliberations200>(
      {url: `/api/tfa/${panelId}/deliberations`, method: 'GET', signal
    },
      );
    }
  



export const getGetTfaDeliberationsQueryKey = (panelId?: string,) => {
    return [
    `/api/tfa/${panelId}/deliberations`
    ] as const;
    }

    
export const getGetTfaDeliberationsQueryOptions = <TData = Awaited<ReturnType<typeof getTfaDeliberations>>, TError = unknown>(panelId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTfaDeliberations>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTfaDeliberationsQueryKey(panelId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTfaDeliberations>>> = ({ signal }) => getTfaDeliberations(panelId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(panelId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTfaDeliberations>>, TError, TData> & { queryKey: QueryKey }
}

export type GetTfaDeliberationsQueryResult = NonNullable<Awaited<ReturnType<typeof getTfaDeliberations>>>
export type GetTfaDeliberationsQueryError = unknown


/**
 * @summary Get all deliberation responses for a panel
 */

export function useGetTfaDeliberations<TData = Awaited<ReturnType<typeof getTfaDeliberations>>, TError = unknown>(
 panelId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTfaDeliberations>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetTfaDeliberationsQueryOptions(panelId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * @summary Trigger AI synthesis of panel deliberation responses
 */
export const postTfaSynthesize = (
    panelId: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<PostTfaSynthesize200>(
      {url: `/api/tfa/${panelId}/synthesize`, method: 'POST', signal
    },
      );
    }
  


export const getPostTfaSynthesizeMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postTfaSynthesize>>, TError,{panelId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postTfaSynthesize>>, TError,{panelId: string}, TContext> => {

const mutationKey = ['postTfaSynthesize'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postTfaSynthesize>>, {panelId: string}> = (props) => {
          const {panelId} = props ?? {};

          return  postTfaSynthesize(panelId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostTfaSynthesizeMutationResult = NonNullable<Awaited<ReturnType<typeof postTfaSynthesize>>>
    
    export type PostTfaSynthesizeMutationError = unknown

    /**
 * @summary Trigger AI synthesis of panel deliberation responses
 */
export const usePostTfaSynthesize = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postTfaSynthesize>>, TError,{panelId: string}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof postTfaSynthesize>>,
        TError,
        {panelId: string},
        TContext
      > => {

      const mutationOptions = getPostTfaSynthesizeMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Get projects where the current user has a pending TFA deliberation
 */
export const getMyPendingDeliberations = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetMyPendingDeliberations200>(
      {url: `/api/tfa/my-pending-deliberations`, method: 'GET', signal
    },
      );
    }
  



export const getGetMyPendingDeliberationsQueryKey = () => {
    return [
    `/api/tfa/my-pending-deliberations`
    ] as const;
    }

    
export const getGetMyPendingDeliberationsQueryOptions = <TData = Awaited<ReturnType<typeof getMyPendingDeliberations>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMyPendingDeliberations>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMyPendingDeliberationsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMyPendingDeliberations>>> = ({ signal }) => getMyPendingDeliberations(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMyPendingDeliberations>>, TError, TData> & { queryKey: QueryKey }
}

export type GetMyPendingDeliberationsQueryResult = NonNullable<Awaited<ReturnType<typeof getMyPendingDeliberations>>>
export type GetMyPendingDeliberationsQueryError = unknown


/**
 * @summary Get projects where the current user has a pending TFA deliberation
 */

export function useGetMyPendingDeliberations<TData = Awaited<ReturnType<typeof getMyPendingDeliberations>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMyPendingDeliberations>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetMyPendingDeliberationsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * @summary Record the final TFA determination
 */
export const postTfaDetermination = (
    id: string,
    postTfaDeterminationBody: PostTfaDeterminationBody,
 signal?: AbortSignal
) => {
      
      
      return customInstance<PostTfaDetermination201>(
      {url: `/api/tfa/${id}/determination`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postTfaDeterminationBody, signal
    },
      );
    }
  


export const getPostTfaDeterminationMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postTfaDetermination>>, TError,{id: string;data: PostTfaDeterminationBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postTfaDetermination>>, TError,{id: string;data: PostTfaDeterminationBody}, TContext> => {

const mutationKey = ['postTfaDetermination'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postTfaDetermination>>, {id: string;data: PostTfaDeterminationBody}> = (props) => {
          const {id,data} = props ?? {};

          return  postTfaDetermination(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostTfaDeterminationMutationResult = NonNullable<Awaited<ReturnType<typeof postTfaDetermination>>>
    export type PostTfaDeterminationMutationBody = PostTfaDeterminationBody
    export type PostTfaDeterminationMutationError = unknown

    /**
 * @summary Record the final TFA determination
 */
export const usePostTfaDetermination = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postTfaDetermination>>, TError,{id: string;data: PostTfaDeterminationBody}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof postTfaDetermination>>,
        TError,
        {id: string;data: PostTfaDeterminationBody},
        TContext
      > => {

      const mutationOptions = getPostTfaDeterminationMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Manually trigger AI draft regeneration for a TFA panel
 */
export const regenerateTfaDraft = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<RegenerateTfaDraft200>(
      {url: `/api/tfa/${id}/regenerate-draft`, method: 'POST', signal
    },
      );
    }
  


export const getRegenerateTfaDraftMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof regenerateTfaDraft>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof regenerateTfaDraft>>, TError,{id: string}, TContext> => {

const mutationKey = ['regenerateTfaDraft'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof regenerateTfaDraft>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  regenerateTfaDraft(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type RegenerateTfaDraftMutationResult = NonNullable<Awaited<ReturnType<typeof regenerateTfaDraft>>>
    
    export type RegenerateTfaDraftMutationError = void

    /**
 * @summary Manually trigger AI draft regeneration for a TFA panel
 */
export const useRegenerateTfaDraft = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof regenerateTfaDraft>>, TError,{id: string}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof regenerateTfaDraft>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getRegenerateTfaDraftMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary List activities for a project
 */
export const getProjectActivities = (
    projectId: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetProjectActivities200>(
      {url: `/api/projects/${projectId}/activities`, method: 'GET', signal
    },
      );
    }
  



export const getGetProjectActivitiesQueryKey = (projectId?: string,) => {
    return [
    `/api/projects/${projectId}/activities`
    ] as const;
    }

    
export const getGetProjectActivitiesQueryOptions = <TData = Awaited<ReturnType<typeof getProjectActivities>>, TError = unknown>(projectId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getProjectActivities>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProjectActivitiesQueryKey(projectId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProjectActivities>>> = ({ signal }) => getProjectActivities(projectId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(projectId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getProjectActivities>>, TError, TData> & { queryKey: QueryKey }
}

export type GetProjectActivitiesQueryResult = NonNullable<Awaited<ReturnType<typeof getProjectActivities>>>
export type GetProjectActivitiesQueryError = unknown


/**
 * @summary List activities for a project
 */

export function useGetProjectActivities<TData = Awaited<ReturnType<typeof getProjectActivities>>, TError = unknown>(
 projectId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getProjectActivities>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetProjectActivitiesQueryOptions(projectId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * @summary Create a new activity for a project
 */
export const createActivity = (
    projectId: string,
    createActivityBody: CreateActivityBody,
 signal?: AbortSignal
) => {
      
      
      return customInstance<CreateActivity201>(
      {url: `/api/projects/${projectId}/activities`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createActivityBody, signal
    },
      );
    }
  


export const getCreateActivityMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createActivity>>, TError,{projectId: string;data: CreateActivityBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createActivity>>, TError,{projectId: string;data: CreateActivityBody}, TContext> => {

const mutationKey = ['createActivity'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createActivity>>, {projectId: string;data: CreateActivityBody}> = (props) => {
          const {projectId,data} = props ?? {};

          return  createActivity(projectId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateActivityMutationResult = NonNullable<Awaited<ReturnType<typeof createActivity>>>
    export type CreateActivityMutationBody = CreateActivityBody
    export type CreateActivityMutationError = unknown

    /**
 * @summary Create a new activity for a project
 */
export const useCreateActivity = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createActivity>>, TError,{projectId: string;data: CreateActivityBody}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof createActivity>>,
        TError,
        {projectId: string;data: CreateActivityBody},
        TContext
      > => {

      const mutationOptions = getCreateActivityMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Get a single activity with competence records
 */
export const getActivity = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetActivity200>(
      {url: `/api/activities/${id}`, method: 'GET', signal
    },
      );
    }
  



export const getGetActivityQueryKey = (id?: string,) => {
    return [
    `/api/activities/${id}`
    ] as const;
    }

    
export const getGetActivityQueryOptions = <TData = Awaited<ReturnType<typeof getActivity>>, TError = void>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getActivity>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetActivityQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getActivity>>> = ({ signal }) => getActivity(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getActivity>>, TError, TData> & { queryKey: QueryKey }
}

export type GetActivityQueryResult = NonNullable<Awaited<ReturnType<typeof getActivity>>>
export type GetActivityQueryError = void


/**
 * @summary Get a single activity with competence records
 */

export function useGetActivity<TData = Awaited<ReturnType<typeof getActivity>>, TError = void>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getActivity>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetActivityQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * @summary Create a competence record for an activity
 */
export const createCompetenceRecord = (
    id: string,
    createCompetenceRecordBody: CreateCompetenceRecordBody,
 signal?: AbortSignal
) => {
      
      
      return customInstance<CreateCompetenceRecord201>(
      {url: `/api/activities/${id}/competence-records`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createCompetenceRecordBody, signal
    },
      );
    }
  


export const getCreateCompetenceRecordMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCompetenceRecord>>, TError,{id: string;data: CreateCompetenceRecordBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createCompetenceRecord>>, TError,{id: string;data: CreateCompetenceRecordBody}, TContext> => {

const mutationKey = ['createCompetenceRecord'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createCompetenceRecord>>, {id: string;data: CreateCompetenceRecordBody}> = (props) => {
          const {id,data} = props ?? {};

          return  createCompetenceRecord(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateCompetenceRecordMutationResult = NonNullable<Awaited<ReturnType<typeof createCompetenceRecord>>>
    export type CreateCompetenceRecordMutationBody = CreateCompetenceRecordBody
    export type CreateCompetenceRecordMutationError = unknown

    /**
 * @summary Create a competence record for an activity
 */
export const useCreateCompetenceRecord = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCompetenceRecord>>, TError,{id: string;data: CreateCompetenceRecordBody}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof createCompetenceRecord>>,
        TError,
        {id: string;data: CreateCompetenceRecordBody},
        TContext
      > => {

      const mutationOptions = getCreateCompetenceRecordMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary List signal sources (tenant-level GitHub repos)
 */
export const getSignals = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetSignals200>(
      {url: `/api/signals`, method: 'GET', signal
    },
      );
    }
  



export const getGetSignalsQueryKey = () => {
    return [
    `/api/signals`
    ] as const;
    }

    
export const getGetSignalsQueryOptions = <TData = Awaited<ReturnType<typeof getSignals>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSignals>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSignalsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSignals>>> = ({ signal }) => getSignals(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSignals>>, TError, TData> & { queryKey: QueryKey }
}

export type GetSignalsQueryResult = NonNullable<Awaited<ReturnType<typeof getSignals>>>
export type GetSignalsQueryError = unknown


/**
 * @summary List signal sources (tenant-level GitHub repos)
 */

export function useGetSignals<TData = Awaited<ReturnType<typeof getSignals>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSignals>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetSignalsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * @summary Connect a GitHub repo as a tenant-level signal source
 */
export const createSignal = (
    createSignalBody: CreateSignalBody,
 signal?: AbortSignal
) => {
      
      
      return customInstance<CreateSignal201>(
      {url: `/api/signals`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createSignalBody, signal
    },
      );
    }
  


export const getCreateSignalMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createSignal>>, TError,{data: CreateSignalBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createSignal>>, TError,{data: CreateSignalBody}, TContext> => {

const mutationKey = ['createSignal'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createSignal>>, {data: CreateSignalBody}> = (props) => {
          const {data} = props ?? {};

          return  createSignal(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateSignalMutationResult = NonNullable<Awaited<ReturnType<typeof createSignal>>>
    export type CreateSignalMutationBody = CreateSignalBody
    export type CreateSignalMutationError = unknown

    /**
 * @summary Connect a GitHub repo as a tenant-level signal source
 */
export const useCreateSignal = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createSignal>>, TError,{data: CreateSignalBody}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof createSignal>>,
        TError,
        {data: CreateSignalBody},
        TContext
      > => {

      const mutationOptions = getCreateSignalMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Disconnect a signal source
 */
export const deleteSignal = (
    id: string,
 ) => {
      
      
      return customInstance<void>(
      {url: `/api/signals/${id}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteSignalMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteSignal>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteSignal>>, TError,{id: string}, TContext> => {

const mutationKey = ['deleteSignal'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteSignal>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteSignal(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteSignalMutationResult = NonNullable<Awaited<ReturnType<typeof deleteSignal>>>
    
    export type DeleteSignalMutationError = unknown

    /**
 * @summary Disconnect a signal source
 */
export const useDeleteSignal = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteSignal>>, TError,{id: string}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteSignal>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteSignalMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Re-fetch PRD.md from the connected GitHub repo and update the prd_document artefact
 */
export const syncSignalPrd = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<SyncSignalPrd200>(
      {url: `/api/signals/${id}/sync-prd`, method: 'POST', signal
    },
      );
    }
  


export const getSyncSignalPrdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof syncSignalPrd>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof syncSignalPrd>>, TError,{id: string}, TContext> => {

const mutationKey = ['syncSignalPrd'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof syncSignalPrd>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  syncSignalPrd(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SyncSignalPrdMutationResult = NonNullable<Awaited<ReturnType<typeof syncSignalPrd>>>
    
    export type SyncSignalPrdMutationError = void

    /**
 * @summary Re-fetch PRD.md from the connected GitHub repo and update the prd_document artefact
 */
export const useSyncSignalPrd = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof syncSignalPrd>>, TError,{id: string}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof syncSignalPrd>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getSyncSignalPrdMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary List pending abandoned work candidates
 */
export const getAbandonedWorkCandidates = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetAbandonedWorkCandidates200>(
      {url: `/api/signals/candidates`, method: 'GET', signal
    },
      );
    }
  



export const getGetAbandonedWorkCandidatesQueryKey = () => {
    return [
    `/api/signals/candidates`
    ] as const;
    }

    
export const getGetAbandonedWorkCandidatesQueryOptions = <TData = Awaited<ReturnType<typeof getAbandonedWorkCandidates>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAbandonedWorkCandidates>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAbandonedWorkCandidatesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAbandonedWorkCandidates>>> = ({ signal }) => getAbandonedWorkCandidates(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAbandonedWorkCandidates>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAbandonedWorkCandidatesQueryResult = NonNullable<Awaited<ReturnType<typeof getAbandonedWorkCandidates>>>
export type GetAbandonedWorkCandidatesQueryError = unknown


/**
 * @summary List pending abandoned work candidates
 */

export function useGetAbandonedWorkCandidates<TData = Awaited<ReturnType<typeof getAbandonedWorkCandidates>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAbandonedWorkCandidates>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAbandonedWorkCandidatesQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * @summary Dismiss or confirm an abandoned work candidate
 */
export const patchAbandonedWorkCandidate = (
    id: string,
    patchAbandonedWorkCandidateBody: PatchAbandonedWorkCandidateBody,
 ) => {
      
      
      return customInstance<PatchAbandonedWorkCandidate200>(
      {url: `/api/signals/candidates/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchAbandonedWorkCandidateBody
    },
      );
    }
  


export const getPatchAbandonedWorkCandidateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchAbandonedWorkCandidate>>, TError,{id: string;data: PatchAbandonedWorkCandidateBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patchAbandonedWorkCandidate>>, TError,{id: string;data: PatchAbandonedWorkCandidateBody}, TContext> => {

const mutationKey = ['patchAbandonedWorkCandidate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchAbandonedWorkCandidate>>, {id: string;data: PatchAbandonedWorkCandidateBody}> = (props) => {
          const {id,data} = props ?? {};

          return  patchAbandonedWorkCandidate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatchAbandonedWorkCandidateMutationResult = NonNullable<Awaited<ReturnType<typeof patchAbandonedWorkCandidate>>>
    export type PatchAbandonedWorkCandidateMutationBody = PatchAbandonedWorkCandidateBody
    export type PatchAbandonedWorkCandidateMutationError = unknown

    /**
 * @summary Dismiss or confirm an abandoned work candidate
 */
export const usePatchAbandonedWorkCandidate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchAbandonedWorkCandidate>>, TError,{id: string;data: PatchAbandonedWorkCandidateBody}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof patchAbandonedWorkCandidate>>,
        TError,
        {id: string;data: PatchAbandonedWorkCandidateBody},
        TContext
      > => {

      const mutationOptions = getPatchAbandonedWorkCandidateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Extract signals from an abandoned work candidate using Claude
 */
export const extractAbandonedWork = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<ExtractAbandonedWork200>(
      {url: `/api/signals/candidates/${id}/extract`, method: 'POST', signal
    },
      );
    }
  


export const getExtractAbandonedWorkMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof extractAbandonedWork>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof extractAbandonedWork>>, TError,{id: string}, TContext> => {

const mutationKey = ['extractAbandonedWork'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof extractAbandonedWork>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  extractAbandonedWork(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ExtractAbandonedWorkMutationResult = NonNullable<Awaited<ReturnType<typeof extractAbandonedWork>>>
    
    export type ExtractAbandonedWorkMutationError = unknown

    /**
 * @summary Extract signals from an abandoned work candidate using Claude
 */
export const useExtractAbandonedWork = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof extractAbandonedWork>>, TError,{id: string}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof extractAbandonedWork>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getExtractAbandonedWorkMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary List all repos accessible via the GitHub App installation
 */
export const getSignalAvailableRepos = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetSignalAvailableRepos200>(
      {url: `/api/signals/available-repos`, method: 'GET', signal
    },
      );
    }
  



export const getGetSignalAvailableReposQueryKey = () => {
    return [
    `/api/signals/available-repos`
    ] as const;
    }

    
export const getGetSignalAvailableReposQueryOptions = <TData = Awaited<ReturnType<typeof getSignalAvailableRepos>>, TError = void>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSignalAvailableRepos>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSignalAvailableReposQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSignalAvailableRepos>>> = ({ signal }) => getSignalAvailableRepos(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSignalAvailableRepos>>, TError, TData> & { queryKey: QueryKey }
}

export type GetSignalAvailableReposQueryResult = NonNullable<Awaited<ReturnType<typeof getSignalAvailableRepos>>>
export type GetSignalAvailableReposQueryError = void


/**
 * @summary List all repos accessible via the GitHub App installation
 */

export function useGetSignalAvailableRepos<TData = Awaited<ReturnType<typeof getSignalAvailableRepos>>, TError = void>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSignalAvailableRepos>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetSignalAvailableReposQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * @summary Preview a repo's activity before linking to a project
 */
export const getSignalRepoPreview = (
    params: GetSignalRepoPreviewParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetSignalRepoPreview200>(
      {url: `/api/signals/repo-preview`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getGetSignalRepoPreviewQueryKey = (params?: GetSignalRepoPreviewParams,) => {
    return [
    `/api/signals/repo-preview`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetSignalRepoPreviewQueryOptions = <TData = Awaited<ReturnType<typeof getSignalRepoPreview>>, TError = void>(params: GetSignalRepoPreviewParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSignalRepoPreview>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSignalRepoPreviewQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSignalRepoPreview>>> = ({ signal }) => getSignalRepoPreview(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSignalRepoPreview>>, TError, TData> & { queryKey: QueryKey }
}

export type GetSignalRepoPreviewQueryResult = NonNullable<Awaited<ReturnType<typeof getSignalRepoPreview>>>
export type GetSignalRepoPreviewQueryError = void


/**
 * @summary Preview a repo's activity before linking to a project
 */

export function useGetSignalRepoPreview<TData = Awaited<ReturnType<typeof getSignalRepoPreview>>, TError = void>(
 params: GetSignalRepoPreviewParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSignalRepoPreview>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetSignalRepoPreviewQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * @summary Aggregated commit activity by repo for the stacked area chart
 */
export const getSignalActivityChart = (
    params: GetSignalActivityChartParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetSignalActivityChart200>(
      {url: `/api/signals/activity-chart`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getGetSignalActivityChartQueryKey = (params?: GetSignalActivityChartParams,) => {
    return [
    `/api/signals/activity-chart`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetSignalActivityChartQueryOptions = <TData = Awaited<ReturnType<typeof getSignalActivityChart>>, TError = void>(params: GetSignalActivityChartParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSignalActivityChart>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSignalActivityChartQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSignalActivityChart>>> = ({ signal }) => getSignalActivityChart(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSignalActivityChart>>, TError, TData> & { queryKey: QueryKey }
}

export type GetSignalActivityChartQueryResult = NonNullable<Awaited<ReturnType<typeof getSignalActivityChart>>>
export type GetSignalActivityChartQueryError = void


/**
 * @summary Aggregated commit activity by repo for the stacked area chart
 */

export function useGetSignalActivityChart<TData = Awaited<ReturnType<typeof getSignalActivityChart>>, TError = void>(
 params: GetSignalActivityChartParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSignalActivityChart>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetSignalActivityChartQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * @summary List claims for the tenant
 */
export const getClaims = (
    params?: GetClaimsParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetClaims200>(
      {url: `/api/claims`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getGetClaimsQueryKey = (params?: GetClaimsParams,) => {
    return [
    `/api/claims`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetClaimsQueryOptions = <TData = Awaited<ReturnType<typeof getClaims>>, TError = unknown>(params?: GetClaimsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getClaims>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetClaimsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getClaims>>> = ({ signal }) => getClaims(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getClaims>>, TError, TData> & { queryKey: QueryKey }
}

export type GetClaimsQueryResult = NonNullable<Awaited<ReturnType<typeof getClaims>>>
export type GetClaimsQueryError = unknown


/**
 * @summary List claims for the tenant
 */

export function useGetClaims<TData = Awaited<ReturnType<typeof getClaims>>, TError = unknown>(
 params?: GetClaimsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getClaims>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetClaimsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * @summary Create a new claim
 */
export const createClaim = (
    createClaimBody: CreateClaimBody,
 signal?: AbortSignal
) => {
      
      
      return customInstance<CreateClaim201>(
      {url: `/api/claims`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createClaimBody, signal
    },
      );
    }
  


export const getCreateClaimMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createClaim>>, TError,{data: CreateClaimBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createClaim>>, TError,{data: CreateClaimBody}, TContext> => {

const mutationKey = ['createClaim'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createClaim>>, {data: CreateClaimBody}> = (props) => {
          const {data} = props ?? {};

          return  createClaim(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateClaimMutationResult = NonNullable<Awaited<ReturnType<typeof createClaim>>>
    export type CreateClaimMutationBody = CreateClaimBody
    export type CreateClaimMutationError = unknown

    /**
 * @summary Create a new claim
 */
export const useCreateClaim = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createClaim>>, TError,{data: CreateClaimBody}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof createClaim>>,
        TError,
        {data: CreateClaimBody},
        TContext
      > => {

      const mutationOptions = getCreateClaimMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Get a claim
 */
export const getClaim = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetClaim200>(
      {url: `/api/claims/${id}`, method: 'GET', signal
    },
      );
    }
  



export const getGetClaimQueryKey = (id?: string,) => {
    return [
    `/api/claims/${id}`
    ] as const;
    }

    
export const getGetClaimQueryOptions = <TData = Awaited<ReturnType<typeof getClaim>>, TError = void>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getClaim>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetClaimQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getClaim>>> = ({ signal }) => getClaim(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getClaim>>, TError, TData> & { queryKey: QueryKey }
}

export type GetClaimQueryResult = NonNullable<Awaited<ReturnType<typeof getClaim>>>
export type GetClaimQueryError = void


/**
 * @summary Get a claim
 */

export function useGetClaim<TData = Awaited<ReturnType<typeof getClaim>>, TError = void>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getClaim>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetClaimQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * @summary Delete a draft claim (draft status only)
 */
export const deleteClaim = (
    id: string,
 ) => {
      
      
      return customInstance<void>(
      {url: `/api/claims/${id}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteClaimMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteClaim>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteClaim>>, TError,{id: string}, TContext> => {

const mutationKey = ['deleteClaim'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteClaim>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteClaim(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteClaimMutationResult = NonNullable<Awaited<ReturnType<typeof deleteClaim>>>
    
    export type DeleteClaimMutationError = void

    /**
 * @summary Delete a draft claim (draft status only)
 */
export const useDeleteClaim = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteClaim>>, TError,{id: string}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteClaim>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteClaimMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Run the pre-lock validation checklist
 */
export const validateClaim = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<ValidateClaim200>(
      {url: `/api/claims/${id}/validate`, method: 'POST', signal
    },
      );
    }
  


export const getValidateClaimMutationOptions = <TError = ValidateClaim422,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof validateClaim>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof validateClaim>>, TError,{id: string}, TContext> => {

const mutationKey = ['validateClaim'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof validateClaim>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  validateClaim(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ValidateClaimMutationResult = NonNullable<Awaited<ReturnType<typeof validateClaim>>>
    
    export type ValidateClaimMutationError = ValidateClaim422

    /**
 * @summary Run the pre-lock validation checklist
 */
export const useValidateClaim = <TError = ValidateClaim422,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof validateClaim>>, TError,{id: string}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof validateClaim>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getValidateClaimMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Lock a claim (no further edits after lock)
 */
export const lockClaim = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<LockClaim200>(
      {url: `/api/claims/${id}/lock`, method: 'POST', signal
    },
      );
    }
  


export const getLockClaimMutationOptions = <TError = LockClaim422,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof lockClaim>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof lockClaim>>, TError,{id: string}, TContext> => {

const mutationKey = ['lockClaim'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof lockClaim>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  lockClaim(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type LockClaimMutationResult = NonNullable<Awaited<ReturnType<typeof lockClaim>>>
    
    export type LockClaimMutationError = LockClaim422

    /**
 * @summary Lock a claim (no further edits after lock)
 */
export const useLockClaim = <TError = LockClaim422,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof lockClaim>>, TError,{id: string}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof lockClaim>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getLockClaimMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Get working papers for a claim
 */
export const getClaimWorkingPapers = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<WorkingPapersResponse>(
      {url: `/api/claims/${id}/working-papers`, method: 'GET', signal
    },
      );
    }
  



export const getGetClaimWorkingPapersQueryKey = (id?: string,) => {
    return [
    `/api/claims/${id}/working-papers`
    ] as const;
    }

    
export const getGetClaimWorkingPapersQueryOptions = <TData = Awaited<ReturnType<typeof getClaimWorkingPapers>>, TError = Error>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getClaimWorkingPapers>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetClaimWorkingPapersQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getClaimWorkingPapers>>> = ({ signal }) => getClaimWorkingPapers(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getClaimWorkingPapers>>, TError, TData> & { queryKey: QueryKey }
}

export type GetClaimWorkingPapersQueryResult = NonNullable<Awaited<ReturnType<typeof getClaimWorkingPapers>>>
export type GetClaimWorkingPapersQueryError = Error


/**
 * @summary Get working papers for a claim
 */

export function useGetClaimWorkingPapers<TData = Awaited<ReturnType<typeof getClaimWorkingPapers>>, TError = Error>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getClaimWorkingPapers>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetClaimWorkingPapersQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * @summary Validate and lock claim in one step
 */
export const prepareClaimForLock = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<PrepareClaimForLock200>(
      {url: `/api/claims/${id}/prepare`, method: 'POST', signal
    },
      );
    }
  


export const getPrepareClaimForLockMutationOptions = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof prepareClaimForLock>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof prepareClaimForLock>>, TError,{id: string}, TContext> => {

const mutationKey = ['prepareClaimForLock'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof prepareClaimForLock>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  prepareClaimForLock(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PrepareClaimForLockMutationResult = NonNullable<Awaited<ReturnType<typeof prepareClaimForLock>>>
    
    export type PrepareClaimForLockMutationError = Error

    /**
 * @summary Validate and lock claim in one step
 */
export const usePrepareClaimForLock = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof prepareClaimForLock>>, TError,{id: string}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof prepareClaimForLock>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getPrepareClaimForLockMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary List access tokens for a claim
 */
export const getAccessTokens = (
    params: GetAccessTokensParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetAccessTokens200>(
      {url: `/api/access-tokens`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getGetAccessTokensQueryKey = (params?: GetAccessTokensParams,) => {
    return [
    `/api/access-tokens`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetAccessTokensQueryOptions = <TData = Awaited<ReturnType<typeof getAccessTokens>>, TError = unknown>(params: GetAccessTokensParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAccessTokens>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAccessTokensQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAccessTokens>>> = ({ signal }) => getAccessTokens(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAccessTokens>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAccessTokensQueryResult = NonNullable<Awaited<ReturnType<typeof getAccessTokens>>>
export type GetAccessTokensQueryError = unknown


/**
 * @summary List access tokens for a claim
 */

export function useGetAccessTokens<TData = Awaited<ReturnType<typeof getAccessTokens>>, TError = unknown>(
 params: GetAccessTokensParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAccessTokens>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAccessTokensQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * @summary Issue a new access token (raw returned once, hash stored)
 */
export const createAccessToken = (
    createAccessTokenBody: CreateAccessTokenBody,
 signal?: AbortSignal
) => {
      
      
      return customInstance<CreateAccessToken201>(
      {url: `/api/access-tokens`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createAccessTokenBody, signal
    },
      );
    }
  


export const getCreateAccessTokenMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAccessToken>>, TError,{data: CreateAccessTokenBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createAccessToken>>, TError,{data: CreateAccessTokenBody}, TContext> => {

const mutationKey = ['createAccessToken'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createAccessToken>>, {data: CreateAccessTokenBody}> = (props) => {
          const {data} = props ?? {};

          return  createAccessToken(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateAccessTokenMutationResult = NonNullable<Awaited<ReturnType<typeof createAccessToken>>>
    export type CreateAccessTokenMutationBody = CreateAccessTokenBody
    export type CreateAccessTokenMutationError = unknown

    /**
 * @summary Issue a new access token (raw returned once, hash stored)
 */
export const useCreateAccessToken = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAccessToken>>, TError,{data: CreateAccessTokenBody}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof createAccessToken>>,
        TError,
        {data: CreateAccessTokenBody},
        TContext
      > => {

      const mutationOptions = getCreateAccessTokenMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Revoke an access token
 */
export const revokeAccessToken = (
    id: string,
    revokeAccessTokenBody: RevokeAccessTokenBody,
 signal?: AbortSignal
) => {
      
      
      return customInstance<RevokeAccessToken200>(
      {url: `/api/access-tokens/${id}/revoke`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: revokeAccessTokenBody, signal
    },
      );
    }
  


export const getRevokeAccessTokenMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof revokeAccessToken>>, TError,{id: string;data: RevokeAccessTokenBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof revokeAccessToken>>, TError,{id: string;data: RevokeAccessTokenBody}, TContext> => {

const mutationKey = ['revokeAccessToken'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof revokeAccessToken>>, {id: string;data: RevokeAccessTokenBody}> = (props) => {
          const {id,data} = props ?? {};

          return  revokeAccessToken(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type RevokeAccessTokenMutationResult = NonNullable<Awaited<ReturnType<typeof revokeAccessToken>>>
    export type RevokeAccessTokenMutationBody = RevokeAccessTokenBody
    export type RevokeAccessTokenMutationError = unknown

    /**
 * @summary Revoke an access token
 */
export const useRevokeAccessToken = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof revokeAccessToken>>, TError,{id: string;data: RevokeAccessTokenBody}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof revokeAccessToken>>,
        TError,
        {id: string;data: RevokeAccessTokenBody},
        TContext
      > => {

      const mutationOptions = getRevokeAccessTokenMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary List claim access grants for a claim (admin only)
 */
export const getClaimAccessGrants = (
    params: GetClaimAccessGrantsParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetClaimAccessGrants200>(
      {url: `/api/claim-access-grants`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getGetClaimAccessGrantsQueryKey = (params?: GetClaimAccessGrantsParams,) => {
    return [
    `/api/claim-access-grants`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetClaimAccessGrantsQueryOptions = <TData = Awaited<ReturnType<typeof getClaimAccessGrants>>, TError = unknown>(params: GetClaimAccessGrantsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getClaimAccessGrants>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetClaimAccessGrantsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getClaimAccessGrants>>> = ({ signal }) => getClaimAccessGrants(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getClaimAccessGrants>>, TError, TData> & { queryKey: QueryKey }
}

export type GetClaimAccessGrantsQueryResult = NonNullable<Awaited<ReturnType<typeof getClaimAccessGrants>>>
export type GetClaimAccessGrantsQueryError = unknown


/**
 * @summary List claim access grants for a claim (admin only)
 */

export function useGetClaimAccessGrants<TData = Awaited<ReturnType<typeof getClaimAccessGrants>>, TError = unknown>(
 params: GetClaimAccessGrantsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getClaimAccessGrants>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetClaimAccessGrantsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * @summary Invite (or re-grant) an authenticated external reviewer for a claim
 */
export const createClaimAccessGrant = (
    createClaimAccessGrantBody: CreateClaimAccessGrantBody,
 signal?: AbortSignal
) => {
      
      
      return customInstance<CreateClaimAccessGrant201>(
      {url: `/api/claim-access-grants`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createClaimAccessGrantBody, signal
    },
      );
    }
  


export const getCreateClaimAccessGrantMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createClaimAccessGrant>>, TError,{data: CreateClaimAccessGrantBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createClaimAccessGrant>>, TError,{data: CreateClaimAccessGrantBody}, TContext> => {

const mutationKey = ['createClaimAccessGrant'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createClaimAccessGrant>>, {data: CreateClaimAccessGrantBody}> = (props) => {
          const {data} = props ?? {};

          return  createClaimAccessGrant(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateClaimAccessGrantMutationResult = NonNullable<Awaited<ReturnType<typeof createClaimAccessGrant>>>
    export type CreateClaimAccessGrantMutationBody = CreateClaimAccessGrantBody
    export type CreateClaimAccessGrantMutationError = unknown

    /**
 * @summary Invite (or re-grant) an authenticated external reviewer for a claim
 */
export const useCreateClaimAccessGrant = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createClaimAccessGrant>>, TError,{data: CreateClaimAccessGrantBody}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof createClaimAccessGrant>>,
        TError,
        {data: CreateClaimAccessGrantBody},
        TContext
      > => {

      const mutationOptions = getCreateClaimAccessGrantMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Revoke a claim access grant (kills portal access immediately)
 */
export const revokeClaimAccessGrant = (
    id: string,
 ) => {
      
      
      return customInstance<RevokeClaimAccessGrant200>(
      {url: `/api/claim-access-grants/${id}`, method: 'DELETE'
    },
      );
    }
  


export const getRevokeClaimAccessGrantMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof revokeClaimAccessGrant>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof revokeClaimAccessGrant>>, TError,{id: string}, TContext> => {

const mutationKey = ['revokeClaimAccessGrant'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof revokeClaimAccessGrant>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  revokeClaimAccessGrant(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type RevokeClaimAccessGrantMutationResult = NonNullable<Awaited<ReturnType<typeof revokeClaimAccessGrant>>>
    
    export type RevokeClaimAccessGrantMutationError = unknown

    /**
 * @summary Revoke a claim access grant (kills portal access immediately)
 */
export const useRevokeClaimAccessGrant = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof revokeClaimAccessGrant>>, TError,{id: string}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof revokeClaimAccessGrant>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getRevokeClaimAccessGrantMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * The Group B reviewer "landing page" endpoint — called before a claim has been picked, so it carries no X-Claim-Id and is guarded by requireReviewer (identity only) rather than requireClaimGrant. Returns only the caller's own active (not revoked, not expired) grants.
 * @summary List the authenticated external reviewer's own active claim access grants
 */
export const getReviewerClaims = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetReviewerClaims200>(
      {url: `/api/reviewer/claims`, method: 'GET', signal
    },
      );
    }
  



export const getGetReviewerClaimsQueryKey = () => {
    return [
    `/api/reviewer/claims`
    ] as const;
    }

    
export const getGetReviewerClaimsQueryOptions = <TData = Awaited<ReturnType<typeof getReviewerClaims>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getReviewerClaims>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetReviewerClaimsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getReviewerClaims>>> = ({ signal }) => getReviewerClaims(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getReviewerClaims>>, TError, TData> & { queryKey: QueryKey }
}

export type GetReviewerClaimsQueryResult = NonNullable<Awaited<ReturnType<typeof getReviewerClaims>>>
export type GetReviewerClaimsQueryError = unknown


/**
 * @summary List the authenticated external reviewer's own active claim access grants
 */

export function useGetReviewerClaims<TData = Awaited<ReturnType<typeof getReviewerClaims>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getReviewerClaims>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetReviewerClaimsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * @summary List audit log entries with optional filters
 */
export const getAuditLog = (
    params?: GetAuditLogParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetAuditLog200>(
      {url: `/api/audit`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getGetAuditLogQueryKey = (params?: GetAuditLogParams,) => {
    return [
    `/api/audit`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetAuditLogQueryOptions = <TData = Awaited<ReturnType<typeof getAuditLog>>, TError = unknown>(params?: GetAuditLogParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAuditLog>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAuditLogQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAuditLog>>> = ({ signal }) => getAuditLog(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAuditLog>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAuditLogQueryResult = NonNullable<Awaited<ReturnType<typeof getAuditLog>>>
export type GetAuditLogQueryError = unknown


/**
 * @summary List audit log entries with optional filters
 */

export function useGetAuditLog<TData = Awaited<ReturnType<typeof getAuditLog>>, TError = unknown>(
 params?: GetAuditLogParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAuditLog>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAuditLogQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * @summary List active artefact links (optionally filtered by sourceId or targetId)
 */
export const getLinks = (
    params?: GetLinksParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetLinks200>(
      {url: `/api/links`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getGetLinksQueryKey = (params?: GetLinksParams,) => {
    return [
    `/api/links`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetLinksQueryOptions = <TData = Awaited<ReturnType<typeof getLinks>>, TError = unknown>(params?: GetLinksParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getLinks>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLinksQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLinks>>> = ({ signal }) => getLinks(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLinks>>, TError, TData> & { queryKey: QueryKey }
}

export type GetLinksQueryResult = NonNullable<Awaited<ReturnType<typeof getLinks>>>
export type GetLinksQueryError = unknown


/**
 * @summary List active artefact links (optionally filtered by sourceId or targetId)
 */

export function useGetLinks<TData = Awaited<ReturnType<typeof getLinks>>, TError = unknown>(
 params?: GetLinksParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getLinks>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetLinksQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * @summary Create an artefact link
 */
export const createLink = (
    createLinkBody: CreateLinkBody,
 signal?: AbortSignal
) => {
      
      
      return customInstance<CreateLink201>(
      {url: `/api/links`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createLinkBody, signal
    },
      );
    }
  


export const getCreateLinkMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createLink>>, TError,{data: CreateLinkBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createLink>>, TError,{data: CreateLinkBody}, TContext> => {

const mutationKey = ['createLink'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createLink>>, {data: CreateLinkBody}> = (props) => {
          const {data} = props ?? {};

          return  createLink(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateLinkMutationResult = NonNullable<Awaited<ReturnType<typeof createLink>>>
    export type CreateLinkMutationBody = CreateLinkBody
    export type CreateLinkMutationError = unknown

    /**
 * @summary Create an artefact link
 */
export const useCreateLink = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createLink>>, TError,{data: CreateLinkBody}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof createLink>>,
        TError,
        {data: CreateLinkBody},
        TContext
      > => {

      const mutationOptions = getCreateLinkMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Soft-delete an artefact link
 */
export const deleteLink = (
    id: string,
 ) => {
      
      
      return customInstance<void>(
      {url: `/api/links/${id}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteLinkMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteLink>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteLink>>, TError,{id: string}, TContext> => {

const mutationKey = ['deleteLink'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteLink>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteLink(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteLinkMutationResult = NonNullable<Awaited<ReturnType<typeof deleteLink>>>
    
    export type DeleteLinkMutationError = unknown

    /**
 * @summary Soft-delete an artefact link
 */
export const useDeleteLink = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteLink>>, TError,{id: string}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteLink>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteLinkMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Get non-labour expenditure summary for a financial year
 */
export const getExpenditureSummary = (
    params: GetExpenditureSummaryParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetExpenditureSummary200>(
      {url: `/api/expenditure/summary`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getGetExpenditureSummaryQueryKey = (params?: GetExpenditureSummaryParams,) => {
    return [
    `/api/expenditure/summary`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetExpenditureSummaryQueryOptions = <TData = Awaited<ReturnType<typeof getExpenditureSummary>>, TError = unknown>(params: GetExpenditureSummaryParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getExpenditureSummary>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetExpenditureSummaryQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getExpenditureSummary>>> = ({ signal }) => getExpenditureSummary(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getExpenditureSummary>>, TError, TData> & { queryKey: QueryKey }
}

export type GetExpenditureSummaryQueryResult = NonNullable<Awaited<ReturnType<typeof getExpenditureSummary>>>
export type GetExpenditureSummaryQueryError = unknown


/**
 * @summary Get non-labour expenditure summary for a financial year
 */

export function useGetExpenditureSummary<TData = Awaited<ReturnType<typeof getExpenditureSummary>>, TError = unknown>(
 params: GetExpenditureSummaryParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getExpenditureSummary>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetExpenditureSummaryQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * @summary List cost allocation line items for a financial year
 */
export const getExpenditureLineItems = (
    params: GetExpenditureLineItemsParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetExpenditureLineItems200>(
      {url: `/api/expenditure/line-items`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getGetExpenditureLineItemsQueryKey = (params?: GetExpenditureLineItemsParams,) => {
    return [
    `/api/expenditure/line-items`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetExpenditureLineItemsQueryOptions = <TData = Awaited<ReturnType<typeof getExpenditureLineItems>>, TError = unknown>(params: GetExpenditureLineItemsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getExpenditureLineItems>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetExpenditureLineItemsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getExpenditureLineItems>>> = ({ signal }) => getExpenditureLineItems(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getExpenditureLineItems>>, TError, TData> & { queryKey: QueryKey }
}

export type GetExpenditureLineItemsQueryResult = NonNullable<Awaited<ReturnType<typeof getExpenditureLineItems>>>
export type GetExpenditureLineItemsQueryError = unknown


/**
 * @summary List cost allocation line items for a financial year
 */

export function useGetExpenditureLineItems<TData = Awaited<ReturnType<typeof getExpenditureLineItems>>, TError = unknown>(
 params: GetExpenditureLineItemsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getExpenditureLineItems>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetExpenditureLineItemsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * @summary Trigger immediate sync for a provider — stores costs with claimId null
 */
export const syncExpenditureProvider = (
    provider: 'aws' | 'gcp' | 'openai' | 'anthropic' | 'replit',
 signal?: AbortSignal
) => {
      
      
      return customInstance<SyncExpenditureProvider200>(
      {url: `/api/expenditure/sync/${provider}`, method: 'POST', signal
    },
      );
    }
  


export const getSyncExpenditureProviderMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof syncExpenditureProvider>>, TError,{provider: 'aws' | 'gcp' | 'openai' | 'anthropic' | 'replit'}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof syncExpenditureProvider>>, TError,{provider: 'aws' | 'gcp' | 'openai' | 'anthropic' | 'replit'}, TContext> => {

const mutationKey = ['syncExpenditureProvider'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof syncExpenditureProvider>>, {provider: 'aws' | 'gcp' | 'openai' | 'anthropic' | 'replit'}> = (props) => {
          const {provider} = props ?? {};

          return  syncExpenditureProvider(provider,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SyncExpenditureProviderMutationResult = NonNullable<Awaited<ReturnType<typeof syncExpenditureProvider>>>
    
    export type SyncExpenditureProviderMutationError = void

    /**
 * @summary Trigger immediate sync for a provider — stores costs with claimId null
 */
export const useSyncExpenditureProvider = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof syncExpenditureProvider>>, TError,{provider: 'aws' | 'gcp' | 'openai' | 'anthropic' | 'replit'}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof syncExpenditureProvider>>,
        TError,
        {provider: 'aws' | 'gcp' | 'openai' | 'anthropic' | 'replit'},
        TContext
      > => {

      const mutationOptions = getSyncExpenditureProviderMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Discover cloud accounts from synced cost data
 */
export const getExpenditureAccounts = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetExpenditureAccounts200>(
      {url: `/api/expenditure/accounts`, method: 'GET', signal
    },
      );
    }
  



export const getGetExpenditureAccountsQueryKey = () => {
    return [
    `/api/expenditure/accounts`
    ] as const;
    }

    
export const getGetExpenditureAccountsQueryOptions = <TData = Awaited<ReturnType<typeof getExpenditureAccounts>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getExpenditureAccounts>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetExpenditureAccountsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getExpenditureAccounts>>> = ({ signal }) => getExpenditureAccounts(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getExpenditureAccounts>>, TError, TData> & { queryKey: QueryKey }
}

export type GetExpenditureAccountsQueryResult = NonNullable<Awaited<ReturnType<typeof getExpenditureAccounts>>>
export type GetExpenditureAccountsQueryError = unknown


/**
 * @summary Discover cloud accounts from synced cost data
 */

export function useGetExpenditureAccounts<TData = Awaited<ReturnType<typeof getExpenditureAccounts>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getExpenditureAccounts>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetExpenditureAccountsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * @summary List account-to-project override mappings
 */
export const getExpenditureOverrides = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetExpenditureOverrides200>(
      {url: `/api/expenditure/overrides`, method: 'GET', signal
    },
      );
    }
  



export const getGetExpenditureOverridesQueryKey = () => {
    return [
    `/api/expenditure/overrides`
    ] as const;
    }

    
export const getGetExpenditureOverridesQueryOptions = <TData = Awaited<ReturnType<typeof getExpenditureOverrides>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getExpenditureOverrides>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetExpenditureOverridesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getExpenditureOverrides>>> = ({ signal }) => getExpenditureOverrides(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getExpenditureOverrides>>, TError, TData> & { queryKey: QueryKey }
}

export type GetExpenditureOverridesQueryResult = NonNullable<Awaited<ReturnType<typeof getExpenditureOverrides>>>
export type GetExpenditureOverridesQueryError = unknown


/**
 * @summary List account-to-project override mappings
 */

export function useGetExpenditureOverrides<TData = Awaited<ReturnType<typeof getExpenditureOverrides>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getExpenditureOverrides>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetExpenditureOverridesQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * @summary Create or update an account-to-project mapping
 */
export const upsertExpenditureOverride = (
    upsertExpenditureOverrideBody: UpsertExpenditureOverrideBody,
 ) => {
      
      
      return customInstance<UpsertExpenditureOverride200>(
      {url: `/api/expenditure/overrides`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: upsertExpenditureOverrideBody
    },
      );
    }
  


export const getUpsertExpenditureOverrideMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof upsertExpenditureOverride>>, TError,{data: UpsertExpenditureOverrideBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof upsertExpenditureOverride>>, TError,{data: UpsertExpenditureOverrideBody}, TContext> => {

const mutationKey = ['upsertExpenditureOverride'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof upsertExpenditureOverride>>, {data: UpsertExpenditureOverrideBody}> = (props) => {
          const {data} = props ?? {};

          return  upsertExpenditureOverride(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpsertExpenditureOverrideMutationResult = NonNullable<Awaited<ReturnType<typeof upsertExpenditureOverride>>>
    export type UpsertExpenditureOverrideMutationBody = UpsertExpenditureOverrideBody
    export type UpsertExpenditureOverrideMutationError = unknown

    /**
 * @summary Create or update an account-to-project mapping
 */
export const useUpsertExpenditureOverride = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof upsertExpenditureOverride>>, TError,{data: UpsertExpenditureOverrideBody}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof upsertExpenditureOverride>>,
        TError,
        {data: UpsertExpenditureOverrideBody},
        TContext
      > => {

      const mutationOptions = getUpsertExpenditureOverrideMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Delete an account-to-project mapping
 */
export const deleteExpenditureOverride = (
    id: string,
 ) => {
      
      
      return customInstance<void>(
      {url: `/api/expenditure/overrides/${id}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteExpenditureOverrideMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteExpenditureOverride>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteExpenditureOverride>>, TError,{id: string}, TContext> => {

const mutationKey = ['deleteExpenditureOverride'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteExpenditureOverride>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteExpenditureOverride(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteExpenditureOverrideMutationResult = NonNullable<Awaited<ReturnType<typeof deleteExpenditureOverride>>>
    
    export type DeleteExpenditureOverrideMutationError = unknown

    /**
 * @summary Delete an account-to-project mapping
 */
export const useDeleteExpenditureOverride = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteExpenditureOverride>>, TError,{id: string}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteExpenditureOverride>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteExpenditureOverrideMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Get the tenant's overhead apportionment setting, resolved against the live payroll reconciliation
 */
export const getOverheadApportionment = (
    params: GetOverheadApportionmentParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetOverheadApportionment200>(
      {url: `/api/expenditure/apportionment`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getGetOverheadApportionmentQueryKey = (params?: GetOverheadApportionmentParams,) => {
    return [
    `/api/expenditure/apportionment`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetOverheadApportionmentQueryOptions = <TData = Awaited<ReturnType<typeof getOverheadApportionment>>, TError = unknown>(params: GetOverheadApportionmentParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getOverheadApportionment>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOverheadApportionmentQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOverheadApportionment>>> = ({ signal }) => getOverheadApportionment(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOverheadApportionment>>, TError, TData> & { queryKey: QueryKey }
}

export type GetOverheadApportionmentQueryResult = NonNullable<Awaited<ReturnType<typeof getOverheadApportionment>>>
export type GetOverheadApportionmentQueryError = unknown


/**
 * @summary Get the tenant's overhead apportionment setting, resolved against the live payroll reconciliation
 */

export function useGetOverheadApportionment<TData = Awaited<ReturnType<typeof getOverheadApportionment>>, TError = unknown>(
 params: GetOverheadApportionmentParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getOverheadApportionment>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetOverheadApportionmentQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * @summary Set the tenant's overhead apportionment mode
 */
export const setOverheadApportionment = (
    setOverheadApportionmentBody: SetOverheadApportionmentBody,
    params: SetOverheadApportionmentParams,
 ) => {
      
      
      return customInstance<SetOverheadApportionment200>(
      {url: `/api/expenditure/apportionment`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: setOverheadApportionmentBody,
        params
    },
      );
    }
  


export const getSetOverheadApportionmentMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setOverheadApportionment>>, TError,{data: SetOverheadApportionmentBody;params: SetOverheadApportionmentParams}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof setOverheadApportionment>>, TError,{data: SetOverheadApportionmentBody;params: SetOverheadApportionmentParams}, TContext> => {

const mutationKey = ['setOverheadApportionment'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setOverheadApportionment>>, {data: SetOverheadApportionmentBody;params: SetOverheadApportionmentParams}> = (props) => {
          const {data,params} = props ?? {};

          return  setOverheadApportionment(data,params,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SetOverheadApportionmentMutationResult = NonNullable<Awaited<ReturnType<typeof setOverheadApportionment>>>
    export type SetOverheadApportionmentMutationBody = SetOverheadApportionmentBody
    export type SetOverheadApportionmentMutationError = void

    /**
 * @summary Set the tenant's overhead apportionment mode
 */
export const useSetOverheadApportionment = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setOverheadApportionment>>, TError,{data: SetOverheadApportionmentBody;params: SetOverheadApportionmentParams}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof setOverheadApportionment>>,
        TError,
        {data: SetOverheadApportionmentBody;params: SetOverheadApportionmentParams},
        TContext
      > => {

      const mutationOptions = getSetOverheadApportionmentMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Xero GL cost-candidate review queue for a financial year
 */
export const getCostCandidates = (
    params: GetCostCandidatesParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetCostCandidates200>(
      {url: `/api/expenditure/candidates`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getGetCostCandidatesQueryKey = (params?: GetCostCandidatesParams,) => {
    return [
    `/api/expenditure/candidates`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetCostCandidatesQueryOptions = <TData = Awaited<ReturnType<typeof getCostCandidates>>, TError = unknown>(params: GetCostCandidatesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCostCandidates>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCostCandidatesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCostCandidates>>> = ({ signal }) => getCostCandidates(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCostCandidates>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCostCandidatesQueryResult = NonNullable<Awaited<ReturnType<typeof getCostCandidates>>>
export type GetCostCandidatesQueryError = unknown


/**
 * @summary Xero GL cost-candidate review queue for a financial year
 */

export function useGetCostCandidates<TData = Awaited<ReturnType<typeof getCostCandidates>>, TError = unknown>(
 params: GetCostCandidatesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCostCandidates>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetCostCandidatesQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * @summary Regenerate the Xero GL cost-candidate queue for a financial year (idempotent; dismissals stick)
 */
export const refreshCostCandidates = (
    refreshCostCandidatesBody: RefreshCostCandidatesBody,
 signal?: AbortSignal
) => {
      
      
      return customInstance<RefreshCostCandidates200>(
      {url: `/api/expenditure/candidates/refresh`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: refreshCostCandidatesBody, signal
    },
      );
    }
  


export const getRefreshCostCandidatesMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof refreshCostCandidates>>, TError,{data: RefreshCostCandidatesBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof refreshCostCandidates>>, TError,{data: RefreshCostCandidatesBody}, TContext> => {

const mutationKey = ['refreshCostCandidates'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof refreshCostCandidates>>, {data: RefreshCostCandidatesBody}> = (props) => {
          const {data} = props ?? {};

          return  refreshCostCandidates(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type RefreshCostCandidatesMutationResult = NonNullable<Awaited<ReturnType<typeof refreshCostCandidates>>>
    export type RefreshCostCandidatesMutationBody = RefreshCostCandidatesBody
    export type RefreshCostCandidatesMutationError = unknown

    /**
 * @summary Regenerate the Xero GL cost-candidate queue for a financial year (idempotent; dismissals stick)
 */
export const useRefreshCostCandidates = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof refreshCostCandidates>>, TError,{data: RefreshCostCandidatesBody}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof refreshCostCandidates>>,
        TError,
        {data: RefreshCostCandidatesBody},
        TContext
      > => {

      const mutationOptions = getRefreshCostCandidatesMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Approve a pending Xero GL cost candidate — creates a cost_allocations row (source api_xero)
 */
export const approveCostCandidate = (
    id: string,
    approveCostCandidateBody?: ApproveCostCandidateBody,
 signal?: AbortSignal
) => {
      
      
      return customInstance<ApproveCostCandidate201>(
      {url: `/api/expenditure/candidates/${id}/approve`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: approveCostCandidateBody, signal
    },
      );
    }
  


export const getApproveCostCandidateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof approveCostCandidate>>, TError,{id: string;data: ApproveCostCandidateBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof approveCostCandidate>>, TError,{id: string;data: ApproveCostCandidateBody}, TContext> => {

const mutationKey = ['approveCostCandidate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof approveCostCandidate>>, {id: string;data: ApproveCostCandidateBody}> = (props) => {
          const {id,data} = props ?? {};

          return  approveCostCandidate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ApproveCostCandidateMutationResult = NonNullable<Awaited<ReturnType<typeof approveCostCandidate>>>
    export type ApproveCostCandidateMutationBody = ApproveCostCandidateBody
    export type ApproveCostCandidateMutationError = void

    /**
 * @summary Approve a pending Xero GL cost candidate — creates a cost_allocations row (source api_xero)
 */
export const useApproveCostCandidate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof approveCostCandidate>>, TError,{id: string;data: ApproveCostCandidateBody}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof approveCostCandidate>>,
        TError,
        {id: string;data: ApproveCostCandidateBody},
        TContext
      > => {

      const mutationOptions = getApproveCostCandidateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Dismiss a pending Xero GL cost candidate (sticks across refreshes)
 */
export const dismissCostCandidate = (
    id: string,
    dismissCostCandidateBody: DismissCostCandidateBody,
 signal?: AbortSignal
) => {
      
      
      return customInstance<DismissCostCandidate200>(
      {url: `/api/expenditure/candidates/${id}/dismiss`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: dismissCostCandidateBody, signal
    },
      );
    }
  


export const getDismissCostCandidateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof dismissCostCandidate>>, TError,{id: string;data: DismissCostCandidateBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof dismissCostCandidate>>, TError,{id: string;data: DismissCostCandidateBody}, TContext> => {

const mutationKey = ['dismissCostCandidate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof dismissCostCandidate>>, {id: string;data: DismissCostCandidateBody}> = (props) => {
          const {id,data} = props ?? {};

          return  dismissCostCandidate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DismissCostCandidateMutationResult = NonNullable<Awaited<ReturnType<typeof dismissCostCandidate>>>
    export type DismissCostCandidateMutationBody = DismissCostCandidateBody
    export type DismissCostCandidateMutationError = void

    /**
 * @summary Dismiss a pending Xero GL cost candidate (sticks across refreshes)
 */
export const useDismissCostCandidate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof dismissCostCandidate>>, TError,{id: string;data: DismissCostCandidateBody}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof dismissCostCandidate>>,
        TError,
        {id: string;data: DismissCostCandidateBody},
        TContext
      > => {

      const mutationOptions = getDismissCostCandidateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Self-scoped developer workload rollup (days to projects, hours, commits, explorations)
 */
export const getMyActivity = (
    params?: GetMyActivityParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetMyActivity200>(
      {url: `/api/developer/my-activity`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getGetMyActivityQueryKey = (params?: GetMyActivityParams,) => {
    return [
    `/api/developer/my-activity`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetMyActivityQueryOptions = <TData = Awaited<ReturnType<typeof getMyActivity>>, TError = unknown>(params?: GetMyActivityParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMyActivity>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMyActivityQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMyActivity>>> = ({ signal }) => getMyActivity(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMyActivity>>, TError, TData> & { queryKey: QueryKey }
}

export type GetMyActivityQueryResult = NonNullable<Awaited<ReturnType<typeof getMyActivity>>>
export type GetMyActivityQueryError = unknown


/**
 * @summary Self-scoped developer workload rollup (days to projects, hours, commits, explorations)
 */

export function useGetMyActivity<TData = Awaited<ReturnType<typeof getMyActivity>>, TError = unknown>(
 params?: GetMyActivityParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMyActivity>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetMyActivityQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * @summary AI-drafted, facts-only weekly recap (cached; regenerated on demand or on evidence change)
 */
export const getWeeklyRecapDraft = (
    params: GetWeeklyRecapDraftParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetWeeklyRecapDraft200>(
      {url: `/api/developer/weekly-recap/draft`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getGetWeeklyRecapDraftQueryKey = (params?: GetWeeklyRecapDraftParams,) => {
    return [
    `/api/developer/weekly-recap/draft`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetWeeklyRecapDraftQueryOptions = <TData = Awaited<ReturnType<typeof getWeeklyRecapDraft>>, TError = unknown>(params: GetWeeklyRecapDraftParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getWeeklyRecapDraft>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetWeeklyRecapDraftQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getWeeklyRecapDraft>>> = ({ signal }) => getWeeklyRecapDraft(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getWeeklyRecapDraft>>, TError, TData> & { queryKey: QueryKey }
}

export type GetWeeklyRecapDraftQueryResult = NonNullable<Awaited<ReturnType<typeof getWeeklyRecapDraft>>>
export type GetWeeklyRecapDraftQueryError = unknown


/**
 * @summary AI-drafted, facts-only weekly recap (cached; regenerated on demand or on evidence change)
 */

export function useGetWeeklyRecapDraft<TData = Awaited<ReturnType<typeof getWeeklyRecapDraft>>, TError = unknown>(
 params: GetWeeklyRecapDraftParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getWeeklyRecapDraft>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetWeeklyRecapDraftQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * @summary The developer's own weekly recap for a given week (empty shell if none)
 */
export const getWeeklyRecap = (
    params: GetWeeklyRecapParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetWeeklyRecap200>(
      {url: `/api/developer/weekly-recap`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getGetWeeklyRecapQueryKey = (params?: GetWeeklyRecapParams,) => {
    return [
    `/api/developer/weekly-recap`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetWeeklyRecapQueryOptions = <TData = Awaited<ReturnType<typeof getWeeklyRecap>>, TError = unknown>(params: GetWeeklyRecapParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getWeeklyRecap>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetWeeklyRecapQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getWeeklyRecap>>> = ({ signal }) => getWeeklyRecap(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getWeeklyRecap>>, TError, TData> & { queryKey: QueryKey }
}

export type GetWeeklyRecapQueryResult = NonNullable<Awaited<ReturnType<typeof getWeeklyRecap>>>
export type GetWeeklyRecapQueryError = unknown


/**
 * @summary The developer's own weekly recap for a given week (empty shell if none)
 */

export function useGetWeeklyRecap<TData = Awaited<ReturnType<typeof getWeeklyRecap>>, TError = unknown>(
 params: GetWeeklyRecapParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getWeeklyRecap>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetWeeklyRecapQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * @summary Upsert the developer's own weekly recap (userId/tenantId always from the session)
 */
export const putWeeklyRecap = (
    putWeeklyRecapBody: PutWeeklyRecapBody,
 ) => {
      
      
      return customInstance<PutWeeklyRecap200>(
      {url: `/api/developer/weekly-recap`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: putWeeklyRecapBody
    },
      );
    }
  


export const getPutWeeklyRecapMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putWeeklyRecap>>, TError,{data: PutWeeklyRecapBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putWeeklyRecap>>, TError,{data: PutWeeklyRecapBody}, TContext> => {

const mutationKey = ['putWeeklyRecap'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putWeeklyRecap>>, {data: PutWeeklyRecapBody}> = (props) => {
          const {data} = props ?? {};

          return  putWeeklyRecap(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutWeeklyRecapMutationResult = NonNullable<Awaited<ReturnType<typeof putWeeklyRecap>>>
    export type PutWeeklyRecapMutationBody = PutWeeklyRecapBody
    export type PutWeeklyRecapMutationError = unknown

    /**
 * @summary Upsert the developer's own weekly recap (userId/tenantId always from the session)
 */
export const usePutWeeklyRecap = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putWeeklyRecap>>, TError,{data: PutWeeklyRecapBody}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof putWeeklyRecap>>,
        TError,
        {data: PutWeeklyRecapBody},
        TContext
      > => {

      const mutationOptions = getPutWeeklyRecapMutationOptions(options);

      return useMutation(mutationOptions);
    }
